var ReactResizeDetector = require('react-resize-detector');
var lodash = require('lodash');
var TWEEN = require('@tweenjs/tween.js');
var uuid = require('uuid');
var THREE = require('three');
var OrbitControls = require('three/examples/jsm/controls/OrbitControls');
var popmotion = require('popmotion');
var OBJLoader = require('three/examples/jsm/loaders/OBJLoader');
var HDRCubeTextureLoader_js = require('three/examples/jsm/loaders/HDRCubeTextureLoader.js');
var EXRLoader_js = require('three/examples/jsm/loaders/EXRLoader.js');
var FBXLoader = require('three/examples/jsm/loaders/FBXLoader');
var GLTFLoader = require('three/examples/jsm/loaders/GLTFLoader');
var DRACOLoader = require('three/examples/jsm/loaders/DRACOLoader');
var KTX2Loader = require('three/examples/jsm/loaders/KTX2Loader');
var meshopt_decoder_module_js = require('three/examples/jsm/libs/meshopt_decoder.module.js');
var axios = require('axios');
var JSON5 = require('json5');
var RGBELoader = require('three/examples/jsm/loaders/RGBELoader');
var Nexus3D = require('nexus3d/src/Nexus3D');
var Stats = require('stats-js');
var OutlinePass = require('three/examples/jsm/postprocessing/OutlinePass');
var EffectComposer = require('three/examples/jsm/postprocessing/EffectComposer');
var RenderPass = require('three/examples/jsm/postprocessing/RenderPass');
var SAOPass = require('three/examples/jsm/postprocessing/SAOPass');
var GlitchPass = require('three/examples/jsm/postprocessing/GlitchPass');
var FilmShader_js = require('three/examples/jsm/shaders/FilmShader.js');
var SepiaShader_js = require('three/examples/jsm/shaders/SepiaShader.js');
var HueSaturationShader_js = require('three/examples/jsm/shaders/HueSaturationShader.js');
var BrightnessContrastShader_js = require('three/examples/jsm/shaders/BrightnessContrastShader.js');
var VignetteShader_js = require('three/examples/jsm/shaders/VignetteShader.js');
var SSAARenderPass = require('three/examples/jsm/postprocessing/SSAARenderPass');
var ShaderPass = require('three/examples/jsm/postprocessing/ShaderPass');
var CopyShader = require('three/examples/jsm/shaders/CopyShader');
var LineMaterial_js = require('three/examples/jsm/lines/LineMaterial.js');
var LineGeometry_js = require('three/examples/jsm/lines/LineGeometry.js');
var Line2_js = require('three/examples/jsm/lines/Line2.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return n;
}

var ReactResizeDetector__default = /*#__PURE__*/_interopDefaultLegacy(ReactResizeDetector);
var TWEEN__default = /*#__PURE__*/_interopDefaultLegacy(TWEEN);
var THREE__namespace = /*#__PURE__*/_interopNamespace(THREE);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var JSON5__namespace = /*#__PURE__*/_interopNamespace(JSON5);
var Nexus3D__default = /*#__PURE__*/_interopDefaultLegacy(Nexus3D);
var Stats__default = /*#__PURE__*/_interopDefaultLegacy(Stats);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return !1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D;}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState");};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate");};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D;}var I=H.prototype=new G;I.constructor=H;objectAssign(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h;}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return {$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return {$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return "object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return "$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return {result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a);}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0;}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e);}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return "object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++);}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a));}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b);}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:objectAssign};var Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b);},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
var Component=F;var Fragment=r;var Profiler=u;var PureComponent=H;var StrictMode=t;var Suspense=y;var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
var cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=objectAssign({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h]);}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f;}return {$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};var createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};var createElement=M;var createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};var createRef=function(){return {current:null}};var forwardRef=function(a){return {$$typeof:x,render:a}};var isValidElement=O;
var lazy=function(a){return {$$typeof:A,_ctor:a,_status:-1,_result:null}};var memo=function(a,b){return {$$typeof:z,type:a,compare:void 0===b?null:b}};var useCallback=function(a,b){return Z().useCallback(a,b)};var useContext=function(a,b){return Z().useContext(a,b)};var useDebugValue=function(){};var useEffect=function(a,b){return Z().useEffect(a,b)};var useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
var useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};var useMemo=function(a,b){return Z().useMemo(a,b)};var useReducer=function(a,b,c){return Z().useReducer(a,b,c)};var useRef=function(a){return Z().useRef(a)};var useState=function(a){return Z().useState(a)};var version="16.14.0";

var react_production_min = {
	Children: Children,
	Component: Component,
	Fragment: Fragment,
	Profiler: Profiler,
	PureComponent: PureComponent,
	StrictMode: StrictMode,
	Suspense: Suspense,
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
	cloneElement: cloneElement,
	createContext: createContext,
	createElement: createElement,
	createFactory: createFactory,
	createRef: createRef,
	forwardRef: forwardRef,
	isValidElement: isValidElement,
	lazy: lazy,
	memo: memo,
	useCallback: useCallback,
	useContext: useContext,
	useDebugValue: useDebugValue,
	useEffect: useEffect,
	useImperativeHandle: useImperativeHandle,
	useLayoutEffect: useLayoutEffect,
	useMemo: useMemo,
	useReducer: useReducer,
	useRef: useRef,
	useState: useState,
	version: version
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var require$$0 = ReactPropTypesSecret_1;

var require$$1$1 = has$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = require$$0;
  var loggedTypeFailures = {};
  var has = require$$1$1;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var require$$1 = checkPropTypes_1;

/** @license React v16.14.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var react_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

var _assign = objectAssign;
var checkPropTypes = require$$1;

var ReactVersion = '16.14.0';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

/**
 * Keeps track of the current dispatcher.
 */
var ReactCurrentDispatcher = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

/**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */
var ReactCurrentBatchConfig = {
  suspense: null
};

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
function describeComponentFrame (name, source, ownerName) {
  var sourceInfo = '';

  if (source) {
    var path = source.fileName;
    var fileName = path.replace(BEFORE_SLASH_RE, '');

    {
      // In DEV, include code for a common special case:
      // prefer "folder/index.js" instead of just "index.js".
      if (/^index\./.test(fileName)) {
        var match = path.match(BEFORE_SLASH_RE);

        if (match) {
          var pathBeforeSlash = match[1];

          if (pathBeforeSlash) {
            var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
            fileName = folderName + '/' + fileName;
          }
        }
      }
    }

    sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
  } else if (ownerName) {
    sourceInfo = ' (created by ' + ownerName + ')';
  }

  return '\n    in ' + (name || 'Unknown') + sourceInfo;
}

var Resolved = 1;
function refineResolvedLazyComponent(lazyComponent) {
  return lazyComponent._status === Resolved ? lazyComponent._result : null;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return "Profiler";

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        return 'Context.Consumer';

      case REACT_PROVIDER_TYPE:
        return 'Context.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type.render);

      case REACT_LAZY_TYPE:
        {
          var thenable = type;
          var resolvedThenable = refineResolvedLazyComponent(thenable);

          if (resolvedThenable) {
            return getComponentName(resolvedThenable);
          }

          break;
        }
    }
  }

  return null;
}

var ReactDebugCurrentFrame = {};
var currentlyValidatingElement = null;
function setCurrentlyValidatingElement(element) {
  {
    currentlyValidatingElement = element;
  }
}

{
  // Stack implementation injected by the current renderer.
  ReactDebugCurrentFrame.getCurrentStack = null;

  ReactDebugCurrentFrame.getStackAddendum = function () {
    var stack = ''; // Add an extra top frame while an element is being validated

    if (currentlyValidatingElement) {
      var name = getComponentName(currentlyValidatingElement.type);
      var owner = currentlyValidatingElement._owner;
      stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
    } // Delegate to the injected renderer-specific implementation


    var impl = ReactDebugCurrentFrame.getCurrentStack;

    if (impl) {
      stack += impl() || '';
    }

    return stack;
  };
}

/**
 * Used by act() to track whether you're inside an act() scope.
 */
var IsSomeRendererActing = {
  current: false
};

var ReactSharedInternals = {
  ReactCurrentDispatcher: ReactCurrentDispatcher,
  ReactCurrentBatchConfig: ReactCurrentBatchConfig,
  ReactCurrentOwner: ReactCurrentOwner,
  IsSomeRendererActing: IsSomeRendererActing,
  // Used by renderers to avoid bundling object-assign twice in UMD bundles:
  assign: _assign
};

{
  _assign(ReactSharedInternals, {
    // These should not be included in production.
    ReactDebugCurrentFrame: ReactDebugCurrentFrame,
    // Shim for React DOM 16.0.0 which still destructured (but not used) this.
    // TODO: remove in React 17.0.
    ReactComponentTreeHook: {}
  });
}

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;

    if (!hasExistingStack) {
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      var stack = ReactDebugCurrentFrame.getStackAddendum();

      if (stack !== '') {
        format += '%s';
        args = args.concat([stack]);
      }
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      throw new Error(message);
    } catch (x) {}
  }
}

var didWarnStateUpdateForUnmountedComponent = {};

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
    var warningKey = componentName + "." + callerName;

    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
      return;
    }

    error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);

    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
  }
}
/**
 * This is the abstract API for an update queue.
 */


var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance, callback, callerName) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
    warnNoop(publicInstance, 'setState');
  }
};

var emptyObject = {};

{
  Object.freeze(emptyObject);
}
/**
 * Base class helpers for the updating state of a component.
 */


function Component(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
  // renderer.

  this.updater = updater || ReactNoopUpdateQueue;
}

Component.prototype.isReactComponent = {};
/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */

Component.prototype.setState = function (partialState, callback) {
  if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
    {
      throw Error( "setState(...): takes an object of state variables to update or a function which returns an object of state variables." );
    }
  }

  this.updater.enqueueSetState(this, partialState, callback, 'setState');
};
/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */


Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
};
/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */


{
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };

  var defineDeprecationWarning = function (methodName, info) {
    Object.defineProperty(Component.prototype, methodName, {
      get: function () {
        warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);

        return undefined;
      }
    });
  };

  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

function ComponentDummy() {}

ComponentDummy.prototype = Component.prototype;
/**
 * Convenience component with default shallow equality check for sCU.
 */

function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}

var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

_assign(pureComponentPrototype, Component.prototype);

pureComponentPrototype.isPureReactComponent = true;

// an immutable object with a single mutable value
function createRef() {
  var refObject = {
    current: null
  };

  {
    Object.seal(refObject);
  }

  return refObject;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
      }
    }
  };

  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
      }
    }
  };

  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

function warnIfStringRefCannotBeAutoConverted(config) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */

function createElement(type, config, children) {
  var propName; // Reserved names are extracted

  var props = {};
  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;

      {
        warnIfStringRefCannotBeAutoConverted(config);
      }
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }

    props.children = childArray;
  } // Resolve default props


  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;

    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }

  {
    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
}
function cloneAndReplaceKey(oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
  return newElement;
}
/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */

function cloneElement(element, config, children) {
  if (!!(element === null || element === undefined)) {
    {
      throw Error( "React.cloneElement(...): The argument must be a React element, but you passed " + element + "." );
    }
  }

  var propName; // Original props are copied

  var props = _assign({}, element.props); // Reserved names are extracted


  var key = element.key;
  var ref = element.ref; // Self is preserved since the owner is preserved.

  var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.

  var source = element._source; // Owner will be preserved, unless ref is overridden

  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    } // Remaining properties override existing props


    var defaultProps;

    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}

var SEPARATOR = '.';
var SUBSEPARATOR = ':';
/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });
  return '$' + escapedString;
}
/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */


var didWarnAboutMaps = false;
var userProvidedKeyEscapeRegex = /\/+/g;

function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

var POOL_SIZE = 10;
var traverseContextPool = [];

function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
  if (traverseContextPool.length) {
    var traverseContext = traverseContextPool.pop();
    traverseContext.result = mapResult;
    traverseContext.keyPrefix = keyPrefix;
    traverseContext.func = mapFunction;
    traverseContext.context = mapContext;
    traverseContext.count = 0;
    return traverseContext;
  } else {
    return {
      result: mapResult,
      keyPrefix: keyPrefix,
      func: mapFunction,
      context: mapContext,
      count: 0
    };
  }
}

function releaseTraverseContext(traverseContext) {
  traverseContext.result = null;
  traverseContext.keyPrefix = null;
  traverseContext.func = null;
  traverseContext.context = null;
  traverseContext.count = 0;

  if (traverseContextPool.length < POOL_SIZE) {
    traverseContextPool.push(traverseContext);
  }
}
/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */


function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  var invokeCallback = false;

  if (children === null) {
    invokeCallback = true;
  } else {
    switch (type) {
      case 'string':
      case 'number':
        invokeCallback = true;
        break;

      case 'object':
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            invokeCallback = true;
        }

    }
  }

  if (invokeCallback) {
    callback(traverseContext, children, // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.

  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);

    if (typeof iteratorFn === 'function') {

      {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          if (!didWarnAboutMaps) {
            warn('Using Maps as children is deprecated and will be removed in ' + 'a future major release. Consider converting children to ' + 'an array of keyed ReactElements instead.');
          }

          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step;
      var ii = 0;

      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
      }
    } else if (type === 'object') {
      var addendum = '';

      {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + ReactDebugCurrentFrame.getStackAddendum();
      }

      var childrenString = '' + children;

      {
        {
          throw Error( "Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + ")." + addendum );
        }
      }
    }
  }

  return subtreeCount;
}
/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */


function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}
/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */


function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (typeof component === 'object' && component !== null && component.key != null) {
    // Explicit key
    return escape(component.key);
  } // Implicit key determined by the index in the set


  return index.toString(36);
}

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;
  func.call(context, child, bookKeeping.count++);
}
/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */


function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }

  var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  releaseTraverseContext(traverseContext);
}

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;
  var mappedChild = func.call(context, child, bookKeeping.count++);

  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, function (c) {
      return c;
    });
  } else if (mappedChild != null) {
    if (isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }

    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';

  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }

  var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  releaseTraverseContext(traverseContext);
}
/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */


function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }

  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}
/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */


function countChildren(children) {
  return traverseAllChildren(children, function () {
    return null;
  }, null);
}
/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */


function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, function (child) {
    return child;
  });
  return result;
}
/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */


function onlyChild(children) {
  if (!isValidElement(children)) {
    {
      throw Error( "React.Children.only expected to receive a single React element child." );
    }
  }

  return children;
}

function createContext(defaultValue, calculateChangedBits) {
  if (calculateChangedBits === undefined) {
    calculateChangedBits = null;
  } else {
    {
      if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
        error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
      }
    }
  }

  var context = {
    $$typeof: REACT_CONTEXT_TYPE,
    _calculateChangedBits: calculateChangedBits,
    // As a workaround to support multiple concurrent renderers, we categorize
    // some renderers as primary and others as secondary. We only expect
    // there to be two concurrent renderers at most: React Native (primary) and
    // Fabric (secondary); React DOM (primary) and React ART (secondary).
    // Secondary renderers store their context values on separate fields.
    _currentValue: defaultValue,
    _currentValue2: defaultValue,
    // Used to track how many concurrent renderers this context currently
    // supports within in a single renderer. Such as parallel server rendering.
    _threadCount: 0,
    // These are circular
    Provider: null,
    Consumer: null
  };
  context.Provider = {
    $$typeof: REACT_PROVIDER_TYPE,
    _context: context
  };
  var hasWarnedAboutUsingNestedContextConsumers = false;
  var hasWarnedAboutUsingConsumerProvider = false;

  {
    // A separate object, but proxies back to the original context object for
    // backwards compatibility. It has a different $$typeof, so we can properly
    // warn for the incorrect usage of Context as a Consumer.
    var Consumer = {
      $$typeof: REACT_CONTEXT_TYPE,
      _context: context,
      _calculateChangedBits: context._calculateChangedBits
    }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

    Object.defineProperties(Consumer, {
      Provider: {
        get: function () {
          if (!hasWarnedAboutUsingConsumerProvider) {
            hasWarnedAboutUsingConsumerProvider = true;

            error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
          }

          return context.Provider;
        },
        set: function (_Provider) {
          context.Provider = _Provider;
        }
      },
      _currentValue: {
        get: function () {
          return context._currentValue;
        },
        set: function (_currentValue) {
          context._currentValue = _currentValue;
        }
      },
      _currentValue2: {
        get: function () {
          return context._currentValue2;
        },
        set: function (_currentValue2) {
          context._currentValue2 = _currentValue2;
        }
      },
      _threadCount: {
        get: function () {
          return context._threadCount;
        },
        set: function (_threadCount) {
          context._threadCount = _threadCount;
        }
      },
      Consumer: {
        get: function () {
          if (!hasWarnedAboutUsingNestedContextConsumers) {
            hasWarnedAboutUsingNestedContextConsumers = true;

            error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
          }

          return context.Consumer;
        }
      }
    }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

    context.Consumer = Consumer;
  }

  {
    context._currentRenderer = null;
    context._currentRenderer2 = null;
  }

  return context;
}

function lazy(ctor) {
  var lazyType = {
    $$typeof: REACT_LAZY_TYPE,
    _ctor: ctor,
    // React uses these fields to store the result.
    _status: -1,
    _result: null
  };

  {
    // In production, this would just set it on the object.
    var defaultProps;
    var propTypes;
    Object.defineProperties(lazyType, {
      defaultProps: {
        configurable: true,
        get: function () {
          return defaultProps;
        },
        set: function (newDefaultProps) {
          error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          defaultProps = newDefaultProps; // Match production behavior more closely:

          Object.defineProperty(lazyType, 'defaultProps', {
            enumerable: true
          });
        }
      },
      propTypes: {
        configurable: true,
        get: function () {
          return propTypes;
        },
        set: function (newPropTypes) {
          error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          propTypes = newPropTypes; // Match production behavior more closely:

          Object.defineProperty(lazyType, 'propTypes', {
            enumerable: true
          });
        }
      }
    });
  }

  return lazyType;
}

function forwardRef(render) {
  {
    if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
      error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
    } else if (typeof render !== 'function') {
      error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
    } else {
      if (render.length !== 0 && render.length !== 2) {
        error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
      }
    }

    if (render != null) {
      if (render.defaultProps != null || render.propTypes != null) {
        error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
      }
    }
  }

  return {
    $$typeof: REACT_FORWARD_REF_TYPE,
    render: render
  };
}

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function memo(type, compare) {
  {
    if (!isValidElementType(type)) {
      error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
    }
  }

  return {
    $$typeof: REACT_MEMO_TYPE,
    type: type,
    compare: compare === undefined ? null : compare
  };
}

function resolveDispatcher() {
  var dispatcher = ReactCurrentDispatcher.current;

  if (!(dispatcher !== null)) {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }

  return dispatcher;
}

function useContext(Context, unstable_observedBits) {
  var dispatcher = resolveDispatcher();

  {
    if (unstable_observedBits !== undefined) {
      error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://fb.me/rules-of-hooks' : '');
    } // TODO: add a more generic warning for invalid values.


    if (Context._context !== undefined) {
      var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
      // and nobody should be using this in existing code.

      if (realContext.Consumer === Context) {
        error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
      } else if (realContext.Provider === Context) {
        error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
      }
    }
  }

  return dispatcher.useContext(Context, unstable_observedBits);
}
function useState(initialState) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useState(initialState);
}
function useReducer(reducer, initialArg, init) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useReducer(reducer, initialArg, init);
}
function useRef(initialValue) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useRef(initialValue);
}
function useEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useEffect(create, deps);
}
function useLayoutEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useLayoutEffect(create, deps);
}
function useCallback(callback, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useCallback(callback, deps);
}
function useMemo(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useMemo(create, deps);
}
function useImperativeHandle(ref, create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useImperativeHandle(ref, create, deps);
}
function useDebugValue(value, formatterFn) {
  {
    var dispatcher = resolveDispatcher();
    return dispatcher.useDebugValue(value, formatterFn);
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = getComponentName(ReactCurrentOwner.current.type);

    if (name) {
      return '\n\nCheck the render method of `' + name + '`.';
    }
  }

  return '';
}

function getSourceInfoErrorAddendum(source) {
  if (source !== undefined) {
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
  }

  return '';
}

function getSourceInfoErrorAddendumForProps(elementProps) {
  if (elementProps !== null && elementProps !== undefined) {
    return getSourceInfoErrorAddendum(elementProps.__source);
  }

  return '';
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

    if (parentName) {
      info = "\n\nCheck the top-level render call using <" + parentName + ">.";
    }
  }

  return info;
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }

  element._store.validated = true;
  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
    return;
  }

  ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.

  var childOwner = '';

  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
  }

  setCurrentlyValidatingElement(element);

  {
    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.', currentComponentErrorInfo, childOwner);
  }

  setCurrentlyValidatingElement(null);
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }

  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];

      if (isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);

    if (typeof iteratorFn === 'function') {
      // Entry iterators used to provide implicit keys,
      // but now we print a separate warning for them later.
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;

        while (!(step = iterator.next()).done) {
          if (isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var name = getComponentName(type);
    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      setCurrentlyValidatingElement(element);
      checkPropTypes(propTypes, element.props, 'prop', name, ReactDebugCurrentFrame.getStackAddendum);
      setCurrentlyValidatingElement(null);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true;

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    setCurrentlyValidatingElement(fragment);
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        break;
      }
    }

    if (fragment.ref !== null) {
      error('Invalid attribute `ref` supplied to `React.Fragment`.');
    }

    setCurrentlyValidatingElement(null);
  }
}
function createElementWithValidation(type, props, children) {
  var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
  // succeed and there will likely be errors in render.

  if (!validType) {
    var info = '';

    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
    }

    var sourceInfo = getSourceInfoErrorAddendumForProps(props);

    if (sourceInfo) {
      info += sourceInfo;
    } else {
      info += getDeclarationErrorAddendum();
    }

    var typeString;

    if (type === null) {
      typeString = 'null';
    } else if (Array.isArray(type)) {
      typeString = 'array';
    } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
      typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
      info = ' Did you accidentally export a JSX literal instead of a component?';
    } else {
      typeString = typeof type;
    }

    {
      error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }
  }

  var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
  // TODO: Drop this when these are no longer allowed as the type argument.

  if (element == null) {
    return element;
  } // Skip key warning if the type isn't valid since our key validation logic
  // doesn't expect a non-string/function type and can throw confusing errors.
  // We don't want exception behavior to differ between dev and prod.
  // (Rendering will throw with a helpful message and as soon as the type is
  // fixed, the key warnings will appear.)


  if (validType) {
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], type);
    }
  }

  if (type === REACT_FRAGMENT_TYPE) {
    validateFragmentProps(element);
  } else {
    validatePropTypes(element);
  }

  return element;
}
var didWarnAboutDeprecatedCreateFactory = false;
function createFactoryWithValidation(type) {
  var validatedFactory = createElementWithValidation.bind(null, type);
  validatedFactory.type = type;

  {
    if (!didWarnAboutDeprecatedCreateFactory) {
      didWarnAboutDeprecatedCreateFactory = true;

      warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
    } // Legacy hook: remove it


    Object.defineProperty(validatedFactory, 'type', {
      enumerable: false,
      get: function () {
        warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');

        Object.defineProperty(this, 'type', {
          value: type
        });
        return type;
      }
    });
  }

  return validatedFactory;
}
function cloneElementWithValidation(element, props, children) {
  var newElement = cloneElement.apply(this, arguments);

  for (var i = 2; i < arguments.length; i++) {
    validateChildKeys(arguments[i], newElement.type);
  }

  validatePropTypes(newElement);
  return newElement;
}

{

  try {
    var frozenObject = Object.freeze({});
    var testMap = new Map([[frozenObject, null]]);
    var testSet = new Set([frozenObject]); // This is necessary for Rollup to not consider these unused.
    // https://github.com/rollup/rollup/issues/1771
    // TODO: we can remove these if Rollup fixes the bug.

    testMap.set(0, 0);
    testSet.add(0);
  } catch (e) {
  }
}

var createElement$1 =  createElementWithValidation ;
var cloneElement$1 =  cloneElementWithValidation ;
var createFactory =  createFactoryWithValidation ;
var Children = {
  map: mapChildren,
  forEach: forEachChildren,
  count: countChildren,
  toArray: toArray,
  only: onlyChild
};

exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
exports.cloneElement = cloneElement$1;
exports.createContext = createContext;
exports.createElement = createElement$1;
exports.createFactory = createFactory;
exports.createRef = createRef;
exports.forwardRef = forwardRef;
exports.isValidElement = isValidElement;
exports.lazy = lazy;
exports.memo = memo;
exports.useCallback = useCallback;
exports.useContext = useContext;
exports.useDebugValue = useDebugValue;
exports.useEffect = useEffect;
exports.useImperativeHandle = useImperativeHandle;
exports.useLayoutEffect = useLayoutEffect;
exports.useMemo = useMemo;
exports.useReducer = useReducer;
exports.useRef = useRef;
exports.useState = useState;
exports.version = ReactVersion;
  })();
}
});

var react = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = react_production_min;
} else {
  module.exports = react_development;
}
});

/* eslint-disable */
var Viewer3DDefaults = {
  // #region datasource
  dataSource: {
    //type of datasource. Natively, this is the only one available
    type: 'SceneDataSource',
    //the url to the base folder
    url: null,
    //path to the json, relative to the base folder
    path: 'data.json',
    //path to the endpoint, relative to the base folder,
    //that provides the sizes of the files, in case the server is unable to
    //(for instance, if gzip/chunk-based compression is enabled)
    //it should return a json with key-value pairs where the keys are the file paths
    //(again, relative to the base folder) and the values are the sizes of the files,
    //in bytes.
    //if left null or empty, no attempt to fetch such a list will be done
    sizes: '',
    //the id of the first node to load. In the pbs example, it could be "356", "357"...
    initialNodeId: null,
    //indicates if every node loading should be cached
    //this will reduce loading times for a node visited a second time, at an expense of memory
    useCaching: false,
    //if true, all the node resources be loaded at start
    //This can be used together with the useCaching flag to achieve a smooth transition between scenes.
    preFetch: false,
    //path to the draco loader, required for glb file loading with mesh compression
    dracoLoaderPath: './assets/draco/',
    //callback event for when the datasource finishes loading
    onDataSourceLoad: function onDataSourceLoad(api) {}
  },
  // #endregion datasource
  // #region scenes
  scenes: {
    //limit of scene references stored in the scene history,
    //used by the loadPreviousScene()
    historySize: 50,
    //Callback event for when the scenes are being loaded/finished
    onSceneLoading: function onSceneLoading(api, scene) {},
    onSceneReady: function onSceneReady(api, scene) {}
  },
  // #endregion scenes
  // #region nodes
  nodes: {
    //indicates if double-clicking a pickingbox/
    //marker will load the linked scene, i.e. load the
    //scene that the node refers to
    doubleClickToLoad: true,
    //indicates if more than one node can be
    //selected at once using the Shift key
    allowMultiSelect: true,
    //color and opacity applied to the meshes for the
    //isolation feature
    isolationColor: 'rgba(255,255,255,0.2)',
    //indicates if default association of nodes to
    //meshes based on their naming should occur.
    //Otherwise, it will only use the "targetModels"
    //field in the data source
    useDefaultIsolation: true,
    //indicates if the selection of a node with the
    //mouse/touch will trigger the isolation effect.
    //if false, it can only be triggered via API functions.
    selectToIsolate: true,
    //indicates if a mouse click/touch on an empty area
    //(having no selectable items) should trigger deselection
    //of nodes
    clickOnVoidToDeselect: true,
    //interval between a sequence of taps (on touch screens) for it to
    //consider a double tap (same effect as double-clicking with the mouse)
    doubleTapInterval: 400,
    //duration of a touch press for it to be considered a long press
    longPressInterval: 1000,
    //Callback event for when the nodes are selected, deselected,
    //hovered, unhovered, double-clicked or if being loaded/finished
    //loading (onready).
    //The affected node is passed, along with the origin, which can be
    //'ui' or 'user', depending if the event happened as part of an
    //api call or from a user interaction (through mouse/touch).
    onNodeSelect: function onNodeSelect(api, targetNode, origin, selectedNodeList) {},
    onNodeDeselect: function onNodeDeselect(api, targetNode, origin, selectedNodeList) {},
    onNodeHover: function onNodeHover(api, targetNode) {},
    onNodeUnhover: function onNodeUnhover(api, targetNode) {},
    //when a node is double-clicked or double tapped
    onNodeDoubleClick: function onNodeDoubleClick(api, targetNode) {},
    //when a node is right-clicked or long-pressed
    onNodeLongOrRightClick: function onNodeLongOrRightClick(api, targetNode) {}
  },
  // #endregion nodes
  // #region nodeTypes
  nodeTypes: {
    //properties of the PickingBox object
    PickingBox: {
      //fill colors when the PickingBox is in the disabled, hovered, selected or normal state.
      //There is a priority of color application: selected => hovered => disabled => normal.
      //This means that, for instance, if an object is hovered and selected at the same time,
      //the selected color will prevail. A color can be set to null, though, meaning
      //that it won’t take part in the chain.
      //The color is defined as a string, as in a css definition, stating the rgba color components.
      disabledFillColor: 'rgba(0,0,0,0.3)',
      normalFillColor: 'rgba(0,0,0,0)',
      hoveredFillColor: 'rgba(126,0,128,0.5)',
      selectedFillColor: 'rgba(255,200,0,0.5)',
      //border colors follow the same logic as explained for the fill colors
      disabledBorderColor: null,
      normalBorderColor: null,
      hoveredBorderColor: 'rgba(0,0,255,1)',
      selectedBorderColor: 'rgba(0,255,0,1)',
      //indicates if the original diffuse texture of the picking boxes should disabled
      //when the pickingbox is hovered or selected
      disableTextures: true,
      //To improve visibility of the contents behind the PickingBoxes, these support progressive
      //transparency, meaning that the fill color will become less opaque when the camera is closer
      //to the object.
      //This controls the opacity at close range. Setting it to 1 will disable the progressive transparency.
      nearAlpha: 0.05,
      //'nearDistance' indicate at what distance the ‘nearAlpha’ value will be used
      // and 'farDistance' indicates at what distance the default color alpha
      //(as indicated in the disabled-, normal-, hovered- and selectedFillColor fields) will be used.
      nearDistance: 500,
      farDistance: 2000,
      //duration (in milliseconds) of the color transitions/animations
      duration: 200
    },
    Marker: {
      //fill colors when the Marker is in the disabled, hovered, selected or normal state.
      //see the PickingBox's fillColor options for more information on the priority chain
      //The color is defined as a string, as in a css definition, stating the rgba color components.
      disabledColor: 'rgba(255,255,255,0.3)',
      normalColor: 'rgba(255,255,255,1)',
      hoveredColor: 'rgba(0,0,255,0.3)',
      selectedColor: 'rgba(255,0,0,0.3)',
      //duration (in milliseconds) of the color transitions/animations
      duration: 200
    }
  },
  // #endregion nodeTypes
  // #region style
  //style attributes of the div that encloses the webgl canvas
  //it supports many other attributes, namely all kinds of css attributes
  //but their naming should be adjusted to the react standards
  style: {
    backgroundImage: '',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    width: '100%',
    height: 'auto'
  },
  // #endregion style
  // #region renderer
  renderer: {
    //width of the control, in pixels
    //default is null, so that it adjusts to the containing div
    width: null,
    //height of the control, in pixels
    //default is null, so that it uses the ratio for calculation
    height: null,
    //when the above are not defined, it is used to set a constant
    //view ratio, so width divided by height.
    ratio: 2.2,
    //indicates if double-side rendering should be enabled for all loaded models
    enableDoubleSide: false,
    //indicates if wireframe rendering should be enabled for all loaded models
    enableWireframe: false,
    //color of the line of the wireframe.
    wireframeColor: 'rgba(255,255,255,1)',
    //indicates if anti-aliasing should be enabled
    antialias: true,
    //if enabled, a diagnostics window will appear on the top-right
    //corner of the viewer, indicating the framerate
    showStats: false,
    //if enabled, the default progressbar will be shown during loading
    //activities
    showProgress: true,
    //color of the default progressbar text and border
    progressColor: 'rgba(255,255,255,1)',
    //Callback events for loading/processing moments that
    //can be used to showing/hiding a progress bar. The passed value can be:
    //- a value between 0 and 1 (representing 0-100% progress)
    //- undefined, if no possible progress can be determined
    //- Infinity, if the progress is uncertain, for some reasons
    onProgress: function onProgress(value) {},
    onProgressFinished: function onProgressFinished() {},
    //if enabled, 3 colored arrows will be drawn at the position (0,0,0),
    //Red for X axis, green for the Y axis, blue for the Z axis.
    axesHelper: false,
    //supersampling samples, more reduces anti-aliasing, but at higher
    //rendering cost. 0 disables supersampling.
    ssaaSamples: 4,
    //the intensity of the outline effect on the picking boxes
    borderStrength: 3.0,
    //amount of glow of the outline effect on the picking boxes
    borderGlow: 0.0,
    //the thickness of the outline borders on the picking boxes
    borderThickness: 1.0,
    //the period of the "pulsating" effect of the outline on the picking boxes.
    //0 means no pulsation.
    borderPulsePeriod: 0,
    //indicates if the clipping plane (used for cutting effects) is enabled
    clipPlaneEnabled: false,
    //distance from the origin of the clipping plane
    clipPlaneOffset: 0,
    //normal vector of the clipping plane, i.e. the direction that the plane is facing
    //expects an object with x,y,z components OR any of the following preset strings:
    //'X Up', 'X Down', 'Y Up', 'Y Down', 'Z Up', 'Z Down'
    clipPlaneNormal: {
      x: 0,
      y: 0,
      z: 1
    },
    //the color of the clipping cap. If set to null
    //no cap will be applied.
    clipSectionColor: 'rgb(255,255,255)',
    //percentage at which texture maps are changed in skin transitions
    //since texture maps can't be interpolated, the switch has to occur at some point in the animation
    //this value, between 0 and 1, indicates the moment in the animation
    //where this instant transition will take place.
    skinMapTransition: 0.5,
    //Determines if the control is enabled. If disabled, the control will maintain its state
    //but not run its update or render functions, resulting in less overhead. Useful to keep
    //the viewer running in the background.
    enabled: true,
    //Controls the Screen-Space Ambient Occlusion effect
    //the actual effect of each parameter is hard to describe
    //so we should play around with them until the desired outcome
    //is achieved.
    ssao: {
      enabled: false,
      intensity: 0.18,
      scale: 0.8,
      kernelRadius: 100,
      minResolution: 0,
      blurRadius: 8
    },
    //Controls the hue image effect.
    //Value can change between -1 and 1. 0 means means no hue change.
    hue: 0,
    //Controls the saturation image effect.
    //Value can change between -1 and 1. 0 means means no saturation change.
    saturation: 0,
    //Controls the brightness image effect.
    //Value can change between -1 and 1. 0 means means no brightness change.
    brightness: 0,
    //Controls the contrast image effect.
    //Value can change between -1 and 1. 0 means means no contrast change.
    contrast: 0,
    //Activates/Deactivates the sepia image effect.
    sepia: false,
    //Activates/Deactivates the film grain image effect.
    film: false,
    //Controls the vignette image effect
    //An offset of 0 means no noticeable effect
    vignetteOffset: 0,
    vignetteDarkness: 2,
    //Activates/Deactivates the digital glitch image effect.
    glitch: false,
    shadows: {
      enabled: false
    },
    onLoad: function onLoad(api) {},
    //Callback event for when the whole canvas is unloaded
    //useful to dispose the api object reference, for instance
    onUnload: function onUnload() {}
  },
  // #endregion renderer
  // #region light
  light: {
    //intensity of the ambient light
    intensity: 2.0,
    //color tint of the ambient light
    color: 'rgb(153,153,153)'
  },
  // #endregion light
  // #region camera
  camera: {
    //near frustum clipping distance of the perspective camera
    //should be numeric values greater than 0.1 for proper functioning
    near: 0.1,
    //far frustum clipping distances of the perspective camera
    //values can be
    // - any numeric values greater than the value chose for near
    // - 'infinity', meaning no limit
    // - 'auto', meaning the distance will be automatically calculated for the size of the scene content
    far: 10000,
    //horizontal field of view, in degrees
    fov: 120,
    //if true, rotation using the left mouse button (or 1 finger-drag) will be enabled.
    enableRotate: true,
    //if true, panning with the right mouse (or 3-finger drag) will be enabled.
    enablePan: true,
    //if true, zooming using the mouse wheel (or 2 finger pinch) will be enabled.
    enableZoom: true,
    //the initial camera position and target, in absolute coordinates
    //expects an object with coordinates x, y and z with numeric values
    initialPosition: {
      x: 100,
      y: 100,
      z: 100
    },
    initialTarget: {
      x: 0,
      y: 0,
      z: 0
    },
    //vertical camera rotation limits, defined in polar angles, in degrees
    //For instance, at minPolarAngle = 0 the camera will, at most, stand at a top-down view
    //and maxPolarAngle=90, the camera will not rotate below the XY-plane
    minPolarAngle: 0,
    maxPolarAngle: 180,
    //default duration, in milliseconds, used when camera animations takes place
    animationDuration: 750,
    //the speed of the camera rotation. Larger values mean the
    //camera will rotate further for the same mouse/drag movement
    rotateSpeed: 0.2,
    //indicates if the camera should be rotating automatically around the Y-Axis
    autoRotate: false,
    //the speed of auto-rotation, when enabled
    autoRotateSpeed: 2.0,
    //if true, automatic camera framing will occur when a node
    //is selected on the scene
    selectionFraming: true,
    //if true, automatic camera framing will occur where a scene
    //is loaded
    loadFraming: true,
    //the animation duration during load framing
    loadFramingDuration: 750,
    //absolute offset, in addition to the calculated frame distance, at which the camera
    //will stand from the object after framing is performed. Positive values
    //indicate that the camera will be placed further away from the object
    //that the framing distance, while negative values mean it will be placed closer.
    frameOffset: 0,
    //establishes the minimum distance that the camera can navigate towards the target
    //numeric values greater than 0 are accepted
    minDistance: 0,
    //values can be
    // - any numeric values greater than the value chose for minDistance
    // - 'infinity', meaning no limit
    // - 'auto', meaning the distance will be automatically calculated for the size of the scene content
    maxDistance: Infinity,
    //zoom factor - larger values mean the camera will zoom further for the same
    //pinch/scroll wheel delta
    zoomSpeed: 1,
    //pan speed - larger values mean the camera will pan further for the same mouse/finger drag
    panSpeed: 1,
    //if true, the camera will zoom in the direction of the current mouse position
    //(like Google Maps), otherwise it will zoom towards the current screen center.
    scrollZoomToCursor: true,
    //if true, a colored sphere will be drawn at the location of the camera target
    //which can be useful for debugging
    targetHelper: false,
    //Provides an effect of inertia when spinning. It can be used to can be used to give a sense
    //of weight to the controls. The lower the damping factor, the higher is the rotation sensitivity
    //A value of 0 disables damping. Values around 0.05 provide more noticeable effects.
    dampingFactor: 0,
    //Callback events for when the camera position/target changes (in general) or,
    //more specifically, when the camera pans, zooms or rotates
    onCameraChange: function onCameraChange(api) {},
    onCameraPan: function onCameraPan(api) {},
    onCameraZoom: function onCameraZoom(api) {},
    onCameraRotate: function onCameraRotate(api) {}
  },
  // #endregion camera
  // #region animation
  animation: {
    //possible values are 'paused', 'loopOnce', 'loopOnceInverted','loopPingPong'
    initialState: 'loopPingPong'
  },
  // #endregion animation
  // #region minimap
  minimap: {
    // shows/enables or hides/disables the minimap
    enabled: false,
    // horizontal resolution of the minimap. If left null but height
    // is not, it will be set accordingly, so as to keep
    // the same ratio as the loaded surface
    width: 200,
    // (e.g. 100) vertical resolution of the minimap. If left null
    // but width is not, it will be set accordingly, so as to keep
    // the same ratio as the loaded surface
    height: null,
    // if true, a rectangle will be drawn on the minimap, indicating
    //the area viewed by the camera. More appropriate on top-down
    //camera configurations.
    showCameraView: false,
    //  (e.g. “myMinimapDiv”) if indicated, the minimap will be placed
    //  as a child of the element with the id indicated here. If left
    //  null, the minimap will be placed as a child of the 2.5D viewer
    element: null,
    // css properties of the minimap canvas. Any css property can be
    // used here (see the ‘style’ section above for details on css
    // properties). The defaults are indicated here, and these will be
    // merged with any indicated style. So, for instance, if “right”
    // is defined, then the “left” property should explicitly be set
    // to null.
    style: {
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      border: '2px solid white'
    },
    // color of the rectangle stroke that indicates the camera view
    strokeColor: 'rgb(128,3,255)',
    // width of the rectangle stroke that indicates the camera view
    strokeWidth: 4
  },
  // #endregion minimap
  // #region surface
  surface: {
    // delay time, in milliseconds before starting the loading
    // of subsections after a camera movement
    loadingDelay: 1000
  },
  // #endregion surface
  // #region flashlight
  flashlight: {
    // enables/disables the flashlight
    enabled: false,
    // Type of light, can be 'Directional' or 'Spot'
    lightType: 'Directional',
    // intensity of the selected light type
    intensity: 1.0,
    // color tint of the selected light type
    color: 0xffffff,
    // initial target position of the light, in absolute
    // coordinates.
    initialTarget: {
      x: 1000,
      y: 0,
      z: 100
    },
    // initial angle, in degrees, at which the light is pointing from
    initialAngle: 135,
    // distance between light source and target is defined by this property,
    // which remains constant. When moved, the source is aligned to a dome/hemisphere,
    // enabling light rotation around all axes (even through the interaction is limited to a 2D view).
    // This means that, for instance, if the x-y coordinates of the source and target are the same,
    // the light will face top-down.
    // As the source moves to an edge, its z coordinate and angle to the surface will be lowered
    // until it remains almost horizontal to the surface.
    //
    // This value can be set to:
    // - An absolute numeric value
    // - The string 'auto', in which case the distance will be adjusted to the surface size (being equal to the distance
    //   from the center to the closest edge of the surface)
    // - The string 'dynamic', in which case it will do the same as 'auto' and adjust the distance to the camera zoom
    //   (being equal to the distance from the center to the closest edge of the surface segment currently in view)
    //
    distance: 'auto',
    // the initial distance of the light source from the target, according to the logic
    // explained for the 'distance' property
    initialRelativeDistance: 0.5,
    // if true, a debug arrow will be rendered, just so as to illustrate the
    // light source position and target
    arrowHelper: false,
    // if true, left-clicking with the mouse (or tapping on the screen) on a
    // surface area will move the light target to that position
    enableInteractivePosition: true,
    // if true, left-pressing with the mouse (or pressing on the screen) on a
    // surface area, and then dragging, will move the light source position
    // towards or away from the initially pressed point
    enableInteractiveDirection: true,
    // Callback event for when the light source position or target changes
    onLightChange: function onLightChange() {}
  }
};

/**
 * The CanvasResizeWatch is the component that watches for changes in size
 * outside the viewer div and updates other components.
 */

var CanvasResizeWatcher = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CanvasResizeWatcher, _React$Component);

  function CanvasResizeWatcher(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      config: props.config,
      viewerManagers: props.viewerManagers,
      renderManager: props.renderManager
    };
    return _this;
  }

  CanvasResizeWatcher.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var nextConfig = nextProps.config;

    if (nextConfig.renderer.ratio !== state.config.renderer.ratio || nextConfig.camera.fov !== state.config.camera.fov || nextConfig.renderer.width !== state.config.renderer.width || nextConfig.renderer.height !== state.config.renderer.height) {
      CanvasResizeWatcher.updateCanvasSize(state.renderManager.getBaseSize(), nextConfig, state);
    }

    return {
      config: nextConfig
    };
  };

  CanvasResizeWatcher.updateCanvasSize = function updateCanvasSize(width, config, state) {
    if (state.renderManager.hasRenderer()) {
      width = config.renderer.width || width;
      var height = config.renderer.height || width / config.renderer.ratio;
      state.viewerManagers.filter(function (x) {
        return x.onCanvasSizeUpdate;
      }).forEach(function (x) {
        return x.onCanvasSizeUpdate(width, height);
      });
    }
  };

  var _proto = CanvasResizeWatcher.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/react.createElement(ReactResizeDetector__default["default"], {
      handleWidth: true,
      handleHeight: true,
      onResize: function onResize(width) {
        return CanvasResizeWatcher.updateCanvasSize(width, _this2.state.config, _this2.state);
      }
    });
  };

  return CanvasResizeWatcher;
}(react.Component);

var ProgressCircle = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ProgressCircle, _React$Component);

  function ProgressCircle(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.progressManager = props.progressManager;

    _this.progressManager.onProgressEvent.subscribe(_this.onProgressEvent.bind(_assertThisInitialized(_this)), _assertThisInitialized(_this));

    _this.progressManager.onProgressFinishEvent.subscribe(_this.onProgressFinishEvent.bind(_assertThisInitialized(_this)), _assertThisInitialized(_this));

    _this.state = {
      isLoading: false,
      loadingProgress: 0
    };
    return _this;
  }
  /**
   * Event that updates the progress control during the node loading process.
   * @param progress
   */


  var _proto = ProgressCircle.prototype;

  _proto.onProgressEvent = function onProgressEvent(progress) {
    this.setState({
      isLoading: true,
      loadingProgress: progress
    });
  }
  /**
   * Event that hides the progress control when the node loading process is finished.
   */
  ;

  _proto.onProgressFinishEvent = function onProgressFinishEvent() {
    this.setState({
      isLoading: false
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.progressManager.onProgressEvent.unsubscribeAll(this);
    this.progressManager.onProgressFinishEvent.unsubscribeAll(this);
  };

  _proto.render = function render() {
    if (this.props.showProgress && this.state.isLoading) {
      var value = Number.isFinite(this.state.loadingProgress) ? Math.floor(this.state.loadingProgress * 100) + '%' : '';
      var color = this.props.progressColor;
      var style = {
        borderTopColor: color
      };
      return /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("span", {
        style: {
          color: color
        },
        className: 'lds-text'
      }, value), /*#__PURE__*/react.createElement("div", {
        style: style,
        className: 'lds-ring'
      }, /*#__PURE__*/react.createElement("div", {
        style: style
      }), /*#__PURE__*/react.createElement("div", {
        style: style
      }), /*#__PURE__*/react.createElement("div", {
        style: style
      }), /*#__PURE__*/react.createElement("div", {
        style: style
      })));
    }

    return null;
  };

  return ProgressCircle;
}(react.Component);

/**
 * The SharpEvent is a C#-inspired implementation of an event system. One should create an object of this class for each
 * event, such as "this.onChangeEvent = new SharpEvent()", which other class can access directly for subscription and
 * unsubscription. The advantage of this system (when compared with the event emitter) are many:
 * - No repetition: No need to reimplement add,emit and remove functions at every class;
 * - Less verbose: bind(this) is done internally, so there's no need to keep a reference to the original callback and the bound this;
 * - Safer: unsubscription can be performed on object level;
 * - IDE friendly: IDEs can more easily suggest event variables (especially if you follow a naming standard such as 'onChangeEvent') than random strings for event names;
 * - Same performance: The cpu and memory overhead is the pretty much the same.
 * - Simplicity: Usage is simple, as well as its implementation.
 */
var SharpEvent = /*#__PURE__*/function () {
  function SharpEvent() {
    this.callbackItems = [];
  }
  /**
   * Invokes the event.
   * @param args The args to pass to the function.
   */


  var _proto = SharpEvent.prototype;

  _proto.invoke = function invoke() {
    var _arguments = arguments;
    this.callbackItems.forEach(function (item) {
      return item.callback.apply(item, [].slice.call(_arguments));
    });
    this.callbackItems = this.callbackItems.filter(function (item) {
      return !item.singleUse;
    });
  }
  /**
   * Subscribes a callback.
   * @param callback The callback to add.
   * @param thisObject (Optional) If defined, a bind(thisObject) will be performed. It it also useful to unsubscribe all callbacks from that object.
   */
  ;

  _proto.subscribe = function subscribe(callback, thisObject) {
    this.callbackItems.push({
      thisObject: thisObject,
      originalCallback: callback,
      callback: thisObject ? callback.bind(thisObject) : callback
    });
    return this;
  }
  /**
   * Subscribes a callback for one use.
   * @param callback The callback to add.
   * @param thisObject (Optional) If defined, a bind(thisObject) will be performed. It it also useful to unsubscribe all callbacks from that object.
   */
  ;

  _proto.subscribeOnce = function subscribeOnce(callback, thisObject) {
    this.callbackItems.push({
      thisObject: thisObject,
      originalCallback: callback,
      callback: thisObject ? callback.bind(thisObject) : callback,
      singleUse: true
    });
    return this;
  }
  /**
   * Unsubscribes a callback (all or just from a given object).
   * @param callback The callback to remove
   * @param thisObject (Optional) If defined, will unsubscribe all callbacks belonging to 'thisObject', or all otherwise.
   */
  ;

  _proto.unsubscribe = function unsubscribe(callback, thisObject) {
    this.callbackItems = thisObject ? this.callbackItems.filter(function (item) {
      return item.thisObject !== thisObject || item.originalCallback !== callback;
    }) : this.callbackItems.filter(function (item) {
      return item.originalCallback !== callback;
    });
    return this;
  }
  /**
   * Unsubscribes all callbacks (all or just from a given object).
   * @param thisObject (Optional) If defined, will unsubscribe all callbacks belonging to 'thisObject', or all otherwise.
   */
  ;

  _proto.unsubscribeAll = function unsubscribeAll(thisObject) {
    this.callbackItems = thisObject ? this.callbackItems.filter(function (item) {
      return item.thisObject !== thisObject;
    }) : [];
    return this;
  };

  return SharpEvent;
}();

var AbstractAnimation = function AbstractAnimation() {};

var CommonOptionsAnimation = /*#__PURE__*/function (_AbstractAnimation) {
  _inheritsLoose(CommonOptionsAnimation, _AbstractAnimation);

  function CommonOptionsAnimation(animationOptions) {
    var _animationOptions$nam;

    var _this;

    _this = _AbstractAnimation.call(this) || this;
    _this._stoppedOrFinished = false;
    _this._uuid = (_animationOptions$nam = animationOptions.name) != null ? _animationOptions$nam : uuid.v4();
    _this._animationOptions = animationOptions;
    return _this;
  }

  var _proto = CommonOptionsAnimation.prototype;

  _proto.canBeUnregistered = function canBeUnregistered() {
    var _this$_animationOptio;

    return ((_this$_animationOptio = this._animationOptions.unregisterAtEnd) != null ? _this$_animationOptio : true) && this._stoppedOrFinished;
  };

  _proto.start = function start() {
    this._stoppedOrFinished = false;
  };

  _proto.pause = function pause() {
    var _this$_animationOptio2, _this$_animationOptio3;

    (_this$_animationOptio2 = (_this$_animationOptio3 = this._animationOptions).onPause) == null ? void 0 : _this$_animationOptio2.call(_this$_animationOptio3);
  };

  _proto.resume = function resume() {
    var _this$_animationOptio4, _this$_animationOptio5;

    (_this$_animationOptio4 = (_this$_animationOptio5 = this._animationOptions).onResume) == null ? void 0 : _this$_animationOptio4.call(_this$_animationOptio5);
  };

  _proto.stop = function stop() {
    var _this$_animationOptio6, _this$_animationOptio7;

    (_this$_animationOptio6 = (_this$_animationOptio7 = this._animationOptions).onStop) == null ? void 0 : _this$_animationOptio6.call(_this$_animationOptio7);
    this._stoppedOrFinished = true;
  };

  _proto.finish = function finish() {
    var _this$_animationOptio8, _this$_animationOptio9;

    (_this$_animationOptio8 = (_this$_animationOptio9 = this._animationOptions).onFinish) == null ? void 0 : _this$_animationOptio8.call(_this$_animationOptio9);
    this._stoppedOrFinished = true;
  };

  _proto.shouldAutoPlay = function shouldAutoPlay() {
    var _this$_animationOptio10;

    return (_this$_animationOptio10 = this._animationOptions.autoPlay) != null ? _this$_animationOptio10 : true;
  };

  _createClass(CommonOptionsAnimation, [{
    key: "name",
    get: function get() {
      return this._uuid;
    }
  }, {
    key: "uuid",
    get: function get() {
      return this._uuid;
    }
  }, {
    key: "stoppedOrFinished",
    get: function get() {
      return this._stoppedOrFinished;
    }
  }, {
    key: "animationOptions",
    get: function get() {
      return this._animationOptions;
    }
  }]);

  return CommonOptionsAnimation;
}(AbstractAnimation);

var ParallelAnimation = /*#__PURE__*/function (_CommonOptionsAnimati) {
  _inheritsLoose(ParallelAnimation, _CommonOptionsAnimati);

  function ParallelAnimation(animationsCreators, animationOptions) {
    var _this;

    _this = _CommonOptionsAnimati.call(this, animationOptions) || this;
    _this.subAnimationsFinished = 0;
    _this.animations = animationsCreators.map(function (creator) {
      return creator(Object.assign({}, animationOptions, {
        onPause: null,
        onResume: null,
        onStop: null,
        autoPlay: false,
        name: null,
        onFinish: _this.onSubAnimationFinished.bind(_assertThisInitialized(_this))
      }));
    }).filter(function (x) {
      return !!x;
    });
    if (_CommonOptionsAnimati.prototype.shouldAutoPlay.call(_assertThisInitialized(_this))) _this.start();
    return _this;
  }

  var _proto = ParallelAnimation.prototype;

  _proto.onSubAnimationFinished = function onSubAnimationFinished() {
    //when all the subanimations are finished, inform that this parallel animation is done.
    this.subAnimationsFinished++;

    if (this.subAnimationsFinished == this.animations.length) {
      this.finish();
    }
  };

  _proto.start = function start(playOptions) {
    _CommonOptionsAnimati.prototype.start.call(this);

    this.animations.forEach(function (x) {
      return x.start(playOptions);
    });
  };

  _proto.pause = function pause() {
    _CommonOptionsAnimati.prototype.pause.call(this);

    this.animations.forEach(function (x) {
      return x.pause();
    });
  };

  _proto.resume = function resume() {
    _CommonOptionsAnimati.prototype.resume.call(this);

    this.animations.forEach(function (x) {
      return x.resume();
    });
  };

  _proto.stop = function stop() {
    _CommonOptionsAnimati.prototype.stop.call(this);

    this.animations.forEach(function (x) {
      return x.stop();
    });
  };

  _proto.canBeUnregistered = function canBeUnregistered() {
    return _CommonOptionsAnimati.prototype.canBeUnregistered.call(this) && this.animations.every(function (x) {
      return x.canBeUnregistered();
    });
  };

  _proto.seek = function seek(percentage) {
    this.animations.forEach(function (x) {
      return x.seek(percentage);
    });
  };

  _createClass(ParallelAnimation, [{
    key: "duration",
    get: function get() {
      return Math.max.apply(Math, this.animations.map(function (x) {
        return x.duration;
      }));
    }
  }]);

  return ParallelAnimation;
}(CommonOptionsAnimation);

var MathHelper = {
  toRadians: function toRadians(degrees) {
    return degrees * Math.PI / 180;
  },
  toDegrees: function toDegrees(radians) {
    return radians * (180 / Math.PI);
  },
  random: function random(min, max) {
    return Math.random() * (max - min) + min;
  },
  randomInt: function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  },
  clamp: function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
};

var SequentialAnimation = /*#__PURE__*/function (_CommonOptionsAnimati) {
  _inheritsLoose(SequentialAnimation, _CommonOptionsAnimati);

  function SequentialAnimation(animationCreators, animationOptions) {
    var _this;

    _this = _CommonOptionsAnimati.call(this, animationOptions) || this;
    _this.animations = [];
    _this.animationCreators = animationCreators;
    _this.subAnimationOptions = {
      onPause: null,
      onResume: null,
      onStop: null,
      autoPlay: false,
      name: null,
      onFinish: _this.onSubAnimationFinished.bind(_assertThisInitialized(_this))
    };
    _this.currentAnimationIndex = 0; //do a quick initialization of the subanimations, without allowing them to run
    //just to determine their durations
    // and accumulated durations (e.g. [20, 10, 30, 20] would become [0,20, 30, 60, 80])

    var individualDurations = _this.animationCreators.map(function (creator) {
      return creator(_this.subAnimationOptions).duration;
    });

    _this.duration = individualDurations.reduce(function (partialSum, val) {
      return partialSum + val;
    }, 0);
    _this.accumulatedDurations = [0].concat(individualDurations).map(function (curr, i, array) {
      return i == 0 ? 0 : array[i] += array[i - 1] ? array[i - 1] : 0;
    });
    _this.paused = !_this.shouldAutoPlay(); //start anyway to initialize the first, but only trigger its start if this.paused is false

    if (_this.shouldAutoPlay()) _this.start();
    return _this;
  }

  var _proto = SequentialAnimation.prototype;

  _proto.start = function start(playOptions) {
    _CommonOptionsAnimati.prototype.start.call(this);

    this.playOptions = playOptions;
    this.startAnimation(0, playOptions);
  };

  _proto.startAnimation = function startAnimation(index, playOptions) {
    this.currentAnimationIndex = index;
    if (!this.paused) this.currentAnimation.start(playOptions);
  };

  _proto.onSubAnimationFinished = function onSubAnimationFinished() {
    if (this.currentAnimationIndex + 1 >= this.animationCreators.length) {
      this.finish();
    } else {
      this.startAnimation(this.currentAnimationIndex + 1);
    }
  };

  _proto.pause = function pause() {
    this.paused = true;
    this.currentAnimation.pause();

    _CommonOptionsAnimati.prototype.pause.call(this);
  };

  _proto.resume = function resume() {
    this.paused = false;
    this.currentAnimation.resume();

    _CommonOptionsAnimati.prototype.resume.call(this);
  };

  _proto.stop = function stop() {
    this.currentAnimation.stop();

    _CommonOptionsAnimati.prototype.stop.call(this);
  };

  _proto.seek = function seek(percentage) {
    var seekDuration = this.duration * percentage;
    var seekIndex = this.accumulatedDurations.findIndex(function (x) {
      return x > seekDuration;
    }) - 1;
    seekIndex = MathHelper.clamp(seekIndex, 0, this.accumulatedDurations.length);
    this.seekAnimationIndex(seekIndex, seekDuration);
  };

  _proto.seekAnimationIndex = function seekAnimationIndex(seekIndex, seekDuration) {
    //if our seek pointer it at the intended animation
    //call its seek function with the relative percentage
    if (this.currentAnimationIndex == seekIndex) {
      var durationDifference = seekDuration - this.accumulatedDurations[this.currentAnimationIndex];
      var percentageOfAnimation = durationDifference / this.currentAnimation.duration;
      this.currentAnimation.seek(percentageOfAnimation);
    } //if it is beyond, we need to go back on the current animation
    //and then move to the previous animation in the list
    else if (this.currentAnimationIndex > seekIndex) {
      this.currentAnimation.seek(0);
      this.startAnimation(this.currentAnimationIndex - 1, this.playOptions);
      this.seekAnimationIndex(seekIndex, seekDuration);
    } else {
      this.currentAnimation.seek(1);
      this.startAnimation(this.currentAnimationIndex + 1, this.playOptions);
      this.seekAnimationIndex(seekIndex, seekDuration);
    }
  };

  _createClass(SequentialAnimation, [{
    key: "currentAnimation",
    get: function get() {
      var index = this.currentAnimationIndex;
      var animation = this.animations[index];
      if (!animation) animation = this.animations[index] = this.animationCreators[index](this.subAnimationOptions);
      return animation;
    }
  }]);

  return SequentialAnimation;
}(CommonOptionsAnimation);

var TweenManager = /*#__PURE__*/function () {
  function TweenManager() {
    this.tweenAnimationRegistry = new Map();
    this.tweenUpdated = new SharpEvent();
  }

  var _proto = TweenManager.prototype;

  _proto.update = function update() {
    if (TWEEN__default["default"].update()) {
      this.tweenUpdated.invoke();
    }

    for (var _iterator = _createForOfIteratorHelperLoose(this.tweenAnimationRegistry.entries()), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
          key = _step$value[0],
          value = _step$value[1];

      if (value.canBeUnregistered()) {
        this.tweenAnimationRegistry["delete"](key);
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    //cancel all running animations
    for (var _iterator2 = _createForOfIteratorHelperLoose(this.tweenAnimationRegistry.keys()), _step2; !(_step2 = _iterator2()).done;) {
      var key = _step2.value;
      this.cancel(key);
    }
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.tweenUpdated];
  };

  _proto.getAnimations = function getAnimations() {
    return Array.from(this.tweenAnimationRegistry.values());
  };

  _proto.register = function register(animation) {
    if (animation && animation.name != uuid.NIL) {
      this.tweenAnimationRegistry.set(animation.name, animation);
      return animation.name;
    } else {
      return uuid.NIL;
    }
  };

  _proto.registerAnimationsParallel = function registerAnimationsParallel(animationCreators, animationOptions) {
    var _this = this;

    var creatorsReturningAnimations = animationCreators.map(function (x) {
      return function (opts) {
        return _this.remove(x(opts));
      };
    });
    return this.register(new ParallelAnimation(creatorsReturningAnimations, animationOptions));
  };

  _proto.registerAnimationsAsSequence = function registerAnimationsAsSequence(animationCreators, animation) {
    var _this2 = this;

    var creatorsReturningAnimations = animationCreators.map(function (x) {
      return function (opts) {
        return _this2.remove(x(opts));
      };
    });
    return this.register(new SequentialAnimation(creatorsReturningAnimations, animation));
  };

  _proto.remove = function remove(animationId) {
    var tweenAnimation = this.tweenAnimationRegistry.get(animationId);
    this.tweenAnimationRegistry["delete"](animationId);
    return tweenAnimation;
  }
  /**
   * Removes the animation from the tween registry and stops it.
   * @param animationId Id of the animation to cancel.
   */
  ;

  _proto.cancel = function cancel(animationId) {
    var tweenAnimation = this.remove(animationId);

    if (tweenAnimation) {
      tweenAnimation.stop();
    }
  };

  return TweenManager;
}();

// From https://jsfiddle.net/magikMaker/7bjaT/

/**
 * use this to make a Base64 encoded string URL friendly,
 * i.e. '+' and '/' are replaced with '-' and '_' also any trailing '='
 * characters are removed
 *
 * @param {String} str the encoded string
 * @returns {String} the URL friendly encoded String
 */
function base64EncodeUrl(str) {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
/**
 * Use this to recreate a Base64 encoded string that was made URL friendly
 * using Base64EncodeurlFriendly.
 * '-' and '_' are replaced with '+' and '/' and also it is padded with '+'
 *
 * @param {String} str the encoded string
 * @returns {String} the URL friendly encoded String
 */

function base64DecodeUrl(str) {
  str = (str + '===').slice(0, str.length + str.length % 4);
  return str.replace(/-/g, '+').replace(/_/g, '/');
}

var ObjectHelper = {
  coalesce: function coalesce() {
    for (var _iterator = _createForOfIteratorHelperLoose([].slice.call(arguments)), _step; !(_step = _iterator()).done;) {
      var index = _step.value;
      if (index !== null && index !== undefined) return index;
    }
  },
  isNumber: function isNumber(val) {
    return typeof val === 'number';
  }
};

function toVector3(obj) {
  if (obj instanceof THREE.Vector3) return obj;
  return new THREE.Vector3(obj.x, obj.y, obj.z);
}

// import EventEmitter from 'events'
var ApiObject = /*#__PURE__*/function () {
  function ApiObject() {
    this.apis = {};
  }
  /**
   * Registers all the functions of the given object
   * @param apiName
   * @param functionSet
   * @param object (Optional) the base object, so that binding can be performed automatically
   */


  var _proto = ApiObject.prototype;

  _proto.register = function register(apiName, functionSet, object) {
    // spare the repeated job of calling bind for all api functions
    if (object) {
      for (var _i = 0, _Object$keys = Object.keys(functionSet); _i < _Object$keys.length; _i++) {
        var funcKey = _Object$keys[_i];

        try {
          functionSet[funcKey] = functionSet[funcKey].bind(object);
        } catch (e) {
          console.error('Could not bind function "' + funcKey + '": ', e);
        }
      }
    }

    this.apis[apiName] = Object.assign({}, this.apis[apiName], functionSet);
  };

  _proto.get = function get(apiName) {
    return this.apis[apiName];
  };

  return ApiObject;
}();

var Viewer3DApi = /*#__PURE__*/function () {
  function Viewer3DApi(viewerManagers, internalStateManager) {
    var _this = this;

    this.ENUM_EVENTS = {
      DATASOURCE: {
        LOAD: 'onDataSourceLoad'
      },
      NODE: {
        READY: 'onNodeReady',
        SELECT: 'onNodeSelect',
        DESELECT: 'onNodeDeselect',
        LOADING: 'onNodeLoading',
        HOVER: 'onNodeHover',
        UNHOVER: 'onNodeUnhover',
        DBLCLICK: 'onNodeDoubleClick'
      },
      CAMERA: {
        CHANGED: 'onCameraChange',
        PAN: 'onCameraPan',
        ZOOM: 'onCameraZoom',
        ROTATE: 'onCameraRotate'
      },
      RENDERER: {
        UNLOAD: 'onUnload'
      },
      FLASHLIGHT: {
        CHANGED: 'onLightChange'
      }
    };
    this.internalStateManager = internalStateManager;
    this.apiObject = new ApiObject();
    viewerManagers.filter(function (x) {
      return x.exposeAPI;
    }).forEach(function (x) {
      return x.exposeAPI(_this.apiObject, _this);
    });
  }
  /**
   * Lists all events, organized by category.
   * @api viewer3d.api
   * @return {object} An object containing the available events, where the field name indicates the property category.
   */


  var _proto = Viewer3DApi.prototype;

  _proto.listEvents = function listEvents() {
    return this.ENUM_EVENTS;
  }
  /**
   * Changes the properties of a certain category.
   * @param {string} name Path of the property category, separated by '.' or '' to refer to the configuration root.
   * @param {string} options Object containing the fields to be changed, and their values.
   * @api viewer3d.api
   * @example
   * api.loadConfiguration('renderer', {film: true, showStats: false, hue: 0.5});
   * api.loadConfiguration('renderer.ssao.enabled', false);
   * api.loadConfiguration('' , {camera: {enableRotate: false}})
   */
  ;

  _proto.loadConfiguration = function loadConfiguration(name, options) {
    this.internalStateManager.loadConfiguration(name, options);
  }
  /**
   * Gets the current values of one, some or all properties.
   * @param path The path of the property to get. Leave empty to get an object with all property categories.
   * @return An object containing all property categories, or a subset, if a specific path is passed as a parameter.
   * @api viewer3d.api
   * @example
   * api.getConfiguration();                         //=> {dataSource: {…}, scenes: {…}, nodes: {…}, nodeTypes: {…}, ...}
   * api.getConfiguration('renderer');               //=> {width: null, height: null, ratio: 2.5 ...}
   * api.getConfiguration('renderer.ssao.enabled');  //=> false
   */
  ;

  _proto.getConfiguration = function getConfiguration(path) {
    return this.internalStateManager.getConfiguration(path);
  };

  _proto.getSceneAPI = function getSceneAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.SCENE);
  };

  _proto.getCameraAPI = function getCameraAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.CAMERA);
  };

  _proto.getNodeAPI = function getNodeAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.NODE);
  };

  _proto.getMarkerAPI = function getMarkerAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.MARKER);
  };

  _proto.getInstancingAPI = function getInstancingAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.INSTANCING);
  };

  _proto.getSkinAPI = function getSkinAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.SKIN);
  };

  _proto.getAnimationAPI = function getAnimationAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.ANIMATION);
  };

  _proto.getFlashlightAPI = function getFlashlightAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.FLASHLIGHT);
  };

  _proto.getSurfaceAPI = function getSurfaceAPI() {
    return this.apiObject.get(Viewer3DApi.TYPES.SURFACE);
  };

  return Viewer3DApi;
}();
Viewer3DApi.TYPES = {
  NODE: 'Node',
  CAMERA: 'Camera',
  MARKER: 'Marker',
  SKIN: 'Skin',
  ANIMATION: 'Animation',
  SCENE: 'Scene',
  INSTANCING: 'Instancing',
  SURFACE: 'Surface',
  FLASHLIGHT: 'Flashlight'
};

function getCornerPoints(box3) {
  return [new THREE.Vector3(box3.min.x, box3.min.y, box3.min.z), new THREE.Vector3(box3.min.x, box3.min.y, box3.max.z), new THREE.Vector3(box3.min.x, box3.max.y, box3.min.z), new THREE.Vector3(box3.min.x, box3.max.y, box3.max.z), new THREE.Vector3(box3.max.x, box3.min.y, box3.min.z), new THREE.Vector3(box3.max.x, box3.min.y, box3.max.z), new THREE.Vector3(box3.max.x, box3.max.y, box3.min.z), new THREE.Vector3(box3.max.x, box3.max.y, box3.max.z) // 111
  ];
}

var layerNames = {};
function setLayerName(name, number) {
  layerNames[name] = number;
}
function parseLayer(identifier) {
  if (layerNames.hasOwnProperty(identifier)) return layerNames[identifier];
  return 0;
}

var TweenAnimation = /*#__PURE__*/function (_CommonOptionsAnimati) {
  _inheritsLoose(TweenAnimation, _CommonOptionsAnimati);

  function TweenAnimation(tweenProps, update, animationOptions) {
    var _this;

    _this = _CommonOptionsAnimati.call(this, animationOptions) || this;
    _this.tweenProps = tweenProps;
    _this.update = update;
    _this.duration = tweenProps.duration;
    _this.tween = popmotion.tween(tweenProps).start({
      update: update,
      complete: _this.finish.bind(_assertThisInitialized(_this))
    });
    if (!_this.shouldAutoPlay()) _this.tween.pause();
    return _this;
  }

  var _proto = TweenAnimation.prototype;

  _proto.start = function start(playOptions) {
    _CommonOptionsAnimati.prototype.start.call(this);

    if (playOptions != null && playOptions.invert) this.tween.reverse();
    this.tween.resume();
  };

  _proto.pause = function pause() {
    _CommonOptionsAnimati.prototype.pause.call(this);

    this.tween.pause();
  };

  _proto.resume = function resume() {
    _CommonOptionsAnimati.prototype.resume.call(this);

    this.tween.resume();
  };

  _proto.stop = function stop() {
    _CommonOptionsAnimati.prototype.stop.call(this);

    this.tween.stop();
  };

  _proto.seek = function seek(percentage) {
    if (percentage == 0) this.update(this.tweenProps.from);else if (percentage == 1) this.update(this.tweenProps.to);else this.tween.seek(percentage);
  };

  return TweenAnimation;
}(CommonOptionsAnimation);

function animate0to1(onUpdate, animationOptions) {
  return animateCommon(0.0, 1.0, onUpdate, THREE.MathUtils.lerp, animationOptions);
}
function animate1to0(onUpdate, animationOptions) {
  return animateCommon(1, 0, onUpdate, THREE.MathUtils.lerp, animationOptions);
}
function animateNumeric(oldValue, newValue, onUpdate, animationOptions) {
  return animateCommon(oldValue, newValue, onUpdate, THREE.MathUtils.lerp, animationOptions);
}
function animateVector(oldValue, newValue, animationOpts, onUpdate) {
  if (onUpdate === void 0) {
    onUpdate = undefined;
  }

  var action = function action(val) {
    oldValue.copy(val);
    if (onUpdate) onUpdate(val);
  };

  return animateCommon(oldValue.clone(), newValue, action, function (v1, v2, alpha) {
    return new THREE.Vector3(v1.x + (v2.x - v1.x) * alpha, v1.y + (v2.y - v1.y) * alpha, v1.z + (v2.z - v1.z) * alpha);
  }, animationOpts);
}
function animateEuler(oldValue, newValue, animationOpts, onUpdate) {
  if (onUpdate === void 0) {
    onUpdate = undefined;
  }

  var action = function action(val) {
    oldValue.copy(val);
    if (onUpdate) onUpdate(val);
  };

  return animateCommon(oldValue.clone(), newValue, action, function (v1, v2, alpha) {
    return new THREE.Euler(v1.x + (v2.x - v1.x) * alpha, v1.y + (v2.y - v1.y) * alpha, v1.z + (v2.z - v1.z) * alpha);
  }, animationOpts);
}
function animateColor(oldValue, newValue, onUpdate, animationOpts) {
  var action = function action(val) {
    oldValue.copy(val);
    if (onUpdate) onUpdate(oldValue);
  };

  return animateCommon(oldValue.clone(), newValue, action, function (c1, c2, percentage) {
    return c1.clone().lerp(c2, percentage);
  }, animationOpts);
}

function animateCommon(oldValue, newValue, onUpdate, lerpFunction, animationOpts) {
  var action = function action(val) {
    if (onUpdate) onUpdate(val);
  };

  if (animationOpts) {
    var _animationOpts$durati;

    var animationType = animationOpts.type ? popmotion.easing[animationOpts.type] || popmotion.easing.easeInOut : popmotion.easing.easeInOut;
    var animationDuration = (_animationOpts$durati = animationOpts.duration) != null ? _animationOpts$durati : 0;

    if (animationOpts.percentage !== null && animationOpts.percentage !== undefined) {
      var calculatedPercentage = animationType(animationOpts.percentage);
      newValue = lerpFunction(oldValue, newValue, calculatedPercentage);

      if (animationDuration === 0) {
        action(newValue); // use setTimeOut to make sure this does not get executed immediately,

        if (animationOpts.onFinish) setTimeout(function () {
          return animationOpts.onFinish();
        }, 0);
        return;
      }
    }

    return new TweenAnimation({
      from: 0,
      to: 1,
      duration: animationDuration,
      ease: animationType
    }, function (v) {
      var interpolated = lerpFunction(oldValue, newValue, v);
      action(interpolated);
    }, animationOpts);
  } else {
    action(newValue);
  }
}

var Buffer$1 = require('buffer/').Buffer;

var MAIN_CAMERA_LAYER = 1;
var MAIN_CAMERA_NAME = 'main';
setLayerName(MAIN_CAMERA_NAME, MAIN_CAMERA_LAYER);

var CameraManager = /*#__PURE__*/function () {
  function CameraManager(config, tweenManager) {
    this.config = config;
    this.cameraChangeEvent = new SharpEvent();
    this.tweenManager = tweenManager;
    this.animating = false;
  }

  var _proto = CameraManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDivRef) {
    this.rendererDivRef = rendererDivRef; // Create a basic perspective camera

    this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, this.config.camera.near, this.parseFar(this.config.camera.far));
    this.camera.layers.enable(MAIN_CAMERA_LAYER);
    this.controls = new OrbitControls.OrbitControls(this.camera, rendererDivRef);
    this.controls.enableDamping = this.config.camera.dampingFactor > 0;
    this.controls.dampingFactor = this.config.camera.dampingFactor;
    this.controls.enablePan = this.config.camera.enablePan && this.config.renderer.enabled;
    this.controls.enableZoom = this.config.camera.enableZoom && !this.config.camera.scrollZoomToCursor && this.config.renderer.enabled;
    this.controls.enableRotate = this.config.camera.enableRotate && this.config.renderer.enabled;
    this.controls.autoRotate = this.config.camera.autoRotate;
    this.controls.autoRotateSpeed = this.config.camera.autoRotateSpeed;
    this.controls.rotateSpeed = this.config.camera.rotateSpeed;
    this.controls.zoomSpeed = this.config.camera.zoomSpeed;
    this.controls.panSpeed = this.config.camera.panSpeed;
    this.controls.minPolarAngle = MathHelper.toRadians(this.config.camera.minPolarAngle);
    this.controls.maxPolarAngle = MathHelper.toRadians(this.config.camera.maxPolarAngle);
    this.controls.minDistance = this.config.camera.minDistance;
    this.controls.maxDistance = this.parseMaxDistance(this.config.camera.maxDistance);
    this.controls.addEventListener('change', this.cameraChanged.bind(this));
    this.setCameraPosition(this.config.camera.initialPosition);
    this.setCameraTarget(this.config.camera.initialTarget);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.controls.enableDamping = nextConfig.camera.dampingFactor > 0;
    this.controls.dampingFactor = nextConfig.camera.dampingFactor;
    this.controls.enablePan = nextConfig.camera.enablePan && this.config.renderer.enabled;
    this.controls.enableZoom = nextConfig.camera.enableZoom && !nextConfig.camera.scrollZoomToCursor && this.config.renderer.enabled;
    this.controls.enableRotate = nextConfig.camera.enableRotate && this.config.renderer.enabled;
    this.controls.zoomSpeed = nextConfig.camera.zoomSpeed;
    this.controls.panSpeed = nextConfig.camera.panSpeed; // some of the configurations will be updated from the Viewer, when the updateFov is called

    this.controls.autoRotate = nextConfig.camera.autoRotate;
    this.controls.autoRotateSpeed = nextConfig.camera.autoRotateSpeed;
    this.controls.rotateSpeed = nextConfig.camera.rotateSpeed;
    this.controls.minPolarAngle = MathHelper.toRadians(nextConfig.camera.minPolarAngle);
    this.controls.maxPolarAngle = MathHelper.toRadians(nextConfig.camera.maxPolarAngle);
    this.controls.minDistance = nextConfig.camera.minDistance;
    this.controls.maxDistance = this.parseMaxDistance(nextConfig.camera.maxDistance);

    if (nextConfig.camera.near !== this.config.camera.near || nextConfig.camera.far !== this.config.camera.far) {
      this.camera.near = nextConfig.camera.near;
      this.camera.far = this.parseFar(nextConfig.camera.far);
      this.camera.updateProjectionMatrix();
    }

    if (!lodash.isEqual(nextConfig.camera.initialPosition, this.config.camera.initialPosition)) {
      this.setCameraPosition(nextConfig.camera.initialPosition);
    }

    if (!lodash.isEqual(nextConfig.camera.initialTarget, this.config.camera.initialTarget)) {
      this.setCameraTarget(nextConfig.camera.initialTarget);
    }

    this.config = nextConfig;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.controls.dispose();
    delete this.controls;
  };

  _proto.update = function update() {
    // required if controls.enableDamping = true, or if controls.autoRotate = true
    this.controls.update();
  };

  _proto.onCanvasSizeUpdate = function onCanvasSizeUpdate(width, height) {
    var vFOV = 2 * Math.atan(Math.tan(MathHelper.toRadians(this.config.camera.fov) / 2) / (width / height));
    this.screenSize = {
      width: width,
      height: height
    };
    this.camera.fov = MathHelper.toDegrees(vFOV);
    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();
    this.config.camera.onCameraChange(this.api);
    this.cameraChangeEvent.invoke();
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry, api) {
    this.api = api;
    apiRegistry.register(Viewer3DApi.TYPES.CAMERA, {
      getScreenSize: this.getScreenSize,
      setAutoRotate: this.setAutoRotate,
      getAutoRotate: this.getAutoRotate,
      getPosition: this.getCameraPosition,
      setPosition: this.setCameraPosition,
      getTarget: this.getCameraTarget,
      setTarget: this.setCameraTarget,
      setPositionAndTarget: this.setCameraPositionAndTarget,
      getState: this.getCameraState,
      setState: this.setCameraState,
      zoomIn: this.zoomIn,
      zoomOut: this.zoomOut,
      getScreenPosition: this.getScreenPosition,
      moveTo: this.moveTo,
      rotate: this.rotate
    }, this);
  }
  /**
   * Provides the screen size.
   * @api viewer3d.camera
   * @return {Vector2} Size of the screen in pixels.
   */
  ;

  _proto.getScreenSize = function getScreenSize() {
    return this.screenSize;
  };

  _proto.getVerticalFov = function getVerticalFov() {
    return this.camera.fov;
  };

  _proto.getHorizontalFov = function getHorizontalFov() {
    return this.config.camera.fov;
  }
  /**
   * Zooms the camera in.
   * @param percentage Floating-point number between 0-1 indicating the distance percentage to zoom in (default is 0.1).
   * @param animation If a value is set, the transition to the new location will be animated according to the defined options, otherwise the change will be performed instantly.
   * @api viewer3d.camera
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @example
   * viewer3D.getCameraAPI().zoomIn(0.1, true)
   */
  ;

  _proto.zoomIn = function zoomIn(percentage, animation) {
    percentage = ObjectHelper.coalesce(percentage, 0.1);
    animation = ObjectHelper.coalesce(animation, true);
    percentage = MathHelper.clamp(percentage, 0, 0.99);
    return this.zoomInternal(1 - percentage, animation);
  }
  /**
   * Zooms the camera out.
   * @param percentage Floating-point number between 0-1 indicating the distance percentage to zoom out (default is 0.1). Inverse calculation of zoom in, so that one operation can cancel the other.
   * @param animation If a value is set, the transition to the new location will be animated according to the defined options, otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.camera
   * @example
   * viewer3D.getCameraAPI().zoomOut(0.1, true)
   */
  ;

  _proto.zoomOut = function zoomOut(percentage, animation) {
    percentage = ObjectHelper.coalesce(percentage, 0.1);
    animation = ObjectHelper.coalesce(animation, true);
    percentage = MathHelper.clamp(percentage, 0, 0.99);
    return this.zoomInternal(1 / (1 - percentage), animation);
  };

  _proto.zoomInternal = function zoomInternal(percentageDeduction, animation) {
    var position = this.getCameraPosition();
    var target = this.getCameraTarget();
    var sizedDirection = position.clone().sub(target);
    var size = sizedDirection.length();
    var direction = sizedDirection.normalize();
    var intendedDistance = size * percentageDeduction;
    var newPosition = target.clone().add(direction.multiplyScalar(intendedDistance));
    return this.setCameraPosition(newPosition, animation);
  };

  _proto.cameraChanged = function cameraChanged() {
    var currentPosition = this.getCameraPosition();
    var currentTarget = this.getCameraTarget(); // unfortunately the library does not offer the means to differentiate between the several
    // types of camera change, so

    if (this.previousPosition && this.previousTarget) {
      // if the target is the same, we could be talking about a change in rotation or zoom
      if (currentTarget.equals(this.previousTarget)) {
        var currentLen = currentTarget.clone().sub(currentPosition).lengthSq();
        var previousLen = this.previousTarget.clone().sub(this.previousPosition).lengthSq(); // if the distance is approximately the same, we had a rotation, which maintained distance
        // otherwise, it would be a zoom

        if (Math.abs(currentLen - previousLen) < 0.1) {
          this.config.camera.onCameraRotate(this.api);
        } else {
          this.config.camera.onCameraZoom(this.api);
        }
      } else {
        this.config.camera.onCameraPan(this.api);
      }
    }

    this.config.camera.onCameraChange(this.api);
    this.cameraChangeEvent.invoke();
    this.previousPosition = currentPosition.clone();
    this.previousTarget = currentTarget.clone();
  }
  /**
   * Starts/Stops the camera auto rotation. Deprecated, please use the autoRotate camera prop instead.
   * @param state {boolean} True to start the camera, false to stop it.
   * @api viewer3d.camera
   * @deprecated
   */
  ;

  _proto.setAutoRotate = function setAutoRotate(state) {
    console.warn('The function \'setAutoRotate\' has been deprecated. Please use the \'autoRotate\' camera prop instead.');
    this.controls.autoRotate = state;
  }
  /**
   * Gets the state of camera auto rotation. True if it is running, false otherwise.
   * Deprecated, please use the autoRotate camera prop instead.
   * @api viewer3d.camera
   * @returns {boolean} True if the autorotation is enabled, false otherwise.
   * @deprecated
   */
  ;

  _proto.getAutoRotate = function getAutoRotate() {
    console.warn('The function \'getAutoRotate\' has been deprecated. Please use the \'autoRotate\' camera prop instead.');
    return this.controls.autoRotate;
  }
  /**
   * Gets the camera position.
   * @alias getPosition
   * @returns {Vector3} The 3D coordinates of the camera position.
   * @api viewer3d.camera
   */
  ;

  _proto.getCameraPosition = function getCameraPosition() {
    return this.camera.position;
  }
  /**
   * Sets the camera position.
   * @alias setPosition
   * @param position The 3D coordinates of the new position.
   * @param [animation] If a value is set, the transition to the new target will be animated (see animation details in the AnimationOptions object page), otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.camera
   */
  ;

  _proto.setCameraPosition = function setCameraPosition(position, animation) {
    var vector3Position = toVector3(position);
    return this.tweenManager.register(animateVector(this.camera.position, vector3Position, this.includeDefaultDuration(animation)));
  }
  /**
   * Gets the camera target.
   * @alias getTarget
   * @returns {Vector3} The 3D coordinates of the camera target.
   * @api viewer3d.camera
   */
  ;

  _proto.getCameraTarget = function getCameraTarget() {
    return this.controls.target;
  }
  /**
   * Sets the camera target.
   * @alias setTarget
   * @param target The 3D coordinates of the new target.
   * @param animationOptions If a value is set, the transition to the new target will be animated (see animation details in the AnimationOptions object page), otherwise the change will be performed instantly.
   * @api viewer3d.camera
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @example
   * viewer3D.getCameraAPI().setTarget({x : 100, y: 20, z: 39},{})
   */
  ;

  _proto.setCameraTarget = function setCameraTarget(target, animationOptions) {
    var vector3Target = toVector3(target);
    return this.tweenManager.register(animateVector(this.controls.target, vector3Target, this.includeDefaultDuration(animationOptions)));
  }
  /**
   * Sets the camera position and target at once, with the same animation options for both.
   * This call ensures that only 1 call to the onFinished callback function is performed.
   * @api viewer3d.camera
   * @alias setPositionAndTarget
   * @param position {Vector3} The 3D coordinates of the new position.
   * @param target {Vector3} The 3D coordinates of the new target.
   * @param animation If a value is set, the transition to the new target will be animated (see animation details in the AnimationOptions object page), otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   */
  ;

  _proto.setCameraPositionAndTarget = function setCameraPositionAndTarget(position, target, animation) {
    var _this = this,
        _this$includeDefaultD;

    return this.tweenManager.registerAnimationsParallel([function (opts) {
      return _this.setCameraPosition(position, opts);
    }, function (opts) {
      return _this.setCameraTarget(target, opts);
    }], (_this$includeDefaultD = this.includeDefaultDuration(animation)) != null ? _this$includeDefaultD : {
      duration: 0
    });
  }
  /**
   * Gets a hash that represents the current camera position and orientation/target.
   * @returns Base64 string (url-friendly) with the hash.
   * @api viewer3d.camera
   * @alias getState
   */
  ;

  _proto.getCameraState = function getCameraState() {
    var position = this.getCameraPosition();
    var target = this.getCameraTarget();
    var buf = Buffer$1.alloc(6 * 4); // 4 bytes for each value

    var valueList = [position.x, position.y, position.z, target.x, target.y, target.z];

    for (var i = 0; i < valueList.length; i++) {
      buf.writeFloatBE(valueList[i], i * 4);
    }

    var base64String = buf.toString('base64');
    return base64EncodeUrl(base64String);
  }
  /**
   * Sets the current camera position and orientation/target from a hash.
   * @alias setState
   * @param state {string} A Base64 string (url-friendly) with the hash.
   * @param animation If a value is set, the transition to the new location will be animated according to the defined options, otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.camera
   * @example
   * cameraApi.setState('RIUnV0PXyA_DAvSvQrEvDEKXTr9CpLmY', {duration : 3000})
   */
  ;

  _proto.setCameraState = function setCameraState(state, animation) {
    var base64State = base64DecodeUrl(state);
    var buf = Buffer$1.from(base64State, 'base64');
    var valueList = [];

    for (var i = 0; i < 6; i++) {
      valueList.push(buf.readFloatBE(i * 4));
    }

    var newPosition = new THREE.Vector3(valueList[0], valueList[1], valueList[2]);
    var newTarget = new THREE.Vector3(valueList[3], valueList[4], valueList[5]);
    return this.setCameraPositionAndTarget(newPosition, newTarget, animation);
  };

  _proto.getOriginalDirection = function getOriginalDirection() {
    return toVector3(this.config.camera.initialTarget).sub(toVector3(this.config.camera.initialPosition)).normalize();
  };

  _proto.getWorldDirection = function getWorldDirection(direction) {
    var matrix = new THREE.Matrix4();
    matrix.extractRotation(this.camera.matrix);
    return direction.clone().applyMatrix4(matrix);
  }
  /**
   * Moves both the camera position and target simultaneously, maintaining the distance between the two.
   * The move is performed so that the camera direction is maintained.
   * The camera position will be placed at the indicated offset from the indicated point,
   * while the target will be placed at the same distance from the position as it was before.
   *
   * @param point The 3D coordinates of the new position.
   * @param offset The distance from the point that the .
   * @param animation If a value is set, the movement will be animated (see animation details in the AnimationOptions object page), otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.camera
   */
  ;

  _proto.moveTo = function moveTo(point, offset, animation) {
    var position = this.getCameraPosition();
    var target = this.getCameraTarget();
    var pointVector = toVector3(point);
    var frontVector = target.clone().sub(position);
    var backDirection = position.clone().sub(target).normalize();
    var offsetPosition = pointVector.clone().add(backDirection.multiplyScalar(offset));
    var newTarget = offsetPosition.clone().add(frontVector);
    return this.setCameraPositionAndTarget(offsetPosition, newTarget, animation);
  }
  /**
   * Rotates the camera position around the target, at the given axis, maintaining the distance between the two.
   * @param angle Angle, in degrees, to rotate the camera position.
   * @param axis Axis around which to perform the rotation.
   * @param animation Animation control details (see animation details in the AnimationOptions object page).
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.camera
   */
  ;

  _proto.rotate = function rotate(angle, axis, animation) {
    var _this2 = this;

    var angleRadians = MathHelper.toRadians(angle);
    var eulerVector = toVector3(axis);
    var originalCameraPosition = this.camera.position.clone();
    return this.tweenManager.register(animateNumeric(0, angleRadians, function (newValue) {
      var euler = new THREE.Euler(eulerVector.x * newValue, eulerVector.y * newValue, eulerVector.z * newValue, 'XYZ');
      var newPosition = originalCameraPosition.clone().applyEuler(euler);

      _this2.setCameraPosition(newPosition);

      _this2.cameraChangeEvent.invoke();
    }, this.includeDefaultDuration(animation)));
  }
  /**
   * Calculates the 2D screen position of 3D point, from the current camera's perspective.
   * @param vector3D {Vector3} Location of the 3D point.
   * @return {Vector2} ThreeJs Vector2 indicating the 2D screen coordinates.
   * @api viewer3d.camera
   */
  ;

  _proto.getScreenPosition = function getScreenPosition(vector3D) {
    var newVector = vector3D.clone();
    var camera = this.camera;
    newVector.project(camera);
    var clientRect = this.rendererDivRef.getBoundingClientRect();
    var widthHalf = 0.5 * clientRect.width;
    var heightHalf = 0.5 * clientRect.height;
    newVector.x = newVector.x * widthHalf + widthHalf;
    newVector.y = -(newVector.y * heightHalf) + heightHalf;
    return new THREE.Vector2(newVector.x, newVector.y);
  }
  /**
   * Moves the camera so that it frames the given bounding box.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   */
  ;

  _proto.frameBox = function frameBox(boundingBox, direction, animation) {
    var camera = this.camera;
    var frameOffset = this.config.camera.frameOffset;
    var center = boundingBox.getCenter(new THREE.Vector3());
    var cornerPoints = getCornerPoints(boundingBox);
    if (!direction) direction = this.getCameraTarget().clone().sub(camera.position).normalize();
    var lateralDirection = direction.clone().cross(this.camera.up).normalize();
    var verticalDirection = lateralDirection.clone().cross(direction).normalize();
    var horizontalDivisor = Math.tan(MathHelper.toRadians(this.getHorizontalFov() / 2));
    var verticalDivisor = Math.tan(MathHelper.toRadians(this.getVerticalFov() / 2));
    var maxHorizontalDistance = this.getMaxDistanceToPlane(lateralDirection, center, cornerPoints, direction, horizontalDivisor);
    var maxVerticalDistance = this.getMaxDistanceToPlane(verticalDirection, center, cornerPoints, direction, verticalDivisor);
    var boundingDistance = Math.max(maxHorizontalDistance, maxVerticalDistance);
    var offsetDistance = boundingDistance + frameOffset; // we should not allow the calculated distance to within the bounds

    var actualDistance = Math.max(offsetDistance, this.controls.minDistance);
    actualDistance = Math.min(actualDistance, this.controls.maxDistance);
    var newPosition = boundingBox.getCenter(new THREE.Vector3()).sub(direction.multiplyScalar(actualDistance));
    var newTarget = boundingBox.getCenter(new THREE.Vector3());
    return this.setCameraPositionAndTarget(newPosition, newTarget, ObjectHelper.coalesce(animation, {}));
  };

  _proto.getMaxDistanceToPlane = function getMaxDistanceToPlane(lateralDirection, center, cornerPoints, direction, divisor) {
    var lateralPlane = new THREE.Plane(lateralDirection, 0);
    lateralPlane.translate(center);
    var centralPlane = new THREE.Plane(direction, 0);
    centralPlane.translate(center);
    var distances = cornerPoints.map(function (point) {
      var distanceFromPlane = lateralPlane.distanceToPoint(point);
      var distanceFromCamera = distanceFromPlane / divisor;
      var distanceToCenter = centralPlane.distanceToPoint(point);
      return distanceToCenter + distanceFromCamera;
    });
    return Math.max.apply(Math, distances);
  };

  _proto.getCameraLayer = function getCameraLayer() {
    return MAIN_CAMERA_LAYER;
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.cameraChangeEvent];
  };

  _proto.parseFar = function parseFar(far) {
    return ObjectHelper.isNumber(far) ? far : 100;
  };

  _proto.parseMaxDistance = function parseMaxDistance(maxDistance) {
    return ObjectHelper.isNumber(maxDistance) ? maxDistance : Infinity;
  };

  _proto.includeDefaultDuration = function includeDefaultDuration(animationOptions) {
    if (animationOptions) return Object.assign({
      duration: this.config.camera.animationDuration
    }, animationOptions);
  };

  return CameraManager;
}();

var AbstractDataSource = /*#__PURE__*/function () {
  function AbstractDataSource() {}

  var _proto = AbstractDataSource.prototype;

  _proto.load = function load(onLoadFinished) {// eslint-disable-line no-unused-vars
    // to be overridden in the subclasses
  };

  return AbstractDataSource;
}();

var PathHelper = {
  getFullUrl: function getFullUrl(baseUrl, fileUrl) {
    if (!fileUrl) return;
    return !this.isPathAbsolute(fileUrl) ? baseUrl + fileUrl : fileUrl;
  },
  isPathAbsolute: function isPathAbsolute(path) {
    return /^(?:\/|[a-z]+:\/\/)/.test(path);
  }
};

var Equirectangular = /*#__PURE__*/function () {
  function Equirectangular(renderer) {
    this.renderer = renderer;
    this.scene = new THREE.Scene();
    this.crossOrigin = '*';
    this.loaders = {
      hdr: new HDRCubeTextureLoader_js.HDRCubeTextureLoader(),
      exr: new EXRLoader_js.EXRLoader()
    };
  }

  Equirectangular.initialize = function initialize(renderer) {
    Equirectangular.instance = new Equirectangular(renderer);
  };

  Equirectangular.load = function load(url, manager, crossOrigin) {
    if (crossOrigin === void 0) {
      crossOrigin = '*';
    }

    manager = this.manager !== undefined ? manager : THREE.DefaultLoadingManager;
    if (!Equirectangular.instance) throw new Error('Equirectagular has not been initialized!');
    var texture;
    var textureType = url.split('.').pop();

    switch (textureType.toLowerCase()) {
      // @TODO: one day setup HDR EXR
      // case 'hdr':
      //   texture = Equirectangular.instance.loaders.hdr.load(url)
      //   texture.magFilter = THREE.LinearFilter
      //   break
      // case 'exr':
      //   texture = Equirectangular.instance.loaders.exr.load(url)
      //   Equirectangular.instance.loaders.exr.setCrossOrigin(
      //     Equirectangular.instance.crossOrigin
      //   )
      //   texture = Equirectangular.instance.pmremGenerator.fromEquirectangular(
      //     texture
      //   )
      //   break
      default:
        {
          var loader = new THREE.TextureLoader(manager);
          if (loader.setCrossOrigin) loader.setCrossOrigin(crossOrigin);
          texture = loader.load(url);
          texture.encoding = THREE.sRGBEncoding;
          texture.mapping = THREE.EquirectangularReflectionMapping;
          break;
        }
    }

    return texture;
  };

  return Equirectangular;
}();

/**
 * Loads a Wavefront .mtl file specifying materials
 */

var MTLLoader = function MTLLoader(manager) {
  THREE__namespace.Loader.call(this, manager);
};

MTLLoader.prototype = Object.assign(Object.create(THREE__namespace.Loader.prototype), {
  constructor: MTLLoader,

  /**
   * Loads and parses a MTL asset from a URL.
   *
   * @param {String} url - URL to the MTL file.
   * @param {Function} [onLoad] - Callback invoked with the loaded object.
   * @param {Function} [onProgress] - Callback for download progress.
   * @param {Function} [onError] - Callback for download errors.
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to load.
   */
  load: function load(url, onLoad, onProgress, onError) {
    var scope = this;
    var path = this.path === '' ? THREE__namespace.LoaderUtils.extractUrlBase(url) : this.path;
    var loader = new THREE__namespace.FileLoader(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.load(url, function (text) {
      try {
        onLoad(scope.parse(text, path));
      } catch (e) {
        if (onError) {
          onError(e);
        } else {
          console.error(e);
        }

        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  },
  setMaterialOptions: function setMaterialOptions(value) {
    this.materialOptions = value;
    return this;
  },

  /**
   * Parses a MTL file.
   *
   * @param {String} text - Content of MTL file
   * @return {MTLLoader.MaterialCreator}
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to parse.
   */
  parse: function parse(text, path) {
    var lines = text.split('\n');
    var info = {};
    var delimiterPattern = /\s+/;
    var materialsInfo = {};

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      line = line.trim();

      if (line.length === 0 || line.charAt(0) === '#') {
        // Blank line or comment ignore
        continue;
      }

      var pos = line.indexOf(' ');
      var key = pos >= 0 ? line.substring(0, pos) : line;
      key = key.toLowerCase();
      var value = pos >= 0 ? line.substring(pos + 1) : '';
      value = value.trim();

      if (key === 'newmtl') {
        // New material
        info = {
          name: value
        };
        materialsInfo[value] = info;
      } else {
        if (key === 'ka' || key === 'kd' || key === 'ks' || key === 'ke') {
          var ss = value.split(delimiterPattern, 3);
          info[key] = [parseFloat(ss[0]), parseFloat(ss[1]), parseFloat(ss[2])];
        } else {
          info[key] = value;
        }
      }
    }

    var materialCreator = new MTLLoader.MaterialCreator(this.resourcePath || path, this.materialOptions);
    materialCreator.setCrossOrigin(this.crossOrigin);
    materialCreator.setManager(this.manager);
    materialCreator.setMaterials(materialsInfo);
    return materialCreator;
  }
});
/**
 * Create a new MTLLoader.MaterialCreator
 * @param baseUrl - Url relative to which textures are loaded
 * @param options - Set of options on how to construct the materials
 *                  side: Which side to apply the material
 *                        FrontSide (default), THREE.BackSide, THREE.DoubleSide
 *                  wrap: What type of wrapping to apply for textures
 *                        RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
 *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
 *                                Default: false, assumed to be already normalized
 *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
 *                                  Default: false
 * @constructor
 */

MTLLoader.MaterialCreator = function (baseUrl, options) {
  this.baseUrl = baseUrl || '';
  this.options = options;
  this.materialsInfo = {};
  this.materials = {};
  this.materialsArray = [];
  this.nameLookup = {};
  this.side = this.options && this.options.side ? this.options.side : THREE__namespace.FrontSide;
  this.wrap = this.options && this.options.wrap ? this.options.wrap : THREE__namespace.RepeatWrapping;
};

MTLLoader.MaterialCreator.prototype = {
  constructor: MTLLoader.MaterialCreator,
  crossOrigin: 'anonymous',
  setCrossOrigin: function setCrossOrigin(value) {
    this.crossOrigin = value;
    return this;
  },
  setManager: function setManager(value) {
    this.manager = value;
  },
  setMaterials: function setMaterials(materialsInfo) {
    this.materialsInfo = this.convert(materialsInfo);
    this.materials = {};
    this.materialsArray = [];
    this.nameLookup = {};
  },
  convert: function convert(materialsInfo) {
    if (!this.options) return materialsInfo;
    var converted = {};

    for (var mn in materialsInfo) {
      // Convert materials info into normalized form based on options
      var mat = materialsInfo[mn];
      var covmat = {};
      converted[mn] = covmat;

      for (var prop in mat) {
        var save = true;
        var value = mat[prop];
        var lprop = prop.toLowerCase();

        switch (lprop) {
          case 'kd':
          case 'ka':
          case 'ks':
            // Diffuse color (color under white light) using RGB values
            if (this.options && this.options.normalizeRGB) {
              value = [value[0] / 255, value[1] / 255, value[2] / 255];
            }

            if (this.options && this.options.ignoreZeroRGBs) {
              if (value[0] === 0 && value[1] === 0 && value[2] === 0) {
                // ignore
                save = false;
              }
            }

            break;
        }

        if (save) {
          covmat[lprop] = value;
        }
      }
    }

    return converted;
  },
  preload: function preload() {
    for (var mn in this.materialsInfo) {
      this.create(mn);
    }
  },
  getIndex: function getIndex(materialName) {
    return this.nameLookup[materialName];
  },
  getAsArray: function getAsArray() {
    var index = 0;

    for (var mn in this.materialsInfo) {
      this.materialsArray[index] = this.create(mn);
      this.nameLookup[mn] = index;
      index++;
    }

    return this.materialsArray;
  },
  create: function create(materialName) {
    if (this.materials[materialName] === undefined) {
      this.createMaterial_(materialName);
    }

    return this.materials[materialName];
  },
  createMaterial_: function createMaterial_(materialName) {
    var scope = this;
    var mat = this.materialsInfo[materialName];
    var params = {
      name: materialName,
      side: this.side
    };

    function resolveURL(baseUrl, url) {
      if (typeof url !== 'string' || url === '') return ''; // Absolute URL

      if (/^https?:\/\//i.test(url)) return url;
      return baseUrl + url;
    }

    var setMapForType = function setMapForType(mapType, value) {
      if (params[mapType]) return; // Keep the first encountered texture

      var texture;
      var texParams = scope.getTextureParams(value, params);
      var url = resolveURL(scope.baseUrl, texParams.url);

      if (mapType === 'envMap') {
        texture = scope.loadEquiRectangular(url);
      } else {
        texture = scope.loadTexture(url);
      }

      texture.repeat.copy(texParams.scale);
      texture.offset.copy(texParams.offset);
      texture.wrapT = scope.wrap;
      texture.wrapS = scope.wrap;
      params[mapType] = texture;
    };

    for (var prop in mat) {
      var value = mat[prop];
      var n;
      if (value === '') continue;

      switch (prop.toLowerCase()) {
        // Ns is material specular exponent
        case 'kd':
          // Diffuse color (color under white light) using RGB values
          params.color = new THREE__namespace.Color().fromArray(value);
          break;

        case 'ks':
          // Specular color (color when light is reflected from shiny surface) using RGB values
          params.specular = new THREE__namespace.Color().fromArray(value);
          break;

        case 'ke':
          // Emissive using RGB values
          params.emissive = new THREE__namespace.Color().fromArray(value);
          break;

        case 'map_kd':
          // Diffuse texture map
          setMapForType('map', value);
          break;

        case 'map_refl':
          // Reflective map texture map
          setMapForType('envMap', value);
          break;

        case 'map_ks':
          // Specular map
          setMapForType('specularMap', value);
          break;

        case 'map_ke':
          // Emissive map
          setMapForType('emissiveMap', value);
          break;

        case 'norm':
          setMapForType('normalMap', value);
          break;

        case 'map_bump':
        case 'bump':
          // Bump texture map
          setMapForType('bumpMap', value);
          break;

        case 'map_d':
          // Alpha map
          setMapForType('alphaMap', value);
          params.transparent = true;
          break;

        case 'ns':
          // The specular exponent (defines the focus of the specular highlight)
          // A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.
          params.shininess = parseFloat(value);
          break;

        case 'd':
          n = parseFloat(value);

          if (n < 1) {
            params.opacity = n;
            params.transparent = true;
          }

          break;

        case 'tr':
          n = parseFloat(value);
          if (this.options && this.options.invertTrProperty) n = 1 - n;

          if (n > 0) {
            params.opacity = 1 - n;
            params.transparent = true;
          }

          break;
      }
    }

    var newMaterial = this.materials[materialName] = new THREE__namespace.MeshPhongMaterial(params);
    newMaterial.needsUpdate = true;
    return newMaterial;
  },
  getTextureParams: function getTextureParams(value, matParams) {
    var texParams = {
      scale: new THREE__namespace.Vector2(1, 1),
      offset: new THREE__namespace.Vector2(0, 0)
    };
    var items = value.split(/\s+/);
    var pos;
    pos = items.indexOf('-bm');

    if (pos >= 0) {
      matParams.bumpScale = parseFloat(items[pos + 1]);
      items.splice(pos, 2);
    }

    pos = items.indexOf('-s');

    if (pos >= 0) {
      texParams.scale.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
      items.splice(pos, 4); // we expect 3 parameters here!
    }

    pos = items.indexOf('-o');

    if (pos >= 0) {
      texParams.offset.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
      items.splice(pos, 4); // we expect 3 parameters here!
    }

    texParams.url = items.join(' ').trim();
    return texParams;
  },
  loadTexture: function loadTexture(url, mapping, onLoad, onProgress, onError) {
    var texture;
    var manager = this.manager !== undefined ? this.manager : THREE__namespace.DefaultLoadingManager;
    var loader = manager.getHandler(url);

    if (loader === null) {
      loader = new THREE__namespace.TextureLoader(manager);
    }

    if (loader.setCrossOrigin) loader.setCrossOrigin(this.crossOrigin);
    texture = loader.load(url, onLoad, onProgress, onError);
    if (mapping !== undefined) texture.mapping = mapping;
    return texture;
  },
  loadEquiRectangular: function loadEquiRectangular(url, onLoad, onProgress, onError) {
    var texture;
    var manager = this.manager !== undefined ? this.manager : THREE__namespace.DefaultLoadingManager;
    var loader = manager.getHandler(url);

    if (loader === null) {
      texture = Equirectangular.load(url, manager);
    }

    return texture;
  }
};

function _catch$3(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var ObjLoadHelper = /*#__PURE__*/function () {
  function ObjLoadHelper() {}

  /**
   *Loads a Wavefront .obj file from a given url.
   * @param objFilePath Full file path/url to the obj file.
   * @param mtlFilePath Full file path/url to the mtl file.
   * @param fileSizeResolver
   * @param onLoadProgress Callback for file loading progress, as function(progress){}
   * @param onLoadFinished Callback for file loading finish, as function(err,result){}
   */
  ObjLoadHelper.load = function load(objFilePath, mtlFilePath, fileSizeResolver, onLoadProgress, onLoadFinished) {
    try {
      var _temp2 = _catch$3(function () {
        var mtlBaseFolderPath = mtlFilePath.substring(0, mtlFilePath.lastIndexOf('/') + 1);
        var mtlFileName = mtlFilePath.replace(mtlBaseFolderPath, '');
        var objFileName = objFilePath.replace(mtlBaseFolderPath, '');
        var mtlLoader = new MTLLoader();
        var objLoader = new OBJLoader.OBJLoader();
        mtlLoader.setPath(mtlBaseFolderPath);
        objLoader.setPath(mtlBaseFolderPath);
        mtlLoader.setCrossOrigin('*');
        return Promise.resolve(mtlLoader.loadAsync(mtlFileName, function (progress) {
          onLoadProgress(progress.loaded / progress.total);
        })).then(function (mtl) {
          mtl.preload();
          objLoader.setMaterials(mtl);
          return Promise.resolve(objLoader.loadAsync(objFileName, function (progress) {
            onLoadProgress(progress.loaded / progress.total);
          })).then(function (obj) {
            onLoadFinished(undefined, obj);
          });
        });
      }, function (e) {
        console.error('ObjLoadHelper Error: ', e);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return ObjLoadHelper;
}();

var ContentItemTransformer = /*#__PURE__*/function () {
  function ContentItemTransformer(contentItem) {
    if (contentItem.translation) {
      this.translation = toVector3(contentItem.translation);
    }

    if (contentItem.rotation) {
      this.rotation = toVector3(contentItem.rotation).multiplyScalar(Math.PI / 180);
    }

    if (contentItem.scale) {
      this.scale = toVector3(contentItem.scale);
    }

    if (contentItem.visible !== null && contentItem.visible !== undefined) {
      this.visible = contentItem.visible;
    }

    this.layer = contentItem.layer;
  }

  var _proto = ContentItemTransformer.prototype;

  _proto.apply = function apply(object3D) {
    var _this = this;

    if (this.translation) {
      object3D.position.add(this.translation);
    }

    if (this.rotation) {
      object3D.rotation.set(this.rotation.x, this.rotation.y, this.rotation.z);
    }

    if (this.scale) {
      object3D.scale.copy(this.scale);
    }

    if (this.visible !== null && this.visible !== undefined) {
      object3D.visible = this.visible;
    }

    if (this.layer) {
      object3D.layers.set(parseLayer(this.layer));
      object3D.traverse(function (child) {
        return child.layers.set(parseLayer(_this.layer));
      });
    }
  };

  return ContentItemTransformer;
}();

var ObjContentLoader = /*#__PURE__*/function () {
  function ObjContentLoader() {}

  var _proto = ObjContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    // make relative paths absolute, if necessary
    var objFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
    var mtlFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.mtl || contentItem.url.slice(0, -4) + '.mtl');
    var contentItemTransformer = new ContentItemTransformer(contentItem);
    ObjLoadHelper.load(objFileUrl, mtlFileUrl, dataSource.fileSizeResolver, onLoadProgress, function (err, onFinishResult) {
      if (err) {
        console.error(err);
      }

      for (var _iterator = _createForOfIteratorHelperLoose(onFinishResult.children), _step; !(_step = _iterator()).done;) {
        var child = _step.value;
        contentItemTransformer.apply(child);
        output.objects.push(child);
      }

      onLoadFinished(undefined, output);
    });
  };

  return ObjContentLoader;
}();

var MixerObject = /*#__PURE__*/function (_Object3D) {
  _inheritsLoose(MixerObject, _Object3D);

  function MixerObject(mixer) {
    var _this;

    _this = _Object3D.call(this) || this;
    _this._mixer = mixer;
    return _this;
  }

  _createClass(MixerObject, [{
    key: "mixer",
    get: function get() {
      return this._mixer;
    }
  }]);

  return MixerObject;
}(THREE.Object3D);

var ThreeAnimation = /*#__PURE__*/function (_AbstractAnimation) {
  _inheritsLoose(ThreeAnimation, _AbstractAnimation);

  function ThreeAnimation(animationAction) {
    var _this;

    _this = _AbstractAnimation.call(this) || this;
    _this.animationAction = animationAction;
    return _this;
  }

  var _proto = ThreeAnimation.prototype;

  _proto.pause = function pause() {
    this.animationAction.paused = true;
  };

  _proto.resume = function resume() {
    this.animationAction.paused = false;
  };

  _proto.stop = function stop() {
    this.animationAction.stop();
  };

  _proto.start = function start(playOptions) {
    var _playOptions$repetiti;

    this.animationAction.reset();
    this.animationAction.enabled = true;
    this.animationAction.paused = false;
    this.animationAction.loop = THREE.LoopRepeat;
    this.animationAction.repetitions = (_playOptions$repetiti = playOptions.repetitions) != null ? _playOptions$repetiti : 1;
    this.animationAction.timeScale = playOptions.invert ? -1 : 1;
    this.animationAction.clampWhenFinished = true;
    this.animationAction.play();
    console.log(this.animationAction);
  };

  _proto.canBeUnregistered = function canBeUnregistered() {
    return false;
  };

  _proto.seek = function seek(percentage) {
    this.animationAction.time = percentage * this.duration;
  };

  _createClass(ThreeAnimation, [{
    key: "name",
    get: function get() {
      return this.animationAction.getClip().name;
    }
  }, {
    key: "duration",
    get: function get() {
      return this.animationAction.getClip().duration;
    }
  }]);

  return ThreeAnimation;
}(AbstractAnimation);

var FbxContentLoader = /*#__PURE__*/function () {
  function FbxContentLoader() {}

  var _proto = FbxContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    var loader = new FBXLoader.FBXLoader();
    var fbxFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
    var contentItemTransformer = new ContentItemTransformer(contentItem);
    loader.load(fbxFileUrl, function (content) {
      var children = content.children;

      if (content.animations && content.animations.length > 0) {
        var mixer = new THREE.AnimationMixer(content);

        for (var _iterator = _createForOfIteratorHelperLoose(content.animations), _step; !(_step = _iterator()).done;) {
          var animation = _step.value;
          var action = mixer.clipAction(animation);
          output.animations.push(new ThreeAnimation(action));
        } // add a dummy object to control the animation


        children.push(new MixerObject(mixer));
      }

      output.objects = output.objects.concat(children);

      for (var _iterator2 = _createForOfIteratorHelperLoose(children), _step2; !(_step2 = _iterator2()).done;) {
        var child = _step2.value;
        contentItemTransformer.apply(child);
      }

      onLoadFinished(undefined, output);
    });
  };

  return FbxContentLoader;
}();

var GltfContentLoader = /*#__PURE__*/function () {
  function GltfContentLoader() {}

  var _proto = GltfContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    // Optional: Provide a DRACOLoader instance to decode compressed mesh data
    var dracoLoader = new DRACOLoader.DRACOLoader();
    dracoLoader.setDecoderPath(dataSource.dracoLoaderPath);
    var ktxLoader = new KTX2Loader.KTX2Loader();
    ktxLoader.setTranscoderPath('assets/basis/');
    var loader = new GLTFLoader.GLTFLoader();
    loader.setDRACOLoader(dracoLoader);
    loader.setKTX2Loader(ktxLoader);
    loader.setMeshoptDecoder(meshopt_decoder_module_js.MeshoptDecoder);
    var gltfFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
    var contentItemTransformer = new ContentItemTransformer(contentItem);
    loader.load(gltfFileUrl, function (content) {
      var mixer = new THREE.AnimationMixer(content.scene);

      for (var _iterator = _createForOfIteratorHelperLoose(content.animations), _step; !(_step = _iterator()).done;) {
        var animation = _step.value;
        var action = mixer.clipAction(animation);
        output.animations.push(new ThreeAnimation(action));
      }

      var children = content.scene.children;

      if (children.length === 1 && children[0].type === 'Object3D') {
        children = children[0].children;
      }

      if (content.animations && content.animations.length > 0) {
        // add a dummy object to control the animation
        children.push(new MixerObject(mixer));
      }

      output.objects = output.objects.concat(children);

      for (var _iterator2 = _createForOfIteratorHelperLoose(children), _step2; !(_step2 = _iterator2()).done;) {
        var child = _step2.value;
        contentItemTransformer.apply(child);
      }

      onLoadFinished(undefined, output);
    });
  };

  return GltfContentLoader;
}();

function _catch$2(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var JSONLoader = /*#__PURE__*/function () {
  function JSONLoader() {}

  /**
   * Loads a remote json file from a given url, parsing into a json object, and throwing and error if it didn't succeed.
   * @param url Location of the json file.
   */
  JSONLoader.loadJsonObject = function loadJsonObject(url) {
    try {
      return Promise.resolve(_catch$2(function () {
        return Promise.resolve(axios__default["default"].get(url)).then(function (res) {
          return typeof res.data !== 'object' ? JSON5__namespace.parse(res.data) : res.data;
        });
      }, function (error) {
        console.error('JSONLOADER', error);
        return error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return JSONLoader;
}();

var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var reversed = function (easing) {
    return function (p) {
        return 1 - easing(1 - p);
    };
};
var mirrored = function (easing) {
    return function (p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var createReversedEasing = reversed;
var createMirroredEasing = mirrored;
var createExpoIn = function (power) {
    return function (p) {
        return Math.pow(p, power);
    };
};
var createBackIn = function (power) {
    return function (p) {
        return p * p * ((power + 1) * p - power);
    };
};
var createAnticipateEasing = function (power) {
    var backEasing = createBackIn(power);
    return function (p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};
var linear = function (p) {
    return p;
};
var easeIn = /*#__PURE__*/createExpoIn(2);
var easeOut = /*#__PURE__*/reversed(easeIn);
var easeInOut = /*#__PURE__*/mirrored(easeIn);
var circIn = function (p) {
    return 1 - Math.sin(Math.acos(p));
};
var circOut = /*#__PURE__*/reversed(circIn);
var circInOut = /*#__PURE__*/mirrored(circOut);
var backIn = /*#__PURE__*/createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = /*#__PURE__*/reversed(backIn);
var backInOut = /*#__PURE__*/mirrored(backIn);
var anticipate = /*#__PURE__*/createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
var ca = 4356.0 / 361.0;
var cb = 35442.0 / 1805.0;
var cc = 16061.0 / 1805.0;
var bounceOut = function (p) {
    var p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < BOUNCE_THIRD_THRESHOLD ? ca * p2 - cb * p + cc : 10.8 * p * p - 20.52 * p + 10.72;
};
var bounceIn = function (p) {
    return 1.0 - bounceOut(1.0 - p);
};
var bounceInOut = function (p) {
    return p < 0.5 ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0)) : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
};
var NEWTON_ITERATIONS = 8;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var K_SPLINE_TABLE_SIZE = 11;
var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
var FLOAT_32_SUPPORTED = typeof Float32Array !== 'undefined';
var a = function (a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var b = function (a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var c = function (a1) {
    return 3.0 * a1;
};
var getSlope = function (t, a1, a2) {
    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
};
var calcBezier = function (t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
};
function cubicBezier(mX1, mY1, mX2, mY2) {
    var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);
    var binarySubdivide = function (aX, aA, aB) {
        var i = 0;
        var currentX;
        var currentT;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            } else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    };
    var newtonRaphsonIterate = function (aX, aGuessT) {
        var i = 0;
        var currentSlope = 0;
        var currentX;
        for (; i < NEWTON_ITERATIONS; ++i) {
            currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) {
                return aGuessT;
            }
            currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    var calcSampleValues = function () {
        for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
            sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
        }
    };
    var getTForX = function (aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = K_SPLINE_TABLE_SIZE - 1;
        var dist = 0.0;
        var guessForT = 0.0;
        var initialSlope = 0.0;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += K_SAMPLE_STEP_SIZE;
        }
        --currentSample;
        dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
        initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) {
            return newtonRaphsonIterate(aX, guessForT);
        } else if (initialSlope === 0.0) {
            return guessForT;
        } else {
            return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
        }
    };
    calcSampleValues();
    var resolver = function (aX) {
        var returnValue;
        if (mX1 === mY1 && mX2 === mY2) {
            returnValue = aX;
        } else if (aX === 0) {
            returnValue = 0;
        } else if (aX === 1) {
            returnValue = 1;
        } else {
            returnValue = calcBezier(getTForX(aX), mY1, mY2);
        }
        return returnValue;
    };
    return resolver;
}

var easingFuncs = {
  __proto__: null,
  reversed: reversed,
  mirrored: mirrored,
  createReversedEasing: createReversedEasing,
  createMirroredEasing: createMirroredEasing,
  createExpoIn: createExpoIn,
  createBackIn: createBackIn,
  createAnticipateEasing: createAnticipateEasing,
  linear: linear,
  easeIn: easeIn,
  easeOut: easeOut,
  easeInOut: easeInOut,
  circIn: circIn,
  circOut: circOut,
  circInOut: circInOut,
  backIn: backIn,
  backOut: backOut,
  backInOut: backInOut,
  anticipate: anticipate,
  bounceOut: bounceOut,
  bounceIn: bounceIn,
  bounceInOut: bounceInOut,
  cubicBezier: cubicBezier
};

function createLine(startPoint, endPoint, thickness, color, easing) {
  if (thickness === void 0) {
    thickness = 1.0;
  }

  if (color === void 0) {
    color = new THREE.Color(0xFFFFFF);
  }

  if (easing === void 0) {
    easing = 'linear';
  }

  var radius = thickness / 2;
  var startVector = toVector3(startPoint);
  var endVector = toVector3(endPoint);
  var numPoints = 10;
  var path = createPath(startVector, endVector, numPoints, easing);
  var material = new THREE.MeshBasicMaterial({
    color: color,
    depthTest: false,
    side: THREE.DoubleSide
  });
  var tubularSegments = numPoints;
  var radialSegments = 10;
  var tubeGeometry = new THREE.TubeGeometry(path, tubularSegments, radius, radialSegments, false); //top cap

  var topCapGeometry = new THREE.SphereGeometry(radius, radialSegments, radialSegments);
  var topCapMesh = new THREE.Mesh(topCapGeometry, material);
  topCapMesh.position.copy(startVector); //end cap

  var endCapGeometry = new THREE.SphereGeometry(radius, radialSegments, radialSegments);
  var endCapMesh = new THREE.Mesh(endCapGeometry, material);
  endCapMesh.position.copy(endVector);
  var lineTubeMesh = new THREE.Mesh(tubeGeometry, material);
  lineTubeMesh.add(topCapMesh);
  lineTubeMesh.add(endCapMesh);
  return lineTubeMesh;
}

function createPath(startVector, endVector, numPoints, easing) {
  var midPoints = [];
  var easingFunction = easingFuncs[easing];

  for (var i = 0; i < numPoints; i++) {
    var fraction = i / numPoints;
    var offset = easingFunction(fraction);
    var yValue = startVector.y + (endVector.y - startVector.y) * offset;
    var midPoint = new THREE.Vector3().lerpVectors(startVector, endVector, fraction).setY(yValue);
    midPoints.push(midPoint);
  }

  return new THREE.CatmullRomCurve3([startVector].concat(midPoints, [endVector]));
}

var events = require('events'); // patterns


var isHex = /^#?([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
var isHSL = /^hsl?\((\d{0,3}),\s*(\d{1,3})%,\s*(\d{1,3})%\)$/;
var isHSLA = /^hsla?\((\d{0,3}),\s*(\d{1,3})%,\s*(\d{1,3})%,\s*([01](\.\d+)*)\)$/;
var isRGB = /^rgb?\((\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?)\)$/;
var isRGBA = /^rgba?\((\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?),\s*([01]?\.?\d*)\)$/;
var isPercent = /^\d+(\.\d+)*%$/;
var hexBit = /([0-9a-f])/gi;
var leadHex = /^#/;
var matchHSL = /^hsl?\((\d{0,3}),\s*(\d{1,3})%,\s*(\d{1,3})%\)$/;
var matchHSLA = /^hsla?\((\d{0,3}),\s*(\d{1,3})%,\s*(\d{1,3})%,\s*([01](\.\d+)*)\)$/;
var matchRGB = /^rgb?\((\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?)\)$/;
var matchRGBA = /^rgba?\((\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?),\s*([01]?\.?\d*)\)$/;

var Color = /*#__PURE__*/function () {
  function Color(value) {
    // Event Management
    this.listeners = {};
    this._value = 0;
    this._hex = '#000000';
    this._red = 0; // 0 - 255

    this._green = 0; // 0 - 255

    this._blue = 0; // 0 - 255

    this._hue = 0; // 0 - 360

    this._saturation = 0; // 0 - 100

    this._lightness = 0; // 0 - 100

    this._brightness = 0; // 0 - 100

    this._alpha = 1; // 0 - 1

    this.output = 0;
    this.subscribe(Color.Events.RGB_UPDATED, this.RGBUpdated);
    this.subscribe(Color.Events.HEX_UPDATED, this.HEXUpdated);
    this.subscribe(Color.Events.HSL_UPDATED, this.HSLUpdated);
    this.subscribe(Color.Events.HSV_UPDATED, this.HSVUpdated);
    this.subscribe(Color.Events.INT_UPDATED, this.INTUpdated);
    this.parse(value);
  } // helpers


  Color.absround = function absround(number) {
    return number << 0;
  };

  Color.hue2rgb = function hue2rgb(a, b, c) {
    // http://www.w3.org/TR/css3-color/#hsl-color
    if (c < 0) c += 1;
    if (c > 1) c -= 1;
    if (c < 1 / 6) return a + (b - a) * 6 * c;
    if (c < 1 / 2) return b;
    if (c < 2 / 3) return a + (b - a) * (2 / 3 - c) * 6;
    return a;
  };

  Color.perc2value = function perc2value(p) {
    return isPercent.test(p) ? Color.absround(parseInt(p) * 2.55) : p;
  };

  var _proto = Color.prototype;

  _proto.parse = function parse(value) {
    if (typeof value === 'undefined') {
      return this;
    }

    switch (true) {
      case isFinite(value):
        return this.value(value);

      case value instanceof Color:
        return this.copy(value);

      case isHex.test(value):
        {
          var stripped = value.replace(leadHex, '');

          if (stripped.length === 3) {
            stripped = stripped.replace(hexBit, '$1$1');
          } else if (stripped.length === 8) {
            var alphaHex = parseInt(stripped.substr(6), 16);
            stripped = stripped.substr(0, 6);
            this.alpha(alphaHex / 255);
          }

          return this.value(parseInt(stripped, 16));
        }

      case isRGBA.test(value):
        {
          var parts = value.match(matchRGBA);
          this.red(Color.perc2value(parts[1]));
          this.green(Color.perc2value(parts[2]));
          this.blue(Color.perc2value(parts[3]));
          this.alpha(parseFloat(parts[4]));
          return this.value();
        }

      case isRGB.test(value):
        {
          var _parts = value.match(matchRGB);

          this.red(Color.perc2value(_parts[1]));
          this.green(Color.perc2value(_parts[2]));
          this.blue(Color.perc2value(_parts[3]));
          this.alpha(1);
          return this.value();
        }

      case isHSLA.test(value):
        {
          // http://www.w3.org/TR/css3-color/#hsl-color
          var _parts2 = value.match(matchHSLA);

          this.hue(parseInt(_parts2[1]));
          this.saturation(parseInt(_parts2[2]));
          this.lightness(parseInt(_parts2[3]));
          this.alpha(parseInt(_parts2[4]) || 1);
          return this.value();
        }

      case isHSL.test(value):
        {
          // http://www.w3.org/TR/css3-color/#hsl-color
          var _parts3 = value.match(matchHSL);

          this.hue(parseInt(_parts3[1]));
          this.saturation(parseInt(_parts3[2]));
          this.lightness(parseInt(_parts3[3]));
          this.alpha(1);
          return this.value();
        }

      case Object.prototype.hasOwnProperty.call(Color.namedColors, value):
        {
          value = Color.namedColors[value];

          var _stripped = value.replace(leadHex, '');

          return this.value(parseInt(_stripped, 16));
        }

      case typeof value === 'object':
        return this.set(value);
    }

    return this;
  };

  _proto.clone = function clone() {
    return new Color(this.value());
  };

  _proto.copy = function copy(color) {
    return this.set(color.value());
  };

  _proto.set = function set(key, value) {
    if (arguments.length === 1) {
      if (typeof key === 'object') {
        for (var p in key) {
          if (typeof this[p] === 'function') {
            this[p](key[p]);
          }
        }
      } else if (isFinite(key)) {
        this.value(key);
      }
    } else if (typeof this[key] === 'function') {
      this[key](value);
    }

    return this;
  };

  _proto.toValue = function toValue() {
    return this._value;
  };

  _proto.interpolate = function interpolate(v, f) {
    if (!(v instanceof Color)) {
      v = new Color(v);
    }

    this._red = this._red + (v._red - this._red) * f;
    this._green = this._green + (v._green - this._green) * f;
    this._blue = this._blue + (v._blue - this._blue) * f;
    this.broadcast(events.RGB_UPDATED);
    return this;
  };

  _proto.RGB2HSL = function RGB2HSL() {
    var r = this._red / 255;
    var g = this._green / 255;
    var b = this._blue / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var l = (max + min) / 2;
    var v = max;

    if (max === min) {
      this._hue = 0;
      this._saturation = 0;
      this._lightness = Color.absround(l * 100);
      this._brightness = Color.absround(v * 100);
      return;
    }

    var d = max - min;
    var s = d / (l <= 0.5 ? max + min : 2 - max - min);
    var h = (max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4) / 6;
    this._hue = Color.absround(h * 360);
    this._saturation = Color.absround(s * 100);
    this._lightness = Color.absround(l * 100);
    this._brightness = Color.absround(v * 100);
  };

  _proto.HSL2RGB = function HSL2RGB() {
    var h = this._hue / 360;
    var s = this._saturation / 100;
    var l = this._lightness / 100;
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    this._red = Color.absround(Color.hue2rgb(p, q, h + 1 / 3) * 255);
    this._green = Color.absround(Color.hue2rgb(p, q, h) * 255);
    this._blue = Color.absround(Color.hue2rgb(p, q, h - 1 / 3) * 255);
  };

  _proto.HSV2RGB = function HSV2RGB() {
    // http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
    var h = this._hue / 360;
    var s = this._saturation / 100;
    var v = this._brightness / 100;
    var r = 0;
    var g = 0;
    var b = 0;
    var i = Color.absround(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0:
        r = v;
        g = t;
        b = p;
        break;

      case 1:
        r = q;
        g = v;
        b = p;
        break;

      case 2:
        r = p;
        g = v;
        b = t;
        break;

      case 3:
        r = p;
        g = q;
        b = v;
        break;

      case 4:
        r = t;
        g = p;
        b = v;
        break;

      case 5:
        r = v;
        g = p;
        b = q;
        break;
    }

    this._red = Color.absround(r * 255);
    this._green = Color.absround(g * 255);
    this._blue = Color.absround(b * 255);
  };

  _proto.INT2HEX = function INT2HEX() {
    var x = this._value.toString(16);

    x = '000000'.substr(0, 6 - x.length) + x;
    this._hex = '#' + x.toUpperCase();
  };

  _proto.INT2RGB = function INT2RGB() {
    this._red = this._value >> 16;
    this._green = this._value >> 8 & 0xff;
    this._blue = this._value & 0xff;
  };

  _proto.HEX2INT = function HEX2INT() {
    this._value = parseInt(this._hex, 16);
  };

  _proto.RGB2INT = function RGB2INT() {
    this._value = this._red << 16 | this._green << 8 & 0xffff | this._blue;
  };

  _proto.RGBUpdated = function RGBUpdated() {
    this.RGB2INT(); // populate INT values

    this.RGB2HSL(); // populate HSL values

    this.INT2HEX(); // populate HEX values
  };

  _proto.HSLUpdated = function HSLUpdated() {
    this.HSL2RGB(); // populate RGB values

    this.RGB2INT(); // populate INT values

    this.INT2HEX(); // populate HEX values
  };

  _proto.HSVUpdated = function HSVUpdated() {
    this.HSV2RGB(); // populate RGB values

    this.RGB2INT(); // populate INT values

    this.INT2HEX(); // populate HEX values
  };

  _proto.HEXUpdated = function HEXUpdated() {
    this.HEX2INT(); // populate INT values

    this.INT2RGB(); // populate RGB values

    this.RGB2HSL(); // populate HSL values
  };

  _proto.INTUpdated = function INTUpdated() {
    this.INT2RGB(); // populate RGB values

    this.RGB2HSL(); // populate HSL values

    this.INT2HEX(); // populate HEX values
  };

  _proto.value = function value(_value) {
    return this._handle('_value', _value, Color.Events.INT_UPDATED);
  };

  _proto.hex = function hex(value) {
    return this._handle('_hex', value, Color.Events.HEX_UPDATED);
  };

  _proto.red = function red(value) {
    return this._handle('_red', value, Color.Events.RGB_UPDATED);
  };

  _proto.green = function green(value) {
    return this._handle('_green', value, Color.Events.RGB_UPDATED);
  };

  _proto.blue = function blue(value) {
    return this._handle('_blue', value, Color.Events.RGB_UPDATED);
  };

  _proto.hue = function hue(value) {
    return this._handle('_hue', value, Color.Events.HSL_UPDATED);
  };

  _proto.saturation = function saturation(value) {
    return this._handle('_saturation', value, Color.Events.HSL_UPDATED);
  };

  _proto.lightness = function lightness(value) {
    return this._handle('_lightness', value, Color.Events.HSL_UPDATED);
  };

  _proto.brightness = function brightness(value) {
    return this._handle('_brightness', value, Color.Events.HSV_UPDATED);
  };

  _proto.alpha = function alpha(value) {
    return this._handle('_alpha', value);
  };

  _proto._handle = function _handle(prop, value, event) {
    if (typeof this[prop] !== 'undefined') {
      if (typeof value !== 'undefined') {
        if (value !== this[prop]) {
          this[prop] = value;

          if (event) {
            this.broadcast(event);
          }
        }
      }
    }

    return this[prop];
  } // convert to CSS values
  ;

  _proto.getHex = function getHex() {
    return this._hex;
  };

  _proto.getAlpha = function getAlpha() {
    return this._alpha;
  };

  _proto.getRGB = function getRGB() {
    var components = [Color.absround(this._red), Color.absround(this._green), Color.absround(this._blue)];
    return 'rgb(' + components.join(', ') + ')';
  };

  _proto.getThreeColor = function getThreeColor() {
    return new THREE.Color(this._hex);
  };

  _proto.getPRGB = function getPRGB() {
    var components = [Color.absround(this._red / 255) + '%', Color.absround(this._green / 255) + '%', Color.absround(this._blue / 255) + '%'];
    return 'rgb(' + components.join(', ') + ')';
  };

  _proto.getRGBA = function getRGBA() {
    var components = [Color.absround(this._red), Color.absround(this._green), Color.absround(this._blue), this._alpha];
    return 'rgba(' + components.join(', ') + ')';
  };

  _proto.getPRGBA = function getPRGBA() {
    var components = [Color.absround(this._red / 255) + '%', Color.absround(this._green / 255) + '%', Color.absround(this._blue / 255) + '%', this._alpha];
    return 'rgba(' + components.join(', ') + ')';
  };

  _proto.getHSL = function getHSL() {
    var components = [Color.absround(this._hue), Color.absround(this._saturation) + '%', Color.absround(this._lightness) + '%'];
    return 'hsl(' + components.join(', ') + ')';
  };

  _proto.getHSLA = function getHSLA() {
    var components = [Color.absround(this._hue), Color.absround(this._saturation) + '%', Color.absround(this._lightness) + '%', this._alpha];
    return 'hsla(' + components.join(', ') + ')';
  };

  _proto.format = function format(string) {
    var tokens = {
      r: this._red,
      g: this._green,
      b: this._blue,
      h: this._hue,
      s: this._saturation,
      l: this._lightness,
      v: this._brightness,
      a: this._alpha,
      x: this._hex,
      i: this._value
    };

    for (var token in tokens) {
      string = string.split('%' + token + '%').join(tokens[token]);
    }

    return string;
  };

  _proto.toString = function toString() {
    switch (this.output) {
      case 0:
        // Color.HEX
        return this.getHex();

      case 1:
        // Color.RGB
        return this.getRGB();

      case 2:
        // Color.PRGB
        return this.getPRGB();

      case 3:
        // Color.RGBA
        return this.getRGBA();

      case 4:
        // Color.PRGBA
        return this.getPRGBA();

      case 5:
        // Color.HSL
        return this.getHSL();

      case 6:
        // Color.HSLA
        return this.getHSLA();
    }
  };

  _proto.isSubscribed = function isSubscribed(type) {
    return this.listeners[type] != null;
  };

  _proto.subscribe = function subscribe(type, callback) {
    if (!this.isSubscribed(type)) {
      this.listeners[type] = [];
    }

    this.listeners[type].push(callback);
  };

  _proto.unsubscribe = function unsubscribe(type, callback) {
    if (!this.isSubscribed(type)) {
      return;
    }

    var stack = this.listeners[type];

    for (var i = 0; i < stack.length; i++) {
      if (stack[i] === callback) {
        stack.splice(i, 1);
        return this.unsubscribe(type, callback);
      }
    }
  };

  _proto.broadcast = function broadcast(type, params) {
    if (!this.isSubscribed(type)) {
      return;
    }

    var stack = this.listeners[type];
    var l = stack.length;

    for (var i = 0; i < l; i++) {
      stack[i].apply(this, params);
    }
  };

  return Color;
}();
Color.Events = {
  RGB_UPDATED: 'RGBUpdated',
  HSL_UPDATED: 'HSLUpdated',
  HSV_UPDATED: 'HSVUpdated',
  HEX_UPDATED: 'HexUpdated',
  INT_UPDATED: 'IntUpdated'
};
Color.namedColors = {
  transparent: 'rgba(0, 0, 0, 0)',
  aliceblue: '#F0F8FF',
  antiquewhite: '#FAEBD7',
  aqua: '#00FFFF',
  aquamarine: '#7FFFD4',
  azure: '#F0FFFF',
  beige: '#F5F5DC',
  bisque: '#FFE4C4',
  black: '#000000',
  blanchedalmond: '#FFEBCD',
  blue: '#0000FF',
  blueviolet: '#8A2BE2',
  brown: '#A52A2A',
  burlywood: '#DEB887',
  cadetblue: '#5F9EA0',
  chartreuse: '#7FFF00',
  chocolate: '#D2691E',
  coral: '#FF7F50',
  cornflowerblue: '#6495ED',
  cornsilk: '#FFF8DC',
  crimson: '#DC143C',
  cyan: '#00FFFF',
  darkblue: '#00008B',
  darkcyan: '#008B8B',
  darkgoldenrod: '#B8860B',
  darkgray: '#A9A9A9',
  darkgrey: '#A9A9A9',
  darkgreen: '#006400',
  darkkhaki: '#BDB76B',
  darkmagenta: '#8B008B',
  darkolivegreen: '#556B2F',
  darkorange: '#FF8C00',
  darkorchid: '#9932CC',
  darkred: '#8B0000',
  darksalmon: '#E9967A',
  darkseagreen: '#8FBC8F',
  darkslateblue: '#483D8B',
  darkslategray: '#2F4F4F',
  darkslategrey: '#2F4F4F',
  darkturquoise: '#00CED1',
  darkviolet: '#9400D3',
  deeppink: '#FF1493',
  deepskyblue: '#00BFFF',
  dimgray: '#696969',
  dimgrey: '#696969',
  dodgerblue: '#1E90FF',
  firebrick: '#B22222',
  floralwhite: '#FFFAF0',
  forestgreen: '#228B22',
  fuchsia: '#FF00FF',
  gainsboro: '#DCDCDC',
  ghostwhite: '#F8F8FF',
  gold: '#FFD700',
  goldenrod: '#DAA520',
  gray: '#808080',
  grey: '#808080',
  green: '#008000',
  greenyellow: '#ADFF2F',
  honeydew: '#F0FFF0',
  hotpink: '#FF69B4',
  indianred: '#CD5C5C',
  indigo: '#4B0082',
  ivory: '#FFFFF0',
  khaki: '#F0E68C',
  lavender: '#E6E6FA',
  lavenderblush: '#FFF0F5',
  lawngreen: '#7CFC00',
  lemonchiffon: '#FFFACD',
  lightblue: '#ADD8E6',
  lightcoral: '#F08080',
  lightcyan: '#E0FFFF',
  lightgoldenrodyellow: '#FAFAD2',
  lightgray: '#D3D3D3',
  lightgrey: '#D3D3D3',
  lightgreen: '#90EE90',
  lightpink: '#FFB6C1',
  lightsalmon: '#FFA07A',
  lightseagreen: '#20B2AA',
  lightskyblue: '#87CEFA',
  lightslategray: '#778899',
  lightslategrey: '#778899',
  lightsteelblue: '#B0C4DE',
  lightyellow: '#FFFFE0',
  lime: '#00FF00',
  limegreen: '#32CD32',
  linen: '#FAF0E6',
  magenta: '#FF00FF',
  maroon: '#800000',
  mediumaquamarine: '#66CDAA',
  mediumblue: '#0000CD',
  mediumorchid: '#BA55D3',
  mediumpurple: '#9370D8',
  mediumseagreen: '#3CB371',
  mediumslateblue: '#7B68EE',
  mediumspringgreen: '#00FA9A',
  mediumturquoise: '#48D1CC',
  mediumvioletred: '#C71585',
  midnightblue: '#191970',
  mintcream: '#F5FFFA',
  mistyrose: '#FFE4E1',
  moccasin: '#FFE4B5',
  navajowhite: '#FFDEAD',
  navy: '#000080',
  oldlace: '#FDF5E6',
  olive: '#808000',
  olivedrab: '#6B8E23',
  orange: '#FFA500',
  orangered: '#FF4500',
  orchid: '#DA70D6',
  palegoldenrod: '#EEE8AA',
  palegreen: '#98FB98',
  paleturquoise: '#AFEEEE',
  palevioletred: '#D87093',
  papayawhip: '#FFEFD5',
  peachpuff: '#FFDAB9',
  peru: '#CD853F',
  pink: '#FFC0CB',
  plum: '#DDA0DD',
  powderblue: '#B0E0E6',
  purple: '#800080',
  red: '#FF0000',
  rosybrown: '#BC8F8F',
  royalblue: '#4169E1',
  saddlebrown: '#8B4513',
  salmon: '#FA8072',
  sandybrown: '#F4A460',
  seagreen: '#2E8B57',
  seashell: '#FFF5EE',
  sienna: '#A0522D',
  silver: '#C0C0C0',
  skyblue: '#87CEEB',
  slateblue: '#6A5ACD',
  slategray: '#708090',
  slategrey: '#708090',
  snow: '#FFFAFA',
  springgreen: '#00FF7F',
  steelblue: '#4682B4',
  tan: '#D2B48C',
  teal: '#008080',
  thistle: '#D8BFD8',
  tomato: '#FF6347',
  turquoise: '#40E0D0',
  violet: '#EE82EE'
};
Color.HEX = 0; // toString returns hex: #ABC123

Color.RGB = 1; // toString returns rgb: rgb(0, 100, 255)

Color.PRGB = 2; // toString returns percent rgb: rgb(0%, 40%, 100%)

Color.RGBA = 3; // toString returns rgba: rgba(0, 100, 255, 0.5)

Color.PRGBA = 4; // toString returns percent rgba: rgba(0%, 40%, 100%, 0.5)

Color.HSL = 5; // toString returns hsl: hsl(360, 50%, 50%)

Color.HSLA = 6; // toString returns hsla: hsla(360, 50%, 50%, 0.5)

var loadRGBETextureAsync = function loadRGBETextureAsync(texturePath) {
  try {
    return Promise.resolve(new Promise(function (resolve, reject) {
      var rgbeLoader = new RGBELoader.RGBELoader();
      rgbeLoader.setDataType(THREE.UnsignedByteType);
      rgbeLoader.crossOrigin = '';
      rgbeLoader.load(texturePath, function (texture) {
        resolve(texture);
      }, undefined, function (error) {
        reject(error);
      });
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var loadTextureAsync = function loadTextureAsync(texturePath) {
  try {
    return Promise.resolve(new Promise(function (resolve, reject) {
      var textureLoader = new THREE.TextureLoader();
      textureLoader.crossOrigin = '';
      textureLoader.load(texturePath, function (texture) {
        resolve(texture);
      }, undefined, function (error) {
        console.error('Error loading texture path ' + texturePath, error);
        reject(error);
      });
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

// #endregion TextEffectItem
function drawText(effect, context, size) {
  var _effect$position$x, _effect$position, _effect$position$y, _effect$position2, _effect$font, _effect$text;

  var x = (_effect$position$x = (_effect$position = effect.position) == null ? void 0 : _effect$position.x) != null ? _effect$position$x : size.width / 2;
  var y = (_effect$position$y = (_effect$position2 = effect.position) == null ? void 0 : _effect$position2.y) != null ? _effect$position$y : size.height / 2;
  context.font = (_effect$font = effect.font) != null ? _effect$font : 'Bold 20px Arial';
  context.fillText((_effect$text = effect.text) != null ? _effect$text : "Text", x, y);
}

var effectDrawers = {
  text: drawText
};
function drawEffect(effect, context, size) {
  if (!effect.type) throw new Error("Effect 'type' is missing. Should be any of the options: " + Object.keys(effectDrawers).join(",") + ".");
  var effectDrawFunc = effectDrawers[effect.type];
  if (!effectDrawFunc) throw new Error("Effect '" + effect.type + " is not valid.");
  if (effect.color) context.fillStyle = new Color(effect.color).getHex();
  effectDrawFunc(effect, context, size);
}

var textureLoader = new THREE.TextureLoader();
textureLoader.crossOrigin = ''; // #endregion LineOptions

var SpecialSprite = /*#__PURE__*/function (_Group) {
  _inheritsLoose(SpecialSprite, _Group);

  function SpecialSprite(path, options, callback) {
    var _options$position, _options$center$x, _options$center, _options$center$y, _options$center2;

    var _this;

    _this = _Group.call(this) || this;
    _this.color = new THREE.Color(0xFFFFFF);
    _this.sprite = new THREE.Sprite();
    _this.transparentSprite = new THREE.Sprite();
    _this.loadedTextures = new Map();
    var position = toVector3((_options$position = options.position) != null ? _options$position : new THREE.Vector3(0, 0, 0));

    _this.position.copy(position);

    var scale = options.scale || 1;
    _this.relative = options.relative;
    _this.minSize = options.minSize;
    _this.maxSize = options.maxSize;
    _this.effects = options.effects;
    _this.sprite.center = new THREE.Vector2((_options$center$x = (_options$center = options.center) == null ? void 0 : _options$center.x) != null ? _options$center$x : 0, (_options$center$y = (_options$center2 = options.center) == null ? void 0 : _options$center2.y) != null ? _options$center$y : 0);

    _this.loadMaterialsAsync(path, scale, position, callback, options);

    return _this;
  }

  var _proto = SpecialSprite.prototype;

  _proto.loadMaterialsAsync = function loadMaterialsAsync(path, scale, position, callback, options) {
    try {
      var _this3 = this;

      return Promise.resolve(_this3.loadTextureWithEffects(path)).then(function (spriteTexture) {
        _this3.loadBoundingBox(spriteTexture, scale, position);

        _this3.sprite.material = new THREE.SpriteMaterial({
          map: spriteTexture,
          sizeAttenuation: true,
          depthTest: options.line == null
        });
        _this3.sprite.material.color = _this3.color;

        _this3.add(_this3.sprite);

        _this3.loadTransparentSprite(spriteTexture);

        _this3.loadOffset(options.offset);

        _this3.loadLine(options.line);

        callback(_this3);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadTextureWithEffects = function loadTextureWithEffects(path) {
    try {
      var _this5 = this;

      var existingTexture = _this5.loadedTextures.get(path);

      if (existingTexture) {
        return Promise.resolve(existingTexture);
      }

      return Promise.resolve(loadTextureAsync(path)).then(function (newTexture) {
        if (_this5.effects) {
          var canvas = document.createElement('canvas');
          canvas.width = newTexture.image.width;
          canvas.height = newTexture.image.height;
          var context = canvas.getContext('2d');
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(newTexture.image, 0, 0);

          for (var _iterator = _createForOfIteratorHelperLoose(_this5.effects), _step; !(_step = _iterator()).done;) {
            var effect = _step.value;
            drawEffect(effect, context, {
              width: canvas.width,
              height: canvas.height
            });
          } // Draw a rectangle
          //context.fillStyle = "rgba(255, 0, 0, 0.5)";
          //context.fillStyle = '#ff0000';
          //context.fillRect(0, 0, canvas.width, canvas.height); // Draw the rectangle


          newTexture = new THREE.CanvasTexture(canvas);
        }

        _this5.loadedTextures.set(path, newTexture);

        return newTexture;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadTransparentSprite = function loadTransparentSprite(spriteMap) {
    this.transparentSprite.center = this.sprite.center.clone();
    this.transparentSprite.material = new THREE.SpriteMaterial({
      map: spriteMap,
      opacity: 0.3,
      depthTest: false,
      sizeAttenuation: true
    });
    this.transparentSprite.material.color = this.color;
    this.sprite.add(this.transparentSprite);
  }
  /**
   * We override the raycast, since we want the test if the ray hists the first sprite. If it
   * does, we consider that this specialSprite is the one that hit it.
   * @param raycaster
   * @param intersects
   */
  ;

  _proto.raycast = function raycast(raycaster, intersects) {
    var intersections = [];
    this.sprite.raycast(raycaster, intersections);

    if (intersections.length > 0) {
      var intersection = intersections.pop();
      intersection.object = this;
      intersects.push(intersection);
    }
  };

  _proto.loadOffset = function loadOffset(offset) {
    if (offset) {
      var offsetVector = toVector3(offset);

      if (offsetVector.lengthSq() > 0) {
        var targetVector = new THREE.Vector3(0, 0, 0).clone().sub(offsetVector);
        this.add(createLine(new THREE.Vector3(0, 0, 0), targetVector));
      }
    }
  };

  _proto.loadLine = function loadLine(line) {
    if (line) {
      var _line$target, _line$sourceDistance;

      var absoluteTarget = toVector3((_line$target = line.target) != null ? _line$target : {
        x: 0,
        y: 0,
        z: 0
      });
      var start = new THREE.Vector3(0, 0, 0);
      var end = absoluteTarget.clone().sub(this.position);
      var direction = end.clone().normalize(); //we can offset the starting point

      if (((_line$sourceDistance = line.sourceDistance) != null ? _line$sourceDistance : 0) > 0) {
        start = direction.clone().multiplyScalar(line.sourceDistance);
      }

      if (end.lengthSq() > 0) {
        var _line$color;

        var color = new Color((_line$color = line.color) != null ? _line$color : '#FFFFFF').getThreeColor();
        this.add(createLine(start, end, line.thickness, color, line.easing));
      }
    }
  };

  _proto.loadBoundingBox = function loadBoundingBox(spriteTexture, scale, position) {
    var width = spriteTexture.image.width;
    var height = spriteTexture.image.height;
    this.sprite.scale.set(width * scale, height * scale, 1);
    this.originalScale = this.scale.clone();
    var maxComponent = Math.max(this.sprite.scale.x, this.sprite.scale.y);
    var vector2 = this.sprite.center.clone().multiply(new THREE.Vector2(this.sprite.scale.x, this.sprite.scale.y));
    var vector3 = new THREE.Vector3(position.x, position.y, position.z);
    var minPosition = vector3.clone().sub(new THREE.Vector3(vector2.x, vector2.y, maxComponent / 2));
    var maxPosition = minPosition.clone().add(new THREE.Vector3(maxComponent, maxComponent, maxComponent));
    this.boundingBox = new THREE.Box3(minPosition, maxPosition);
  };

  _proto.setMap = function setMap(path) {
    var _this6 = this;

    this.loadTextureWithEffects(path).then(function (loadedTexture) {
      _this6.sprite.material.map = loadedTexture;
      _this6.transparentSprite.material.map = loadedTexture;
    });
  };

  return SpecialSprite;
}(THREE.Group);

var MarkerContentLoader = /*#__PURE__*/function () {
  function MarkerContentLoader() {}

  var _proto = MarkerContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    try {
      output.objects = output.objects || [];
      var fullUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
      var contentItemTransformer = new ContentItemTransformer(contentItem);
      return Promise.resolve(JSONLoader.loadJsonObject(fullUrl)).then(function (data) {
        var resources = data.resources;
        var promise = Promise.resolve();

        var _loop = function _loop(key) {
          var marker = data.markers[key];
          promise = promise.then(function () {
            return new Promise(function (resolve) {
              if (marker.resource) {
                var resource = resources[marker.resource];
                var options = {
                  normalImagePath: PathHelper.getFullUrl(dataSource.url, resource.normal),
                  hoveredImagePath: PathHelper.getFullUrl(dataSource.url, resource.hovered),
                  selectedImagePath: PathHelper.getFullUrl(dataSource.url, resource.selected),
                  disabledImagePath: PathHelper.getFullUrl(dataSource.url, resource.disabled)
                };
                new SpecialSprite(options.normalImagePath, marker, function (sprite) {
                  sprite.name = marker.name || '';
                  var anySprite = sprite;
                  anySprite.options = options;
                  contentItemTransformer.apply(sprite);
                  output.objects.push(sprite);
                  resolve();
                });
              }
            });
          });
        };

        for (var key in data.markers) {
          _loop(key);
        }

        promise.then(function () {
          onLoadFinished(undefined, output);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return MarkerContentLoader;
}();

var SkinContentLoader = /*#__PURE__*/function () {
  function SkinContentLoader() {}

  var _proto = SkinContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    try {
      var skinsFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
      return Promise.resolve(JSONLoader.loadJsonObject(skinsFileUrl)).then(function (data) {
        output.skins = Object.assign({}, output.skins, data);
        onLoadFinished(undefined, output);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return SkinContentLoader;
}();

var ChromaKeyMaterial = /*#__PURE__*/function (_ShaderMaterial) {
  _inheritsLoose(ChromaKeyMaterial, _ShaderMaterial);

  function ChromaKeyMaterial(url, keyColor) {
    var _this;

    _this = _ShaderMaterial.call(this) || this;
    _this.video = void 0;
    _this.keyColorObject = void 0;
    _this.videoTexture = void 0;
    _this.video = document.createElement('video');
    _this.video.muted = true;
    _this.video.crossOrigin = '*';
    _this.video.loop = true;
    _this.video.src = url;

    _this.video.load();

    _this.keyColorObject = new THREE.Color(keyColor);
    _this.videoTexture = new THREE.Texture(_this.video);
    _this.videoTexture.name = url;
    _this.videoTexture.minFilter = THREE.LinearFilter;
    _this.videoTexture.magFilter = THREE.LinearFilter;

    _this.setValues({
      uniforms: {
        theTexture: {
          type: 't',
          value: _this.videoTexture
        },
        color: {
          type: 'c',
          value: _this.keyColorObject
        }
      },
      vertexShader: "varying mediump vec2 vUv; void main(void) {\n        vUv = uv;\n        mediump vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n        gl_Position = projectionMatrix * mvPosition;\n      }",
      fragmentShader: "\n        uniform mediump sampler2D theTexture;\n        uniform mediump vec3 color;\n        varying mediump vec2 vUv;\n        void main(void) {\n          mediump vec3 tColor = texture2D( theTexture, vUv ).rgb;\n          mediump float a = (length(tColor - color) - 0.5) * 7.0;\n          gl_FragColor = vec4(tColor, a);\n        }",
      transparent: true
    });

    return _this;
  }

  var _proto = ChromaKeyMaterial.prototype;

  _proto.startVideo = function startVideo() {
    this.video.play();
  };

  _proto.stopVideo = function stopVideo() {
    this.video.pause();
    this.video.src = '';
  };

  _proto.update = function update() {
    if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
      // videoImageContext.drawImage(video, 0, 0);
      if (this.videoTexture) {
        this.videoTexture.needsUpdate = true;
        return true;
      }
    }
  };

  _proto.toggleEnabled = function toggleEnabled(newStatus) {
    if (newStatus) {
      this.video.play();
    } else {
      this.video.pause();
    }
  };

  _proto.dispose = function dispose() {
    _ShaderMaterial.prototype.dispose.call(this); // some browsers (Firefox for example) will cache in memory the video buffer when autoplay property is on.
    // so we need to remove the video before removing it


    this.video.pause();
    this.video.remove();
  };

  return ChromaKeyMaterial;
}(THREE.ShaderMaterial); // export const ChromaKeyMaterial = function (url, keyColor) {

var VideoContentLoader = /*#__PURE__*/function () {
  function VideoContentLoader() {}

  var _proto = VideoContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    try {
      var videosFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
      return Promise.resolve(JSONLoader.loadJsonObject(videosFileUrl)).then(function (data) {
        for (var videoEntry in data) {
          var value = data[videoEntry];

          var _loop = function _loop() {
            var obj = _step.value;

            if (obj instanceof THREE.Mesh && obj.name === videoEntry) {
              var videoUrl = PathHelper.getFullUrl(dataSource.url, value.path);
              obj.material = new ChromaKeyMaterial(videoUrl, value.chromaKey);
              obj.material.startVideo(); // add support for object disposal

              var anyObject = obj;

              anyObject.dispose = function () {
                obj.material.dispose();
              };

              anyObject.toggleEnabled = function (newState) {
                obj.material.toggleEnabled(newState);
              };
            }
          };

          for (var _iterator = _createForOfIteratorHelperLoose(output.objects), _step; !(_step = _iterator()).done;) {
            _loop();
          }
        }

        onLoadFinished(undefined, output);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return VideoContentLoader;
}();

function _catch$1(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var LightContentLoader = /*#__PURE__*/function () {
  function LightContentLoader() {
    this.lightTypes = {
      Point: function Point() {
        return new THREE.PointLight();
      },
      Directional: function Directional() {
        return new THREE.DirectionalLight();
      },
      Spot: function Spot() {
        return new THREE.SpotLight();
      },
      Ambient: function Ambient() {
        return new THREE.AmbientLight();
      }
    };
    this.debugHelperTypes = {
      Point: function Point(light) {
        return new THREE.PointLightHelper(light, 10);
      },
      Directional: function Directional(light) {
        return new THREE.DirectionalLightHelper(light, 10);
      },
      Spot: function Spot(light) {
        return new THREE.SpotLightHelper(light);
      }
    };
  }

  var _proto = LightContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    try {
      var _this2 = this;

      var lightsFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
      var contentItemTransformer = new ContentItemTransformer(contentItem);

      var _temp2 = _catch$1(function () {
        return Promise.resolve(JSONLoader.loadJsonObject(lightsFileUrl)).then(function (data) {
          for (var lightName in data) {
            var _lightData$intensity;

            var lightData = data[lightName];
            var type = lightData.type || 'Point';

            var light = _this2.lightTypes[type]();

            light.name = lightName;
            light.color = new THREE.Color(lightData.color || 0xffffff);
            light.intensity = (_lightData$intensity = lightData.intensity) != null ? _lightData$intensity : 1;
            light.position.copy(toVector3(lightData.position || {
              x: 0,
              y: 0,
              z: 0
            }));

            if (lightData.target) {
              var targetObject = new THREE.Object3D();
              targetObject.position.copy(toVector3(lightData.target || {
                x: 0,
                y: 0,
                z: 0
              }));
              output.objects.push(targetObject);
              light['target'] = targetObject;
              light['target'].updateMatrixWorld();
            }

            if (lightData.debug) {
              var debugHelperType = _this2.debugHelperTypes[type];

              if (debugHelperType) {
                var debugHelper = debugHelperType(light);
                output.objects.push(debugHelper);
              }
            }

            contentItemTransformer.apply(light); // don't even add the object to the scene if the intensity is 0

            if (light.intensity > 0) output.objects.push(light);
          }

          onLoadFinished(undefined, output);
        });
      }, function (error) {
        console.error(error);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return LightContentLoader;
}();

/**
 * We could have an interface IFileSizeResolver
 */

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var FileSizeResolver = /*#__PURE__*/function () {
  function FileSizeResolver(basePath, sizeSourcePath) {
    this.basePath = basePath;
    this.fileSizes = {};
    this.sizeSourcePath = sizeSourcePath;
  }

  var _proto = FileSizeResolver.prototype;

  _proto.load = function load() {
    try {
      var _this2 = this;

      if (!_this2.sizeSourcePath) {
        return Promise.resolve(undefined);
      } else {
        return Promise.resolve(_catch(function () {
          return Promise.resolve(JSONLoader.loadJsonObject(_this2.basePath + _this2.sizeSourcePath)).then(function (data) {
            _this2.fileSizes = data;
            return data;
          });
        }, function (error) {
          return new Error('When trying to load file sizes:' + error);
        }));
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getSize = function getSize(url) {
    if (this.fileSizes) {
      if (url.startsWith(this.basePath)) {
        url = url.substr(this.basePath.length);
      }

      return this.fileSizes[url];
    }

    return 0;
  };

  return FileSizeResolver;
}();

var SceneInfo = function SceneInfo(name) {
  this.name = name;
};

var NodeInfo = function NodeInfo(name) {
  this.name = name;
  this.enabled = true;
  this.visible = true;
};

var SceneCache = /*#__PURE__*/function () {
  function SceneCache() {
    this.isloaded = false;
    this.result = null;
    this.onLoadCallback = null;
  }

  var _proto = SceneCache.prototype;

  _proto.getContent = function getContent(onLoadFinished) {
    if (this.isloaded) {
      onLoadFinished(this.result);
    } else {
      this.onLoadCallback = onLoadFinished;
    }
  };

  _proto.setResult = function setResult(result) {
    this.result = result;
    this.isloaded = true;

    if (this.onLoadCallback) {
      this.onLoadCallback(result);
    }
  };

  return SceneCache;
}();

var AbstractMaterialHandler = /*#__PURE__*/function () {
  function AbstractMaterialHandler(name, baseUrl, materialObj) {
    this.name = name;
    this.baseUrl = baseUrl;
    this.materialObj = materialObj;
    this.textureLoadedEvent = new SharpEvent();
    this.textureLoader = new THREE__namespace.TextureLoader();
    this.textureLoader.crossOrigin = '';
    this.loadStartEvent = new SharpEvent();
    this.loadFinishEvent = new SharpEvent(); // these two are expected to be set in the subclasses
    // this._material = {};

    this.properties = {};
    this.storedMaterials = {}; // we use a shared promise reference, so that we can chain
    // loading operations, according to the priority we want
    // (namely loading the reduced versions before others

    this.promise = Promise.resolve();
  }

  var _proto = AbstractMaterialHandler.prototype;

  _proto.loadDefaults = function loadDefaults() {
    var _this = this;

    Object.keys(this.properties).forEach(function (key) {
      var property = _this.properties[key];
      var defaultFileValue = _this.materialObj.defaults ? _this.materialObj.defaults[key] : null; // because 0s and false's would also return false in a simple if(defaultFileValue) check...

      if (defaultFileValue !== null && defaultFileValue !== undefined) property.value = defaultFileValue;else if (property["default"] !== null && property["default"] !== undefined) {
        property.value = property["default"];
      }
    });
  };

  _proto.loadTexture = function loadTexture(relativePath, onFinishCallback) {
    var _this2 = this;

    var absolutePath = this.baseUrl + relativePath;
    return this.textureLoader.load(absolutePath, function (texture) {
      if (onFinishCallback) onFinishCallback(texture);

      _this2.textureLoadedEvent.invoke(absolutePath);
    }, undefined, function (err) {
      if (onFinishCallback) onFinishCallback(null, err);
    });
  };

  _proto.getProperties = function getProperties() {
    return this.properties;
  };

  _proto.setPropertyValues = function setPropertyValues(propertyValues) {
    var _this3 = this;

    Object.keys(propertyValues).forEach(function (key) {
      var property = _this3.properties[key];
      property.value = propertyValues[key];
      Object.values(_this3.storedMaterials).forEach(function (material) {
        property.setter(material, property.value);
      });
    });
  };

  _proto.getUIDetails = function getUIDetails() {
    var _this4 = this;

    var uiDetails = {}; // go over each property and get those attributes
    // that start with ui:

    Object.keys(this.properties).forEach(function (key) {
      var property = _this4.properties[key];
      var propertyUiDetails = {};
      Object.keys(property).forEach(function (subKey) {
        if (subKey.startsWith('ui:')) {
          propertyUiDetails[subKey] = property[subKey];
        }
      });
      uiDetails[key] = propertyUiDetails;
    });
    return uiDetails;
  };

  _proto.getPropertyValues = function getPropertyValues() {
    var _this5 = this;

    var propertyValues = {};
    Object.keys(this.properties).forEach(function (key) {
      var property = _this5.properties[key];
      propertyValues[key] = property.value;
    });
    return propertyValues;
  };

  _proto.setMaterialProperties = function setMaterialProperties(material) {
    var handler = this;
    var propertyValues = this.getPropertyValues();
    Object.keys(propertyValues).forEach(function (key) {
      var property = handler.properties[key];
      property.setter(material, propertyValues[key]);
    });
  };

  _proto.pad = function pad(num, count) {
    var str = num + '';

    while (str.length < count) {
      str = '0' + str;
    }

    return str;
  }
  /**
   * To be overriden in the subclasses.
   * @param getTextureFunc
   * @return {null}
   */
  ;

  _proto.getSpecificMaterial = function getSpecificMaterial() {
    // eslint-disable-line no-unused-vars
    return null;
  }
  /**
   * To be overriden in the subclasses. Returns a map with the material field name as key, and the path as value.
   * @return {{}}
   */
  ;

  _proto.getSpecificTextureNames = function getSpecificTextureNames() {
    return {};
  };

  _proto.getMultiLevelTexturePaths = function getMultiLevelTexturePaths(texturePath, level, x, y) {
    var indexOfDot = texturePath.lastIndexOf('.');
    var texturePathWithoutExtension = texturePath.substr(0, indexOfDot);
    var textureName = texturePathWithoutExtension.includes('/') ? texturePathWithoutExtension.substr(texturePathWithoutExtension.lastIndexOf('/') + 1) : texturePathWithoutExtension;
    var extension = texturePath.substr(indexOfDot);
    var textureFileName = texturePathWithoutExtension + '/l' + this.pad(level, 2) + '/' + textureName + '_c' + this.pad(x, 2) + '_r' + this.pad(y, 2) + extension;
    var textureFileNameReduced = texturePathWithoutExtension + '/l' + this.pad(level, 2) + '/' + textureName + '_c' + this.pad(x, 2) + '_r' + this.pad(y, 2) + '_red' + extension;
    return {
      full: textureFileName,
      reduced: textureFileNameReduced
    };
  };

  _proto.getSingleLevelMaterial = function getSingleLevelMaterial() {
    var _this6 = this;

    var material = this.getSpecificMaterial();
    material.opacity = 0;
    material.transparent = true;
    material.depthWrite = false;
    material.needsUpdate = true;
    var textureNameMap = this.getSpecificTextureNames();
    var promise = Promise.resolve();

    var _loop = function _loop(textureKey) {
      promise = promise.then(function () {
        return new Promise(function (resolve) {
          _this6.loadStartEvent.invoke(textureNameMap[textureKey]);

          _this6.loadTexture(textureNameMap[textureKey], function (texture) {
            material[textureKey] = texture;
            material.needsUpdate = true;
            resolve();

            _this6.animateMaterial(material, 1500, function () {
              return _this6.loadFinishEvent.invoke();
            });
          });
        });
      });
    };

    for (var textureKey in textureNameMap) {
      _loop(textureKey);
    }

    this.storedMaterials.single = material; // set the properties, even if the materials were cached

    this.setMaterialProperties(material);
    return material;
  };

  _proto.getMultiLevelMaterial = function getMultiLevelMaterial(level, x, y, loadReducedVersion) {
    var _this7 = this;

    var blockId = level + ',' + x + ',' + y;
    var material = this.storedMaterials[blockId]; // we can cache the materials.

    if (material) {
      this.setMaterialProperties(material);
      return material;
    } // If there isn't on the list yet create it now.


    this.storedMaterials[blockId] = material = this.getSpecificMaterial();
    this.setMaterialProperties(material); // out material will be invisible until it's fully loaded

    material.opacity = 0;
    material.transparent = true;
    material.depthWrite = false;
    material.needsUpdate = true; // this material may include several textures/maps, such as diffuse, normal, height, etc.

    var textureNameMap = this.getSpecificTextureNames(); // now, considering the level and tile, we need to grab the full and reduced versions
    // of each texture

    var multiLevelTexturePaths = {};

    for (var textureKey in textureNameMap) {
      multiLevelTexturePaths[textureKey] = this.getMultiLevelTexturePaths(textureNameMap[textureKey], level, x, y);
    }

    this.loadStartEvent.invoke(); // if a reduced version must be loaded first, do so for all maps

    if (loadReducedVersion) {
      var _loop2 = function _loop2(_textureKey) {
        var fileNames = multiLevelTexturePaths[_textureKey];
        _this7.promise = _this7.promise.then(function () {
          return new Promise(function (resolve) {
            material.needsUpdate = true;

            _this7.loadTexture(fileNames.reduced, function (reduceTexture) {
              material[_textureKey] = reduceTexture;
              resolve();
            });
          });
        });
      };

      for (var _textureKey in textureNameMap) {
        _loop2(_textureKey);
      } // once all the maps are loaded, we can perform the animation function


      this.promise = this.promise.then(function () {
        _this7.animateMaterial(material, 500, function () {
          return _this7.loadFinishEvent.invoke();
        });
      });
    }

    var fullTexturesMap = {};

    var _loop3 = function _loop3(_textureKey2) {
      var fileNames = multiLevelTexturePaths[_textureKey2];
      _this7.promise = _this7.promise.then(function () {
        return new Promise(function (resolve) {
          _this7.loadTexture(fileNames.full, function (texture) {
            fullTexturesMap[_textureKey2] = texture;
            resolve();
          });
        });
      });
    };

    for (var _textureKey2 in textureNameMap) {
      _loop3(_textureKey2);
    } // once all the maps are loaded, we can perform the animation function


    this.promise = this.promise.then(function () {
      if (loadReducedVersion) {
        material.opacity = 0;
      } // we do the texture assignment now only, because we need to make sure
      // the opacity is 0


      for (var _textureKey3 in textureNameMap) {
        material[_textureKey3] = fullTexturesMap[_textureKey3];
      }

      material.needsUpdate = true;

      if (loadReducedVersion) {
        material.opacity = 1;
      } else {
        _this7.animateMaterial(material, 1500, function () {
          return _this7.loadFinishEvent.invoke();
        });
      }
    });
    return material;
  };

  _proto.animateMaterial = function animateMaterial(material, duration, onComplete) {
    new TWEEN__default["default"].Tween(material).to({
      opacity: 1.0
    }, duration).easing(TWEEN__default["default"].Easing.Quadratic.In).onComplete(onComplete).start();
  };

  return AbstractMaterialHandler;
}();

var DiffuseMaterialHandler = /*#__PURE__*/function (_AbstractMaterialHand) {
  _inheritsLoose(DiffuseMaterialHandler, _AbstractMaterialHand);

  function DiffuseMaterialHandler() {
    return _AbstractMaterialHand.apply(this, arguments) || this;
  }

  var _proto = DiffuseMaterialHandler.prototype;

  _proto.getSpecificMaterial = function getSpecificMaterial() {
    // const diffuseTexture = getTextureFunc(this.materialObj.properties.diffusemap);
    return new THREE__namespace.MeshPhongMaterial({
      // map: diffuseTexture,
      alphaTest: 0.5 // side: THREE.DoubleSide

    });
  };

  _proto.getSpecificTextureNames = function getSpecificTextureNames() {
    return {
      map: this.materialObj.properties.diffusemap
    };
  };

  return DiffuseMaterialHandler;
}(AbstractMaterialHandler);

var NormalMaterialHandler = /*#__PURE__*/function (_AbstractMaterialHand) {
  _inheritsLoose(NormalMaterialHandler, _AbstractMaterialHand);

  function NormalMaterialHandler(name, baseUrl, materialObj) {
    var _this;

    _this = _AbstractMaterialHand.call(this, name, baseUrl, materialObj) || this;
    _this.properties = {
      normalScale: {
        type: 'number',
        title: 'Normal Scale',
        minimum: 0,
        maximum: 10,
        multipleOf: 0.01,
        "default": 1,
        'ui:widget': 'range',
        // 'getter' : () => this._material.normalScale.x,
        setter: function setter(material, value) {
          return material.normalScale = new THREE__namespace.Vector2(value, value);
        }
      },
      shininess: {
        type: 'number',
        title: 'Shininess',
        "default": 30,
        minimum: 0,
        maximum: 100,
        multipleOf: 0.1,
        'ui:widget': 'range',
        // 'getter' : () => this._material.shininess,
        setter: function setter(material, value) {
          return material.shininess = value;
        }
      }
    };
    return _this;
  }

  var _proto = NormalMaterialHandler.prototype;

  _proto.getSpecificMaterial = function getSpecificMaterial() {
    // const normalTexture = getTextureFunc(this.materialObj.properties.normalmap);
    return new THREE__namespace.MeshPhongMaterial({
      // normalMap: normalTexture,
      side: THREE__namespace.DoubleSide
    });
  };

  _proto.getSpecificTextureNames = function getSpecificTextureNames() {
    return {
      normalMap: this.materialObj.properties.normalmap
    };
  };

  return NormalMaterialHandler;
}(AbstractMaterialHandler);

var DiffuseNormalMaterialHandler = /*#__PURE__*/function (_AbstractMaterialHand) {
  _inheritsLoose(DiffuseNormalMaterialHandler, _AbstractMaterialHand);

  function DiffuseNormalMaterialHandler(name, baseUrl, materialObj) {
    var _this;

    _this = _AbstractMaterialHand.call(this, name, baseUrl, materialObj) || this;
    _this.properties = {
      normalScale: {
        type: 'number',
        title: 'Normal Scale',
        minimum: 0,
        maximum: 10,
        multipleOf: 0.01,
        "default": 1,
        'ui:widget': 'range',
        // 'getter' : () => this._material.normalScale.x,
        setter: function setter(material, value) {
          return material.normalScale = new THREE__namespace.Vector2(value, value);
        }
      },
      // showDiffuse: {
      //   type: 'boolean',
      //   title: 'Show Diffuse?',
      //   default: true,
      //   getter: () => this._material.map !== null,
      //   setter: (value) => {
      //     this._material.map = value ? this._diffuseTexture : null
      //     this._material.needsUpdate = true
      //   }
      // },
      shininess: {
        type: 'number',
        title: 'Shininess',
        "default": 30,
        minimum: 0,
        maximum: 100,
        multipleOf: 0.1,
        'ui:widget': 'range',
        // 'getter' : () => this._material.shininess,
        setter: function setter(material, value) {
          return material.shininess = value;
        }
      }
    };
    return _this;
  }

  var _proto = DiffuseNormalMaterialHandler.prototype;

  _proto.getSpecificMaterial = function getSpecificMaterial() {
    // const diffuseTexture = getTextureFunc(this.materialObj.properties.diffusemap);
    // const normalTexture = getTextureFunc(this.materialObj.properties.normalmap);
    return new THREE__namespace.MeshPhongMaterial({
      // map: diffuseTexture,
      // normalMap: normalTexture,
      alphaTest: 0.5
    });
  };

  _proto.getSpecificTextureNames = function getSpecificTextureNames() {
    return {
      map: this.materialObj.properties.diffusemap,
      normalMap: this.materialObj.properties.normalmap
    };
  };

  return DiffuseNormalMaterialHandler;
}(AbstractMaterialHandler);

var HeightMaterialHandler = /*#__PURE__*/function (_AbstractMaterialHand) {
  _inheritsLoose(HeightMaterialHandler, _AbstractMaterialHand);

  function HeightMaterialHandler(name, baseUrl, materialObj) {
    var _this;

    _this = _AbstractMaterialHand.call(this, name, baseUrl, materialObj) || this;
    _this.properties = {
      bumpScale: {
        type: 'number',
        title: 'Height Scale',
        minimum: 0,
        maximum: 10,
        multipleOf: 0.01,
        "default": 1,
        'ui:widget': 'range',
        // 'getter' : () => this._material.bumpScale,
        setter: function setter(material, value) {
          return material.bumpScale = value;
        }
      },
      showDiffuse: {
        type: 'boolean',
        title: 'Show Diffuse?',
        "default": true,
        // 'getter' : () => this._material.map !== null,
        setter: function setter(material, value) {
          material.map = value ? material.backUpMap : null;
          material.needsUpdate = true;
        }
      },
      shininess: {
        type: 'number',
        title: 'Shininess',
        "default": 30,
        minimum: 0,
        maximum: 100,
        multipleOf: 0.1,
        'ui:widget': 'range',
        // 'getter' : () => this._material.shininess,
        setter: function setter(material, value) {
          return material.shininess = value;
        }
      }
    };
    return _this;
  }

  var _proto = HeightMaterialHandler.prototype;

  _proto.getSpecificMaterial = function getSpecificMaterial() {
    // const diffuseTexture = getTextureFunc(this.materialObj.properties.diffusemap);
    // const displacementTexture = getTextureFunc(this.materialObj.properties.heightmap);
    return new THREE__namespace.MeshPhongMaterial({
      // map: diffuseTexture,
      // backUpMap: diffuseTexture,  //just to be able to set map to null and not lose reference to the diffuse map
      // bumpMap: displacementTexture,
      side: THREE__namespace.DoubleSide
    });
  };

  _proto.getSpecificTextureNames = function getSpecificTextureNames() {
    return {
      map: this.materialObj.properties.diffusemap,
      backUpMap: this.materialObj.properties.diffusemap,
      bumpMap: this.materialObj.properties.heightmap
    };
  };

  return HeightMaterialHandler;
}(AbstractMaterialHandler);

var QuadNode = /*#__PURE__*/function () {
  function QuadNode(x, y, width, height, column, row, level, maxLevel, tileWidth, tileHeight, group, parent) {
    this.column = column;
    this.row = row;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.level = level;
    this.maxLevel = maxLevel;
    this.tileWidth = tileWidth;
    this.tileHeight = tileHeight;
    this.children = [];
    this.group = group;
    this.parent = parent;
    this.materialHandler = null;

    if (!parent) {
      this.backgroundPlane = new THREE__namespace.Mesh(new THREE__namespace.PlaneGeometry(this.width, this.height));
      this.backgroundPlane.position.set(this.x + this.width / 2, this.y - this.height / 2, -1);
      this.backgroundPlane.material = this.backgroundPlane.originalMaterial = new THREE__namespace.MeshPhongMaterial({});
      this.group.add(this.backgroundPlane);
    }
  }

  var _proto = QuadNode.prototype;

  _proto.setMaterialHandler = function setMaterialHandler(materialHandler, loadReducedVersion) {
    this.materialHandler = materialHandler;

    if (this.backgroundPlane) {
      this.backgroundPlane.material = this.backgroundPlane.originalMaterial = this.materialHandler.getMultiLevelMaterial(this.level, this.column, this.row, true);
    }

    if (this.plane) {
      this.plane.material = this.plane.originalMaterial = this.materialHandler.getMultiLevelMaterial(this.level, this.column, this.row, loadReducedVersion);
    }

    if (this.children.length > 0) {
      this.children.forEach(function (x) {
        return x.setMaterialHandler(materialHandler, loadReducedVersion);
      });
    }
  };

  _proto.process = function process(x, y, width, height, camDotsPerX, camDotsPerY) {
    if (this.intersects(x, y, width, height)) {
      var dotsPerX = this.tileWidth / this.width;
      var dotsPerY = this.tileHeight / this.height;

      if (camDotsPerX > dotsPerX || camDotsPerY > dotsPerY) {
        var subParts = this.subdivide();

        if (subParts) {
          this.children.forEach(function (child) {
            return child.process(x, y, width, height, camDotsPerX, camDotsPerY);
          });
        } else this.setupCurrent();
      } else {
        this.setupCurrent();
      }
    } else {
      // remove own plane
      this.unloadPlane();
    }
  };

  _proto.subdivide = function subdivide() {
    if (this.children.length > 0) {
      return this.children;
    }

    if (this.level >= this.maxLevel) return;
    var levelScale = Math.pow(2, this.maxLevel - this.level - 1);
    var minX = this.tileWidth * levelScale;
    var minY = this.tileHeight * levelScale;
    var numHorizSlices = Math.ceil(this.width / minX);
    var numVertSlices = Math.ceil(this.height / minY);
    var remainHorizontal = this.width % minX;
    var remainVertical = this.height % minY;
    var currentX = this.x;

    for (var column = 0; column < numHorizSlices; column++) {
      var currentHorizSize = remainHorizontal > 0 && column === numHorizSlices - 1 ? remainHorizontal : minX;
      var currentY = this.y;

      for (var row = 0; row < numVertSlices; row++) {
        var currentVertSize = remainVertical > 0 && row === numVertSlices - 1 ? remainVertical : minY;
        var subColumn = column + this.column * 2; // numHorizSlices;

        var subRow = row + this.row * 2; // numVertSlices;

        var subQuadNode = new QuadNode(currentX, currentY, currentHorizSize, currentVertSize, subColumn, subRow, this.level + 1, this.maxLevel, this.tileWidth, this.tileHeight, this.group, this);
        if (this.materialHandler) subQuadNode.setMaterialHandler(this.materialHandler, false); // this.doesParentHavePlaneLoaded()

        this.children.push(subQuadNode);
        currentY -= currentVertSize;
      }

      currentX += currentHorizSize;
    } // this.unloadPlane();


    return this.children;
  };

  _proto.loadPlane = function loadPlane() {
    var geometry = new THREE__namespace.PlaneGeometry(this.width, this.height);
    var plane = new THREE__namespace.Mesh(geometry);
    plane.renderOrder = this.level + 1;
    plane.position.set(this.x + this.width / 2, this.y - this.height / 2, this.level); // subplane.position.set(column * size, -row * size, 1);
    // this.subplane.material = this.materialHandler.getMaterial(this.level, this.column, this.row);
    // this.subplane.material.wireframe = true;

    if (this.materialHandler) plane.material = plane.originalMaterial = this.materialHandler.getMultiLevelMaterial(this.level, this.column, this.row, false); // this.doesParentHavePlaneLoaded()
    // temporary contour
    // this.addContour(geometry, plane);

    this.group.add(plane);
    this.plane = plane;
  };

  _proto.unloadPlane = function unloadPlane() {
    this.group.remove(this.plane);
    this.plane = null;
  };

  _proto.intersects = function intersects(targetX, targetY, targetWidth, targetHeight) {
    var combinedMin = {
      x: Math.min(this.x, targetX),
      y: Math.min(this.y - this.height, targetY - targetHeight)
    };
    var combinedMax = {
      x: Math.max(this.x + this.width, targetX + targetWidth),
      y: Math.max(this.y, targetY)
    };
    return !(combinedMax.x - combinedMin.x > this.width + targetWidth || combinedMax.y - combinedMin.y > this.height + targetHeight);
  };

  _proto.setupCurrent = function setupCurrent() {
    if (this.children.length > 0) {
      this.children.forEach(function (child) {
        return child["delete"]();
      });
      this.children = [];
    }

    if (!this.plane) this.loadPlane();
  };

  _proto.doesParentHavePlaneLoaded = function doesParentHavePlaneLoaded() {
    return this.parent && (this.parent.plane !== undefined || this.parent.doesParentHavePlaneLoaded());
  };

  _proto["delete"] = function _delete() {
    this.children.forEach(function (child) {
      return child["delete"]();
    });
    this.unloadPlane(); // this.group.remove(this.plane);
  };

  _proto.addContour = function addContour(geometry, plane) {
    var edgesGeometry = new THREE__namespace.EdgesGeometry(geometry); // or WireframeGeometry

    var edgesMaterial = new THREE__namespace.LineBasicMaterial({
      color: 0xff0000,
      linewidth: 2
    });
    var wireframe = new THREE__namespace.LineSegments(edgesGeometry, edgesMaterial);
    wireframe.position.set(0, 0, this.maxLevel - this.level + 1);
    plane.add(wireframe);
  };

  return QuadNode;
}();

var SurfaceObject = /*#__PURE__*/function (_Object3D) {
  _inheritsLoose(SurfaceObject, _Object3D);

  function SurfaceObject() {
    return _Object3D.apply(this, arguments) || this;
  }

  var _proto = SurfaceObject.prototype;

  _proto.toggleBackPlane = function toggleBackPlane(status) {
    if (this.backPlane) {
      if (status) {
        this.add(this.backPlane);
      } else {
        this.remove(this.backPlane);
      }
    }
  };

  return SurfaceObject;
}(THREE.Object3D);

var SurfaceContentLoader = /*#__PURE__*/function () {
  function SurfaceContentLoader() {
    this.materialMap = {
      DIFFUSE: DiffuseMaterialHandler,
      NORMAL: NormalMaterialHandler,
      DIFFUSENORMAL: DiffuseNormalMaterialHandler,
      HEIGHT: HeightMaterialHandler
    };
  }

  var _proto = SurfaceContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    try {
      var _this2 = this;

      var fullUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
      var contentItemTransformer = new ContentItemTransformer(contentItem);
      return Promise.resolve(JSONLoader.loadJsonObject(fullUrl)).then(function (data) {
        var materials = data.materials;
        var materialNames = Object.keys(materials);
        var loadedMaterialHandlers = {};
        materialNames.forEach(function (name) {
          var materialObj = materials[name];
          var type = materialObj.type;
          var MaterialCreationFunction = _this2.materialMap[type];

          if (MaterialCreationFunction) {
            loadedMaterialHandlers[name] = new MaterialCreationFunction(name, dataSource.url, materialObj);
            loadedMaterialHandlers[name].loadDefaults();
          }
        }, _this2);

        var group = _this2.loadPlane(data);

        group.materialHandlers = loadedMaterialHandlers;
        output.objects.push(group);
        contentItemTransformer.apply(group);
        onLoadFinished(undefined, output);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadPlane = function loadPlane(data) {
    var group = new SurfaceObject();
    var totalWidth = data.width || 1;
    var totalHeight = data.height || totalWidth;
    var isMultiResolution = !!data.multiResolution;
    var useBackPlane = Boolean(data.useBackPlane);
    group.name = data.name;
    group.totalWidth = totalWidth;
    group.totalHeight = totalHeight;
    group.isMultiResolution = isMultiResolution;

    if (isMultiResolution) {
      group.tileWidth = data.multiResolution.tileWidth;
      group.tileHeight = data.multiResolution.tileHeight;
      group.numHorizSlices = Math.ceil(totalWidth / group.tileWidth);
      group.numVertSlices = Math.ceil(totalHeight / group.tileHeight);
      group.maxSliceNumber = Math.max(group.numHorizSlices, group.numVertSlices);
      group.maxLevel = Math.ceil(Math.log2(group.maxSliceNumber));
    }

    group.collisionPlane = new THREE.Mesh(new THREE.PlaneGeometry(totalWidth * 10, totalHeight * 10));
    group.boundingBox = new THREE.Box3(new THREE.Vector3(0, -totalHeight, 0), new THREE.Vector3(totalWidth, 0, 0));

    if (useBackPlane) {
      // create an empty plane, for both single and multiresolution cases, so that we don't ever get an empty background
      var backPlane = new THREE.Mesh(new THREE.PlaneGeometry(totalWidth, totalHeight));
      backPlane.position.copy(new THREE.Vector3(totalWidth / 2, -totalHeight / 2, -2));
      backPlane.material = new THREE.MeshPhongMaterial({});
      group.backPlane = backPlane;
      group.add(backPlane);
    }

    if (isMultiResolution) {
      group.baseQuad = new QuadNode(0, 0, totalWidth, totalHeight, 0, 0, 0, group.maxLevel, group.tileWidth, group.tileHeight, group);
    } else {
      var geometry = new THREE.PlaneGeometry(totalWidth, totalHeight);
      group.plane = new THREE.Mesh(geometry);
      group.plane.position.copy(new THREE.Vector3(totalWidth / 2, -totalHeight / 2, 0));
      group.add(group.plane);
    } // instead of X-Y plane, we rotate it to lie on the X-Z plane


    group.rotateX(MathHelper.toRadians(-90));
    group.rotateZ(MathHelper.toRadians(-90));
    group.position.copy(new THREE.Vector3(totalHeight, 0, 0));
    return group;
  };

  return SurfaceContentLoader;
}();

var ContentLoaderOutput = function ContentLoaderOutput() {
  this.objects = [];
  this.animations = [];
  this.skins = {};
  this.skies = [];
};

function getFileNameWithoutExtension(urlPath) {
  // split urlPath by '/' and get last item
  var fileNameWithExtension = urlPath.split('/').pop(); // remove extension and join the remaining parts

  var fileNameParts = fileNameWithExtension.split('.');
  fileNameParts.pop();
  return fileNameParts.join('.');
}
function getFileExtension(urlPath) {
  // Get the last portion of the URL after the last slash
  var filename = urlPath.substring(urlPath.lastIndexOf('/') + 1); // Get the file extension by splitting the filename at the last dot

  return filename.split('.').pop();
}

var NexusContentLoader = /*#__PURE__*/function () {
  function NexusContentLoader(renderManager) {
    this.renderManager = renderManager;
  }

  var _proto = NexusContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    var _this = this;

    // make relative paths absolute, if necessary
    var nxzFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
    var contentItemTransformer = new ContentItemTransformer(contentItem);
    output.objects.push(new Nexus3D__default["default"].Nexus3D(nxzFileUrl, this.renderManager.renderer, {
      onLoad: function onLoad(nexus) {
        //nexus objects do not keep mesh names, and only return one object
        //so we set the name (that otherwise would be blank) to the file name
        nexus.name = getFileNameWithoutExtension(contentItem.url); //the nexus object does not calculate its boundingbox properly, so we have to override it

        nexus.boundingBox = nexus.boundingSphere.getBoundingBox(new THREE.Box3());
        contentItemTransformer.apply(nexus);
        nexus.updateMatrixWorld();
        onLoadFinished(undefined, output);
      },
      onUpdate: function onUpdate() {
        _this.renderManager.updateShouldRenderer(true);
      }
    }));
  };

  return NexusContentLoader;
}();

var SkyContentLoader = /*#__PURE__*/function () {
  function SkyContentLoader(renderManager) {
    this.cubeTextureLoader = new THREE.CubeTextureLoader();
    this.textureLoader = new THREE.TextureLoader();
    this.renderManager = renderManager;
    this.textureLoader.crossOrigin = '';
  }

  var _proto = SkyContentLoader.prototype;

  _proto.loadContent = function loadContent(contentItem, output, dataSource, onLoadProgress, onLoadFinished) {
    try {
      var _this2 = this;

      var skyFileUrl = PathHelper.getFullUrl(dataSource.url, contentItem.url);
      return Promise.resolve(JSONLoader.loadJsonObject(skyFileUrl)).then(function (sky) {
        function _temp(skyTexture) {
          output.skies.push(skyTexture);
          onLoadFinished(undefined, output);
        }

        var textureLoader = new THREE.TextureLoader();
        textureLoader.crossOrigin = '';
        var _sky$equirectangular = sky.equirectangular;
        return _sky$equirectangular ? Promise.resolve(_this2.loadEquirectangularTexture(dataSource, sky)).then(_temp) : _temp(_this2.loadCubemapTexture(dataSource, sky));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadEquirectangularTexture = function loadEquirectangularTexture(dataSource, sky) {
    try {
      var _this4 = this;

      var texturePath = PathHelper.getFullUrl(dataSource.url, sky.equirectangular);
      var fileExtension = getFileExtension(texturePath);

      if (fileExtension === "hdr") {
        return Promise.resolve(loadRGBETextureAsync(texturePath)).then(function (texture) {
          texture.mapping = THREE.EquirectangularReflectionMapping;
          return texture;
        });
      } else {
        return Promise.resolve(_this4.textureLoader.load(texturePath, function (it) {
          it.mapping = THREE.EquirectangularReflectionMapping;
        }));
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadCubemapTexture = function loadCubemapTexture(dataSource, sky) {
    var textureNames = ['front', 'back', 'top', 'bottom', 'left', 'right'].map(function (side) {
      return PathHelper.getFullUrl(dataSource.url, sky[side]);
    });
    return this.cubeTextureLoader.load(textureNames, function (it) {
      it.encoding = THREE.sRGBEncoding;
    });
  };

  _proto.getPMREMGenerator = function getPMREMGenerator() {
    if (!this.pmremGenerator) {
      this.pmremGenerator = new THREE.PMREMGenerator(this.renderManager.renderer);
    }

    return this.pmremGenerator;
  };

  return SkyContentLoader;
}();

var PrefetchMode = {
  All: 'all',
  First: 'first'
};
/**
 * This datasource is the base example of how to develop data sources.
 * Data source must include the means to load the data, indicate how they map into nodes and
 * how they result into three.js compatible content.
 *
 * This class to the base example of json specification that was provided in the old
 * 3D Viewer.
 */

var SceneDataSource = /*#__PURE__*/function (_AbstractDataSource) {
  _inheritsLoose(SceneDataSource, _AbstractDataSource);

  function SceneDataSource(renderManager) {
    var _this;

    _this = _AbstractDataSource.call(this) || this;
    _this.contentBySceneIdMap = {};
    _this.url = 'http://localhost:3000/';
    _this.path = 'data.json';
    _this.sizes = null;
    _this.initialSceneId = null;
    _this.enableDoubleSide = false;
    _this.enableWireframe = false;
    _this.useCaching = true;
    _this.preFetch = PrefetchMode.First;
    _this.disposed = false;
    _this.contentBySceneIdMap = {};
    _this.scenes = [];
    _this.loaders = {
      obj: new ObjContentLoader(),
      fbx: new FbxContentLoader(),
      gltf: new GltfContentLoader(),
      glb: new GltfContentLoader(),
      markers: new MarkerContentLoader(),
      skins: new SkinContentLoader(),
      videos: new VideoContentLoader(),
      lights: new LightContentLoader(),
      surface: new SurfaceContentLoader(),
      sky: new SkyContentLoader(renderManager),
      nxz: new NexusContentLoader(renderManager),
      nxs: new NexusContentLoader(renderManager)
    };
    return _this;
  }
  /**
   * The process starts here. The file is downloaded and parsed.
   * @param onLoadFinished
   */


  var _proto = SceneDataSource.prototype;

  _proto.load = function load(onLoadFinished) {
    var _this2 = this;

    this.fileSizeResolver = new FileSizeResolver(this.url, this.sizes);
    var promise = this.fileSizeResolver.load();
    promise.then(function () {
      JSONLoader.loadJsonObject(_this2.url + _this2.path).then(function (data) {
        _this2.scenes = [];

        for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];

          _this2.scenes.push(_this2.processData(key, data[key]));
        }

        if (_this2.preFetch) {
          var scenesToPrefetch = _this2.preFetch === PrefetchMode.All ? _this2.getScenes() : [_this2.getFirstScene()];

          if (_this2.useCaching) {
            for (var _iterator = _createForOfIteratorHelperLoose(scenesToPrefetch), _step; !(_step = _iterator()).done;) {
              var scene = _step.value;
              _this2.contentBySceneIdMap[scene.name] = new SceneCache();
            }
          }

          _this2.prefetchScenes(scenesToPrefetch, function () {
            if (!_this2.disposed) onLoadFinished();
          });
        } else {
          // let firstNode = this.getFirstNode();
          if (!_this2.disposed) onLoadFinished();
        }
      });
    });
  };

  _proto.prefetchScenes = function prefetchScenes(scenes, onLoadFinished, requestedScene) {
    var _this3 = this;

    if (scenes.length === 0) {
      // in case we already loaded the intended targetScene
      // onLoadFinished will be set to null, meaning that the
      // end of this process is not relevant
      if (onLoadFinished) onLoadFinished();
      return;
    }

    var scene = scenes.shift();
    this.loadContent(scene, function () {}, function (err, result) {
      if (_this3.useCaching) _this3.contentBySceneIdMap[scene.name].setResult(result);

      if (scene === requestedScene) {
        onLoadFinished();

        _this3.prefetchScenes(scenes, null);
      } else {
        _this3.prefetchScenes(scenes, onLoadFinished, requestedScene);
      }
    });
  };

  _proto.processData = function processData(sceneName, scene) {
    // TODO: Remove after version 2.0.0
    if (scene.children) {
      console.warn('scene.children is no longer supported. Please switch to the new "nodes" definition.');
    }

    var sceneInfo = Object.assign(new SceneInfo(sceneName), scene);

    if (sceneInfo.nodes) {
      for (var _i2 = 0, _Object$keys2 = Object.keys(sceneInfo.nodes); _i2 < _Object$keys2.length; _i2++) {
        var key = _Object$keys2[_i2];
        sceneInfo.nodes[key] = Object.assign(new NodeInfo(key), sceneInfo.nodes[key]);
      }
    }

    return sceneInfo;
  };

  _proto.getFirstScene = function getFirstScene() {
    if (this.initialSceneId) return lodash.find(this.scenes, {
      id: this.initialSceneId
    });else {
      return lodash.find(this.scenes, {
        "default": true
      }) || this.scenes[0];
    }
  }
  /**
   * Gets the list of loaded Scenes.
   * @returns {SceneInfo[]} List of loaded scenes.
   */
  ;

  _proto.getScenes = function getScenes() {
    return this.scenes;
  };

  _proto.getContent = function getContent(scene, onLoadProgress, onLoadFinished) {
    var _this4 = this;

    if (this.useCaching && this.contentBySceneIdMap[scene.name]) {
      this.contentBySceneIdMap[scene.name].getContent(function (result) {
        if (!_this4.disposed) onLoadFinished(undefined, result);
      });
    } else {
      this.loadContent(scene, onLoadProgress, function (err, result) {
        if (_this4.useCaching) {
          var nodeCache = _this4.contentBySceneIdMap[scene.name] = new SceneCache();
          nodeCache.setResult(result);
        }

        if (!_this4.disposed) onLoadFinished(undefined, result);
      });
    }
  };

  _proto.loadContent = function loadContent(scene, onLoadProgress, onFinished) {
    var _this5 = this;

    var promise = Promise.resolve(new ContentLoaderOutput()); // start the progress bar, even if it is just to state that we don't know
    // progress yet

    onLoadProgress(Number.POSITIVE_INFINITY);

    if (scene.content) {
      var _loop = function _loop() {
        var contentItem = _step2.value;

        if (contentItem.url) {
          var extension = contentItem.url.split('.').pop().toLowerCase();
          var type = contentItem.type;
          var loader = _this5.loaders[extension] || _this5.loaders[type];

          if (!loader) {
            throw new Error("Could not find a loader for the extension '" + extension + "' or type '" + type + "'. \n            Accepted values are " + Object.keys(_this5.loaders).join(',') + ".");
          }

          promise = promise.then(function (previousResult) {
            return new Promise(function (resolve) {
              loader.loadContent(contentItem, previousResult, _this5, onLoadProgress, function (err, result) {
                resolve(result);
              });
            });
          });
        }
      };

      for (var _iterator2 = _createForOfIteratorHelperLoose(scene.content), _step2; !(_step2 = _iterator2()).done;) {
        _loop();
      }
    }

    promise.then(function (result) {
      onFinished(undefined, result);
    });
  };

  return SceneDataSource;
}(AbstractDataSource);

function filterNamedObjects(objectsWithName, nameFilter) {
  var nameFilterSet = Array.isArray(nameFilter) ? new Set(nameFilter) : nameFilter;
  return objectsWithName.filter(function (node) {
    return appliesToObject(node, nameFilterSet);
  });
}
function appliesToObject(object, nameFilter) {
  // if the filter is empty, it applies
  if (!nameFilter) return true;
  if (nameFilter instanceof Set && nameFilter.has(object.name)) return true; // if the filter is a list, ensure that the list contains the object name

  if (Array.isArray(nameFilter) && nameFilter.includes(object.name)) return true;
  var regexFilter = nameFilter;

  if (regexFilter.filter) {
    var regexStrings = Array.isArray(regexFilter.filter) ? regexFilter.filter : [regexFilter.filter];
    var regexes = [];

    for (var _iterator = _createForOfIteratorHelperLoose(regexStrings), _step; !(_step = _iterator()).done;) {
      var regexString = _step.value;
      regexes.push(new RegExp(regexFilter.strict ? '^' + regexString + '$' : regexString));
    }

    if (regexFilter.invert) {
      return regexes.every(function (x) {
        return !x.test(object.name);
      });
    } else {
      return regexes.some(function (x) {
        return x.test(object.name);
      });
    }
  } // otherwise, only accept it if the filter actually matches the object name


  return object.name === nameFilter;
}

var DataSourceManager = /*#__PURE__*/function () {
  function DataSourceManager(sceneManager, cameraManager, renderManager) {
    this.onObjectsLoadedEvent = new SharpEvent();
    this.onLoadProgressEvent = new SharpEvent();
    this.onLoadFinishEvent = new SharpEvent();
    this.onSceneChanged = new SharpEvent();
    this.sceneContentChangedEvent = new SharpEvent();
    this.sceneManager = sceneManager;
    this.config = cameraManager.config;
    this.cameraManager = cameraManager;
    this.group = new THREE.Group();
    this.sceneHistory = [];
    this.sceneManager.scene.add(this.group);
    this.sceneLoaded = false;
    this.datasourceTypes = {
      SceneDataSource: function SceneDataSource$1() {
        return new SceneDataSource(renderManager);
      }
    };
    this.setupDataSource(this.config);
  }

  var _proto = DataSourceManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDiv) {
    this.rendererDiv = rendererDiv;
    this.loadDataSource();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    var shouldReloadDataSource = false;

    if (!lodash.isEqual(nextConfig.dataSource, this.config.dataSource)) {
      this.setupDataSource(nextConfig);
      shouldReloadDataSource = true;
    } // call the method toggleEnabled for all children that support it


    if (nextConfig.renderer.enabled !== this.config.renderer.enabled) {
      for (var _iterator = _createForOfIteratorHelperLoose(this.group.children.filter(function (x) {
        return x.toggleEnabled;
      }).map(function (x) {
        return x;
      })), _step; !(_step = _iterator()).done;) {
        var child = _step.value;
        child.toggleEnabled(nextConfig.renderer.enabled);
      }
    }

    this.config = nextConfig;

    if (shouldReloadDataSource) {
      this.sceneHistory = [];
      this.loadedScene = undefined;
      this.clearTransientObjects();
      this.loadDataSource();
    }
  };

  _proto.loadDataSource = function loadDataSource() {
    var _this = this;

    // have the data source load the data
    this.dataSource.load(function (err) {
      if (err) console.error('Error on loading.', err);else {
        _this.config.dataSource.onDataSourceLoad(_this.api);

        var initialScene = _this.dataSource.getFirstScene();

        if (!initialScene) {
          console.error('The given data does not have the indicated initial node.');
        } else {
          _this.loadScene(initialScene);
        }
      }
    });
  };

  _proto.clearTransientObjects = function clearTransientObjects() {
    var removeIndex = 0;
    var numChildren = this.group.children.length;

    for (var i = 0; i < numChildren; i++) {
      var child = this.group.children[removeIndex];

      if (!child.persistent) {
        this.group.remove(child);
        if (child.dispose) child.dispose();
      } else removeIndex++;
    }
  };

  _proto.setupDataSource = function setupDataSource(config) {
    var _this2 = this;

    // make sure we don't get callbacks from the old datasource
    if (this.dataSource) {
      this.dataSource.disposed = true;
    }

    this.dataSource = this.datasourceTypes[config.dataSource.type]();
    Object.keys(config.dataSource).forEach(function (property) {
      _this2.dataSource[property] = config.dataSource[property];
    });
  };

  _proto.storeInHistory = function storeInHistory(scene) {
    if (scene && this.config.scenes.historySize > 0) {
      // restrict the number of scenes in the history
      while (this.sceneHistory.length + 1 > this.config.scenes.historySize) {
        this.sceneHistory.shift();
      }

      this.sceneHistory.push(scene);
    }
  };

  _proto.onLoadProgress = function onLoadProgress(progress) {
    if (!this.isCancelled) {
      this.onLoadProgressEvent.invoke(progress);
    }
  };

  _proto.onLoadFinished = function onLoadFinished(err, result) {
    var _this3 = this;

    if (err) console.error('There was an error loading the content.');else {
      var objects = result.objects;
      objects.forEach(function (object) {
        _this3.group.add(object);
      }, this);

      if (result.skies.length > 0) {
        this.sceneManager.scene.background = this.sceneManager.scene.environment = result.skies[0];
      }

      this.onObjectsLoadedEvent.invoke(objects);
      this.allBoundingBox = this.calculateBoundingBox(objects); // warn all the interested components that subscribe to this event

      this.onLoadFinishEvent.invoke(result); // if we have requested to frameBox a child node once the parent node was loaded
      // do so now

      if (this.config.camera.loadFraming) {
        var animation = {
          onFinish: function onFinish() {
            return _this3.config.scenes.onSceneReady(_this3.api, _this3.loadedScene);
          },
          duration: this.config.camera.loadFramingDuration
        };

        if (!this.allBoundingBox.isEmpty()) {
          this.cameraManager.frameBox(this.allBoundingBox, null, animation);
        } else {
          animation.onFinish();
        }
      } else {
        // warn anybody that may be interested
        this.config.scenes.onSceneReady(this.api, this.loadedScene);
        this.sceneContentChangedEvent.invoke();
      }

      this.sceneLoaded = true;
    }
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry, api) {
    this.api = api;
    apiRegistry.register(Viewer3DApi.TYPES.SCENE, {
      addSceneObject: this.addSceneObject,
      removeSceneObject: this.removeSceneObject,
      getScenes: this.getScenes,
      getScene: this.getScene,
      getCurrentScene: this.getCurrentScene,
      getSceneObjects: this.getSceneObjects,
      loadScene: this.loadScene,
      loadPreviousScene: this.loadPreviousScene,
      frameScene: this.frameScene,
      setObjectVisibility: this.setObjectVisibility
    }, this);
  }
  /**
   * Loads a scene.
   * @param {SceneInfo} scene The scene to be loaded. Does nothing if the node is currently loaded.
   * @api viewer3d.scene
   */
  ;

  _proto.loadScene = function loadScene(scene) {
    // make sure that the node is different from this one
    if (this.loadedScene !== scene) {
      // store the previous scene (if set) to the history
      this.storeInHistory(this.loadedScene);
      this.config.scenes.onSceneLoading(this.api, scene);
      this.sceneLoaded = false;
      this.clearTransientObjects();
      this.loadedScene = scene;
      this.onSceneChanged.invoke(scene);
      this.dataSource.getContent(scene, this.onLoadProgress.bind(this), this.onLoadFinished.bind(this));
    }
  }
  /**
   * Frames the whole scene in the screen, using the current camera direction or the provided one. Works only if a scene is loaded.
   * @param animation If a value is set, the transition to the new location will be animated according to the defined options, otherwise the change will be performed instantly.
   * @param direction A vector3 indicating the camera direction to use in the frame. If null, the current camera direction will be used.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.scene
   */
  ;

  _proto.frameScene = function frameScene(animation, direction) {
    return this.cameraManager.frameBox(this.allBoundingBox, direction, animation);
  }
  /**
   * Gets the list of available scenes.
   * @param nameFilter Name of the scene (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.scene
   * @returns The list of available scenes (matching the indicated filter, if provided).
   */
  ;

  _proto.getScenes = function getScenes(nameFilter) {
    return filterNamedObjects(this.dataSource.getScenes(), nameFilter);
  }
  /**
   * Gets the first scene that matches the provided name.  Same as calling getScenes, but for undefined/null names, it will not return anything.
   * @param name Name of the scene to be fetched.
   * @returns The scene with the indicated name.
   * @api viewer3d.scene
   */
  ;

  _proto.getScene = function getScene(name) {
    return this.getScenes([name])[0];
  }
  /**
   * Gets the scene that is currently loaded.
   * @returns The currently loaded scene.
   * @api viewer3d.scene
   */
  ;

  _proto.getCurrentScene = function getCurrentScene() {
    return this.loadedScene;
  };

  _proto.calculateBoundingBox = function calculateBoundingBox(objects) {
    var boundingBox = new THREE.Box3();
    objects.forEach(function (object) {
      if (object.node) {
        // sprites may have to get their BoundingBox through these means
        boundingBox.union(object.node.boundingBox);
      } else if (object.boundingBox) {
        var newBox3 = new THREE.Box3().copy(object.boundingBox).applyMatrix4(object.matrixWorld);
        boundingBox.union(newBox3);
      } else if (object.geometry !== undefined || object instanceof THREE.Object3D) {
        boundingBox.union(new THREE.Box3().setFromObject(object));
      }
    });
    return boundingBox;
  }
  /**
   * Goes back (i.e. reloads) the scene that was previously loaded, if any.
   * @api viewer3d.scene
   */
  ;

  _proto.loadPreviousScene = function loadPreviousScene() {
    var previousScene = this.sceneHistory.pop();

    if (previousScene) {
      this.loadScene(previousScene);
    }
  }
  /**
   * Gets a list of all current scene objects, including nodes, meshes and lights.
   * @param [nameFilter] Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @returns {object[]} A list of all the objects in the currently loaded scene.
   * @api viewer3d.scene
   */
  ;

  _proto.getSceneObjects = function getSceneObjects(nameFilter) {
    return filterNamedObjects(this.group.children, nameFilter);
  }
  /**
   * Sets the visibility of the objects that match the passed filter.
   * @param visibility New visibility status that is to be assigned to the objects.
   * @param nameFilter  Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.scene
   */
  ;

  _proto.setObjectVisibility = function setObjectVisibility(visibility, nameFilter) {
    var contentChanged = false;

    for (var _iterator2 = _createForOfIteratorHelperLoose(this.getSceneObjects(nameFilter)), _step2; !(_step2 = _iterator2()).done;) {
      var sceneObject = _step2.value;
      contentChanged = contentChanged || sceneObject.visible !== visibility;
      sceneObject.visible = visibility;
    }

    if (contentChanged) this.sceneContentChangedEvent.invoke();
  }
  /**
   * Adds a given scene object to the scene.
   * @param sceneObject Object to be added.
   * @api viewer3d.scene
   */
  ;

  _proto.addSceneObject = function addSceneObject(sceneObject) {
    this.group.add(sceneObject);
    this.updateAllBoundingBox();
    this.sceneContentChangedEvent.invoke();
  }
  /**
   * Removes a given scene object from the scene.
   * @param sceneObject {object} Object to be removed.
   * @api viewer3d.scene
   */
  ;

  _proto.removeSceneObject = function removeSceneObject(sceneObject) {
    this.group.remove(sceneObject);
    this.updateAllBoundingBox();
    this.sceneContentChangedEvent.invoke();
  };

  _proto.updateAllBoundingBox = function updateAllBoundingBox() {
    this.allBoundingBox = this.calculateBoundingBox(this.group.children);
  }
  /**
   * Gets the meshes and all its subtree submeshes, starting from the root (or from the optionally provided mesh)
   * @param [threeJsObject] {object} (Optional)
   * @returns {Mesh[]} List of three.js meshes
   */
  ;

  _proto.getMeshChildren = function getMeshChildren(threeJsObject) {
    if (!threeJsObject) threeJsObject = this.group;
    var meshes = [];
    var groups = [threeJsObject];

    while (groups.length > 0) {
      var item = groups.pop();

      for (var _iterator3 = _createForOfIteratorHelperLoose(item.children), _step3; !(_step3 = _iterator3()).done;) {
        var child = _step3.value;

        if (child.isMesh && child.geometry !== undefined) {
          meshes.push(child);
        }

        if (child.children && child.children.length > 0) {
          groups.push(child);
        }
      }
    }

    return meshes;
  };

  _proto.getProgressEvent = function getProgressEvent() {
    return this.onLoadProgressEvent;
  };

  _proto.getProgressFinishEvent = function getProgressFinishEvent() {
    return this.onLoadFinishEvent;
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.onSceneChanged, this.sceneContentChangedEvent];
  };

  return DataSourceManager;
}();

var OutlineManager = /*#__PURE__*/function () {
  function OutlineManager(config) {
    this.outlinePasses = {};
    this.outlinePassRecycleBin = [];
    this.config = config;
  }

  var _proto = OutlineManager.prototype;

  _proto.initialize = function initialize(renderer, composer) {
    this.composer = composer;
    this.index = this.composer.passes.length;
    this.size = renderer.getSize(new THREE.Vector2());
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    var _this = this;

    this.config = nextConfig;
    Object.keys(this.outlinePasses).forEach(function (key) {
      _this.setConfig(_this.outlinePasses[key]);
    }, this);
  };

  _proto.update = function update(renderManager) {
    // if there are outline passes that are pulsating, we need to render every time
    if (this.outlinePasses && Object.keys(this.outlinePasses).length > 0 && typeof this.outlinePasses === 'object') {
      renderManager.updateShouldRenderer(Object.keys(this.outlinePasses).length > 0 && this.config.renderer.borderPulsePeriod > 0);
    }
  };

  _proto.setConfig = function setConfig(outlinePass) {
    outlinePass.edgeStrength = this.config.renderer.borderStrength;
    outlinePass.edgeGlow = this.config.renderer.borderGlow;
    outlinePass.edgeThickness = this.config.renderer.borderThickness;
    outlinePass.pulsePeriod = this.config.renderer.borderPulsePeriod;
  };

  _proto.buildColorOutlines = function buildColorOutlines(scene, camera) {
    var _this2 = this;

    var objectsByColor = this.processBorderedObjects(scene); // first, go over the existing passes
    // if there aren't any object with this color anymore, send the pass to the "recycle bin"
    // to improve performance

    Object.keys(this.outlinePasses).forEach(function (key) {
      if (!objectsByColor[key]) {
        _this2.outlinePassRecycleBin.push(_this2.outlinePasses[key]);

        _this2.outlinePasses[key].enabled = false;
        delete _this2.outlinePasses[key];
      } else {
        _this2.outlinePasses[key].selectedObjects = objectsByColor[key];
      }
    }, this); // now, let's make sure all border colors have a pass, too
    // if we don't have one pass for that color, we get a pass
    // from the recycle bin or create a new pass

    Object.keys(objectsByColor).forEach(function (key) {
      var actualColor = new Color(key);
      var alpha = actualColor.getAlpha();
      var color = new THREE.Color(actualColor.getRGB());
      if (alpha === 0) return;

      if (!_this2.outlinePasses[key]) {
        var outlinePass;

        if (_this2.outlinePassRecycleBin.length > 0) {
          outlinePass = _this2.outlinePassRecycleBin.pop();
          outlinePass.enabled = true;
        } else {
          outlinePass = new OutlinePass.OutlinePass(new THREE.Vector2(_this2.size.width, _this2.size.height), scene, camera);

          _this2.composer.insertPass(outlinePass, _this2.index);
        }

        outlinePass.visibleEdgeColor = color;
        outlinePass.hiddenEdgeColor = color;

        _this2.setConfig(outlinePass);

        _this2.outlinePasses[key] = outlinePass;
      }

      _this2.outlinePasses[key].selectedObjects = objectsByColor[key];
    });
  };

  _proto.processBorderedObjects = function processBorderedObjects(object, colorDictionary) {
    var _this3 = this;

    if (!colorDictionary) colorDictionary = {};

    if (object.borderColor && object.visible) {
      if (!colorDictionary[object.borderColor]) {
        colorDictionary[object.borderColor] = [];
      }

      colorDictionary[object.borderColor].push(object);
    } else {
      object.children.forEach(function (x) {
        return _this3.processBorderedObjects(x, colorDictionary);
      }, this);
    }

    return colorDictionary;
  };

  return OutlineManager;
}();

var RenderManager = /*#__PURE__*/function () {
  function RenderManager(sceneManager, cameraManager) {
    this.shouldRender = false;
    this.config = cameraManager.config;
    this.sceneManager = sceneManager;
    this.cameraManager = cameraManager;
    this.outlineManager = new OutlineManager(this.config);
    this.renderEvent = new SharpEvent();
  }

  var _proto = RenderManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDivRef) {
    this.rendererDivRef = rendererDivRef;
    this.setupStats();
    this.setupRenderer(this.config);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    delete this.stats;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    // for some heavier changes, it's better to perform a check first
    if (nextConfig.renderer.antialias !== this.config.renderer.antialias || nextConfig.renderer.ssaaSamples !== this.config.renderer.ssaaSamples //||
    //nextConfig.renderer.shadows.enabled !== this.config.renderer.shadows.enabled
    ) this.setupRenderer(nextConfig);
    this.applyPostProcessorConfigs(nextConfig);
    this.renderer.shadowMap.enabled = nextConfig.renderer.shadows.enabled;
    this.stats.domElement.style.visibility = nextConfig.renderer.showStats ? 'visible' : 'hidden';
    this.outlineManager.componentWillReceiveProps(nextConfig);
    this.updateShouldRenderer(true);
    this.config = nextConfig;
  };

  _proto.setupStats = function setupStats() {
    this.stats = new Stats__default["default"]();
    this.stats.domElement.style.position = 'absolute';
    this.stats.domElement.style.top = '0px';
    this.stats.domElement.style.visibility = this.config.renderer.showStats ? 'visible' : 'hidden';
    this.rendererDivRef.appendChild(this.stats.domElement);
  };

  _proto.setupRenderer = function setupRenderer(config) {
    if (this.renderer) this.rendererDivRef.removeChild(this.renderer.domElement);
    var rendererOptions = {
      antialias: config.renderer.antialias,
      preserveDrawingBuffer: true,
      alpha: true
    };
    this.renderer = new THREE.WebGLRenderer(rendererOptions);
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setClearColor(0xffffff);
    this.renderer.setClearAlpha(0);
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.shadowMap.enabled = config.renderer.shadows.enabled; // this.renderer.shadowCameraNear = 3;
    // this.renderer.shadowCameraFov = 50;
    // this.renderer.shadowMapBias = 0.0039;
    // this.renderer.shadowMapDarkness = 0.5;
    // this.renderer.shadowMapWidth = 1024;
    // this.renderer.shadowMapHeight = 1024;
    // this.renderer.shadowMap.autoUpdate = true

    this.renderer.shadowMap.autoUpdate = true;
    Equirectangular.initialize(this.renderer); // TODO: find a possible solution for the rerendering on screen size.

    this.rendererDivRef.appendChild(this.renderer.domElement);
    this.composer = null;
    this.shouldRender = true;
  };

  _proto.getBaseSize = function getBaseSize() {
    return this.rendererDivRef.getBoundingClientRect().width;
  };

  _proto.onCanvasSizeUpdate = function onCanvasSizeUpdate(width, height) {
    this.renderer.setSize(width, height);
    this.shouldRender = true;
    this.composer = null;
  };

  _proto.getScreenshot = function getScreenshot() {
    return this.renderer.domElement.toDataURL('image/png');
  };

  _proto.hasRenderer = function hasRenderer() {
    return Boolean(this.renderer);
  };

  _proto.updateShouldRenderer = function updateShouldRenderer(status) {
    // we're only interested if it becomes true
    this.shouldRender = this.shouldRender || status;
  };

  _proto.render = function render() {
    if (this.config.renderer.showStats) {
      this.stats.update();
    }

    this.outlineManager.update(this);

    if (this.shouldRender) {
      Nexus3D__default["default"].Cache.beginFrame(30); //this.renderer.render(this.sceneManager.scene, this.cameraManager.camera);

      this.renderEvent.invoke(this.renderer);
      this.renderComposer(this.sceneManager.scene, this.cameraManager.camera);
      Nexus3D__default["default"].Cache.endFrame();
    }

    this.shouldRender = false;
  };

  _proto.renderComposer = function renderComposer(scene, camera) {
    if (!this.composer) {
      var size = this.renderer.getSize(new THREE.Vector2());
      this.composer = new EffectComposer.EffectComposer(this.renderer);
      this.composer.setSize(size.x, size.y);
      var renderPass = new RenderPass.RenderPass(scene, camera);
      this.composer.addPass(renderPass);
      this.ssaaRenderPass = new SSAARenderPass.SSAARenderPass(scene, camera, 0x000000, 0);
      this.ssaaRenderPass.renderToScreen = false;
      this.composer.addPass(this.ssaaRenderPass);
      this.saoPass = new SAOPass.SAOPass(scene, camera, false, true);
      this.composer.addPass(this.saoPass);
      this.hueSaturationPass = new ShaderPass.ShaderPass(HueSaturationShader_js.HueSaturationShader);
      this.composer.addPass(this.hueSaturationPass);
      this.brightnessContrastPass = new ShaderPass.ShaderPass(BrightnessContrastShader_js.BrightnessContrastShader);
      this.composer.addPass(this.brightnessContrastPass);
      this.vignettePass = new ShaderPass.ShaderPass(VignetteShader_js.VignetteShader);
      this.composer.addPass(this.vignettePass);
      this.filmPass = new ShaderPass.ShaderPass(FilmShader_js.FilmShader);
      this.composer.addPass(this.filmPass);
      this.sepiaPass = new ShaderPass.ShaderPass(SepiaShader_js.SepiaShader);
      this.composer.addPass(this.sepiaPass);
      this.digitalGlitch = new GlitchPass.GlitchPass(64);
      this.composer.addPass(this.digitalGlitch);
      this.applyPostProcessorConfigs(this.config);
      this.outlineManager.initialize(this.renderer, this.composer);
      this.copyPass = new ShaderPass.ShaderPass(CopyShader.CopyShader);
      this.copyPass.renderToScreen = true;
      this.composer.addPass(this.copyPass);
    }

    this.outlineManager.buildColorOutlines(scene, camera);
    this.composer.render();
  };

  _proto.applyPostProcessorConfigs = function applyPostProcessorConfigs(nextConfig) {
    if (this.composer) {
      this.ssaaRenderPass.enabled = nextConfig.renderer.antialias;
      this.ssaaRenderPass.sampleLevel = this.config.renderer.ssaaSamples;
      this.saoPass.enabled = nextConfig.renderer.ssao.enabled;
      this.saoPass.params.saoIntensity = nextConfig.renderer.ssao.intensity * 0.001; // 0.00009

      this.saoPass.params.saoScale = nextConfig.renderer.ssao.scale; // 0.8

      this.saoPass.params.saoKernelRadius = nextConfig.renderer.ssao.kernelRadius; // 10

      this.saoPass.params.saoMinResolution = nextConfig.renderer.ssao.minResolution;
      this.saoPass.params.saoBlurRadius = nextConfig.renderer.ssao.blurRadius;
      this.hueSaturationPass.uniforms.hue.value = nextConfig.renderer.hue;
      this.hueSaturationPass.uniforms.saturation.value = nextConfig.renderer.saturation;
      this.brightnessContrastPass.uniforms.brightness.value = nextConfig.renderer.brightness;
      this.brightnessContrastPass.uniforms.contrast.value = nextConfig.renderer.contrast;
      this.vignettePass.uniforms.offset.value = nextConfig.renderer.vignetteOffset;
      this.vignettePass.uniforms.darkness.value = nextConfig.renderer.vignetteDarkness;
      this.digitalGlitch.enabled = nextConfig.renderer.glitch;
      this.digitalGlitch.goWild = true;
      this.sepiaPass.enabled = nextConfig.renderer.sepia;
      this.filmPass.enabled = nextConfig.renderer.film;
    }
  };

  return RenderManager;
}();

var _default$1 = /*#__PURE__*/function () {
  function _default(sceneManager, cameraManager) {
    this.scene = sceneManager.scene;
    this.config = cameraManager.config;
    this.cameraManager = cameraManager;
    this.axesHelper = new THREE.AxesHelper(1000);
    this.axesHelper.name = 'AxesHelper';
    this.axesHelper.visible = this.config.renderer.axesHelper;
    this.scene.add(this.axesHelper);
    this.ambientLight = new THREE.AmbientLight(this.config.light.color, this.config.light.intensity);
    this.scene.add(this.ambientLight);
    var sphere = new THREE.SphereBufferGeometry(2);
    this.targetHelper = new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({
      color: 0xff00ff
    }));
    this.targetHelper.visible = this.config.camera.targetHelper;
    sceneManager.scene.add(this.targetHelper);
  }

  var _proto = _default.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    // change in light props
    this.ambientLight.intensity = nextConfig.light.intensity;

    if (this.ambientLight.color !== nextConfig.light.color) {
      this.ambientLight.color = new THREE.Color(new Color(nextConfig.light.color).getRGB());
    }

    this.axesHelper.visible = nextConfig.renderer.axesHelper;
    this.targetHelper.visible = nextConfig.camera.targetHelper;
    this.config = nextConfig;
  };

  _proto.update = function update() {
    var controls = this.cameraManager.controls;
    this.targetHelper.position.set(controls.target.x, controls.target.y, controls.target.z);
  };

  return _default;
}();

var NodeManager = /*#__PURE__*/function () {
  function NodeManager(cameraManager, dataSourceManager) {
    this.hasNodesInScene = false;
    this.config = cameraManager.config;
    this.cameraManager = cameraManager;
    this.dataSourceManager = dataSourceManager;
    this.cameraManager.cameraChangeEvent.subscribe(this.onCameraChange, this);
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinished, this);
    this.nodePreparationEvent = new SharpEvent();
  }

  var _proto = NodeManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDiv) {
    this.rendererDiv = rendererDiv;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    var shouldReloadDataSource = false;

    if (!lodash.isEqual(nextConfig.dataSource, this.config.dataSource)) {
      shouldReloadDataSource = true;
    }

    if (!lodash.isEqual(nextConfig.nodeTypes, this.config.nodeTypes)) {
      // if we are already reloading the datasource, dont' do the refresh
      // because the data will be new
      if (!shouldReloadDataSource) this.refreshNodeProperties(nextConfig);
    }

    this.config = nextConfig;
  };

  _proto.refreshNodeProperties = function refreshNodeProperties(config) {
    var nodeTypeConfig = config.nodeTypes;

    for (var _iterator = _createForOfIteratorHelperLoose(this.getNodes()), _step; !(_step = _iterator()).done;) {
      var node = _step.value;
      node.applyDefaultOptions(nodeTypeConfig);
    }
  };

  _proto.update = function update() {
    var shouldRender = false;

    for (var _iterator2 = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects()), _step2; !(_step2 = _iterator2()).done;) {
      var child = _step2.value;

      if (child.material && child.material.update) {
        shouldRender = shouldRender || child.material.update();
      }
    }

    return shouldRender;
  };

  _proto.onLoadFinished = function onLoadFinished(result) {
    this.nodePreparationEvent.invoke(result); // confirm if there is at least one node.
    // if there aren't, we can perform some optimizations, such as disable ray casting

    this.hasNodesInScene = result.objects.some(function (x) {
      return x.node;
    });
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.NODE, {
      isInScene: this.isInScene,
      getNodes: this.getNodes,
      getNode: this.getNode
    }, this);
  }
  /**
   * Gets the nodes loaded in the currently loaded scene.
   * @param nameFilter Name of the nodes (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @return List of nodes in the scene.
   * @api viewer3d.node
   */
  ;

  _proto.getNodes = function getNodes(nameFilter) {
    return filterNamedObjects(this.dataSourceManager.getSceneObjects().filter(function (object3d) {
      return Boolean(object3d.node);
    }).map(function (object3d) {
      return object3d.node;
    }), nameFilter);
  }
  /**
   * Gets the first node that matches the provided name. Same as calling getNodes, but for undefined/null names, it will not return anything.
   * @param name Name of the node to be fetched.
   * @returns The node with the indicated name.
   * @api viewer3d.node
   */
  ;

  _proto.getNode = function getNode(name) {
    return this.getNodes([name])[0];
  }
  /**
   * Checks if the given node is present in the scene, as part of an object.
   * @param node The node to be checked for.
   * @return True if it present, false otherwise.
   * @api viewer3d.node
   */
  ;

  _proto.isInScene = function isInScene(node) {
    return Boolean(this.getNodes().includes(node));
  };

  _proto.onCameraChange = function onCameraChange() {
    var _this = this;

    this.getNodes().forEach(function (node) {
      return node.onCameraChange(_this.cameraManager.getCameraPosition());
    });
  };

  _proto.buildNode = function buildNode(threeJsObject, prefix, requestedType, nodeClass) {
    var currentScene = this.dataSourceManager.getCurrentScene();
    var nodeInfos = currentScene.nodes || {}; // there must be a definition of the node, even if empty

    var nodeInfo = nodeInfos[threeJsObject.name];

    if (!nodeInfo) {
      // picking nodes defined
      if (threeJsObject.name.startsWith(prefix)) threeJsObject.visible = false;
      return;
    }

    var customNodeInfo = new NodeInfo(threeJsObject.name);
    customNodeInfo.alias = threeJsObject.name; // if the mesh name follows the PICK/MARKER semantic format, we should infer
    // some defaults for the target scene and alias

    if (threeJsObject.name.startsWith(prefix)) {
      customNodeInfo.type = requestedType;
      customNodeInfo.alias = customNodeInfo.linkedScene = this.decodeSemanticName(prefix, threeJsObject.name);
    } // the actual node type can still be overridden in the definition


    lodash.merge(customNodeInfo, nodeInfo); // this function is called for all objects, so we might
    // not know our actual node type until now

    if (customNodeInfo.type === requestedType) {
      threeJsObject.name = customNodeInfo.alias;
      var nodeContainer = threeJsObject;
      nodeContainer.node = new nodeClass(threeJsObject);
      nodeContainer.node.linkedScene = this.dataSourceManager.getScene(customNodeInfo.linkedScene);
      nodeContainer.node.individualOptions = customNodeInfo.options;
      nodeContainer.node.meta = customNodeInfo.meta;
      nodeContainer.node.cameraState = customNodeInfo.cameraState;
      nodeContainer.node.enabled = customNodeInfo.enabled;
      nodeContainer.node.targetModels = customNodeInfo.targetModels;
      nodeContainer.node.applyDefaultOptions(this.config.nodeTypes);
      threeJsObject.visible = customNodeInfo.visible;
    }
  }
  /**
   * Parses a surrogate id that is usually assigned in picking boxes (and now other nodes)
   */
  ;

  _proto.decodeSemanticName = function decodeSemanticName(prefix, sid) {
    // for retro-compatibility issues, we keep this.
    // TODO: Remove after version 2.0.0 or so
    if (sid.includes('__')) {
      var strSplit = sid.split('__');
      var result = strSplit.length > 3 ? strSplit[2].concat('_-').concat(strSplit[3]) : strSplit.pop();
      console.warn('The semantic convention such as "' + sid + '" is no longer supported. Please replace with the format "' + prefix + '_' + result + '".');
      return result;
    } else {
      return sid.split('_')[1];
    }
  };

  return NodeManager;
}();

var NodeHelper = /*#__PURE__*/function () {
  function NodeHelper() {}

  /**
   * Function to pass to Array.filter() function to create a list of distinct elements.
   */
  NodeHelper.onlyUnique = function onlyUnique(value, index, it) {
    return it.indexOf(value) === index;
  };

  return NodeHelper;
}();

var SkinManager = /*#__PURE__*/function () {
  function SkinManager(sceneManager, tweenManager) {
    this.skinChanged = new SharpEvent();
    this.config = sceneManager.config;
    this.dataSourceManager = sceneManager;
    this.tweenManager = tweenManager;
    this.defaultTextureLoader = new THREE.TextureLoader();
    this.defaultTextureLoader.crossOrigin = '';
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onSceneLoadFinished, this);
  }

  var _proto = SkinManager.prototype;

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.SKIN, {
      addSkin: this.addSkin,
      setSkin: this.setSkin,
      removeSkin: this.removeSkin,
      resetSkin: this.resetSkin,
      getSkinNames: this.getSkinNames,
      getObjectSkins: this.getObjectSkins
    }, this);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.onSceneLoadFinished = function onSceneLoadFinished(result) {
    this.skins = result.skins || {};
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.dataSourceManager.onLoadFinishEvent.unsubscribeAll(this);
  }
  /**
   * Adds a skin to an object in the currently loaded scene.
   * @param skinName Name of the skin
   * @param skin Skin object to be added
   * @param nameFilter Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.skin
   */
  ;

  _proto.addSkin = function addSkin(skinName, skin, nameFilter) {
    for (var _iterator = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects(nameFilter).filter(function (x) {
      return x instanceof THREE.Mesh;
    })), _step; !(_step = _iterator()).done;) {
      var object = _step.value;
      var objectSkins = this.skins[object.name];
      if (!objectSkins) objectSkins = this.skins[object.name] = {};
      objectSkins[skinName] = skin;
    }
  }
  /**
   * Removes a skin to an object in the currently loaded scene.
   * @param skinName Name of the skin to be removed. If left null/undefined, all skins of the given objects will be removed.
   * @param nameFilter Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.skin
   */
  ;

  _proto.removeSkin = function removeSkin(skinName, nameFilter) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects(nameFilter).filter(function (x) {
      return x instanceof THREE.Mesh;
    })), _step2; !(_step2 = _iterator2()).done;) {
      var object = _step2.value;

      if (!this.skins[object.name]) {
        return;
      }

      if (skinName) {
        delete this.skins[object.name][skinName];

        if (Object.keys(this.skins[object.name]).length === 0) {
          delete this.skins[object.name];
        }
      } else {
        delete this.skins[object.name];
      }
    }
  }
  /**
   * Sets a skin to an object in the currently loaded scene.
   * @param skin Name of the skin or skin object containing the skin properties to be set.
   * @param nameFilter Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @param cumulative If true, the skin will be applied additively, otherwise the skin will be applied over the original material properties.
   * @param animationOptions If a value is set, the transition to the new target will be animated (see animation details in the AnimationOptions object page), otherwise the change will be performed instantly.
   * @returns A list of animation ids, one for each object, which can be used for pausing, resuming and stopping the animations.
   * @api viewer3d.skin
   */
  ;

  _proto.setSkin = function setSkin(skin, nameFilter, cumulative, animationOptions) {
    var _this = this;

    if (!this.skins) return;
    if (!cumulative) this.resetSkin(nameFilter);
    return this.dataSourceManager.getSceneObjects(nameFilter).filter(function (x) {
      return x instanceof THREE.Mesh;
    }).map(function (object) {
      var actualSkin; // we assume the passed skin is an object containing the properties
      // but if it is just the name of the skin

      if (typeof skin === 'string') {
        // make sure the skin for such an object exists
        var objectSkins = _this.skins[object.name];
        if (!objectSkins) return;
        actualSkin = objectSkins[skin];
        if (!actualSkin) return;
      } else {
        actualSkin = skin;
      }

      var objectAsAny = object;

      if (!objectAsAny.originalSkinMaterial) {
        objectAsAny.originalSkinMaterial = objectAsAny.material;
        objectAsAny.material = objectAsAny.material.clone();
      }

      return _this.setSkinInternal(actualSkin, object, animationOptions != null ? animationOptions : {
        duration: 0
      });
    }, this);
  }
  /**
   * Resets the skin of the selected objects to their original material properties.
   * @param [nameFilter] Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.skin
   */
  ;

  _proto.resetSkin = function resetSkin(nameFilter) {
    this.dataSourceManager.getSceneObjects(nameFilter).filter(function (x) {
      return x instanceof THREE.Mesh;
    }).forEach(function (object) {
      var objectAsAny = object;

      if (objectAsAny.originalSkinMaterial) {
        objectAsAny.material = objectAsAny.originalSkinMaterial;
        objectAsAny.originalSkinMaterial = undefined;
      }
    });
    this.skinChanged.invoke();
  }
  /**
   * Gets skin names that are available for some or all objects.
   * @return Flat list of strings with the skin names.
   * @api viewer3d.skin
   */
  ;

  _proto.getSkinNames = function getSkinNames() {
    if (this.skins) {
      return Object.values(this.skins).map(function (x) {
        return x;
      }).reduce(function (result, val) {
        return result.concat(Object.keys(val));
      }, []) // get only the skin names from the groups
      .filter(NodeHelper.onlyUnique);
    } // get only distinct skins

  }
  /**
   * Gets the available skins for the currently loaded objects.
   * @return {Map<string,Skin[]>} Object containing the skins, grouped by the object that they apply to.
   * @api viewer3d.skin
   */
  ;

  _proto.getObjectSkins = function getObjectSkins() {
    return this.skins;
  };

  _proto.setSkinInternal = function setSkinInternal(skin, object, animationOptions) {
    var _this2 = this;

    var tweens = [];

    var _loop = function _loop(skinProperty) {
      if (!Object.prototype.hasOwnProperty.call(skin, skinProperty)) {
        return "continue";
      }

      var value = skin[skinProperty];
      tweens.push(function (opts) {
        return _this2.handleMap(object.material, skinProperty, value, opts);
      });
      tweens.push(function (opts) {
        return _this2.handleColor(object.material, skinProperty, value, opts);
      });
      tweens.push(function (opts) {
        return _this2.handleAlpha(object.material, skinProperty, value, opts);
      });
    };

    for (var skinProperty in skin) {
      var _ret = _loop(skinProperty);

      if (_ret === "continue") continue;
    }

    return this.tweenManager.register(new ParallelAnimation(tweens, animationOptions));
  };

  _proto.handleMap = function handleMap(material, skinProperty, value, animationOptions) {
    var _this3 = this;

    var url = this.config.dataSource.url; // map entries have special handling
    // because they mean an url that has to be loaded

    if (skinProperty.toLowerCase().includes('map')) {
      return animate0to1(function (updateValue) {
        if (updateValue >= _this3.config.renderer.skinMapTransition) {
          if (!value) {
            material[skinProperty] = null;
          } else if (skinProperty === 'envMap') {
            var fullUrl = PathHelper.getFullUrl(url, value);
            Equirectangular.load(fullUrl, function (texture) {
              material.envMap = texture;

              _this3.refreshMaterialAndRender(material);
            });
          } else {
            var _fullUrl = PathHelper.getFullUrl(url, value);

            _this3.defaultTextureLoader.load(_fullUrl, function (texture) {
              material[skinProperty] = texture;

              _this3.refreshMaterialAndRender(material);
            });
          }
        }
      }, animationOptions);
    }
  };

  _proto.handleColor = function handleColor(material, skinProperty, value, animationOptions) {
    var _this4 = this;

    if (skinProperty === 'color' || skinProperty === 'emissive' || skinProperty === 'specular') {
      var color = new Color(value);
      return animateColor(material[skinProperty] || new THREE.Color(0xfffff), new THREE.Color(color.getRGB()), function (value) {
        material[skinProperty] = value;

        _this4.refreshMaterialAndRender(material);
      }, animationOptions);
    }
  };

  _proto.handleAlpha = function handleAlpha(material, skinProperty, value, animationOptions) {
    var _this5 = this;

    if (skinProperty === 'alpha') {
      return animateNumeric(material.opacity, value, function (value) {
        material.opacity = value;
        material.transparent = material.opacity < 1;
        material.depthWrite = !material.transparent;

        _this5.refreshMaterialAndRender(material);
      }, animationOptions);
    }
  };

  _proto.refreshMaterialAndRender = function refreshMaterialAndRender(material) {
    material.needsUpdate = true;
    this.skinChanged.invoke();
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.skinChanged];
  };

  return SkinManager;
}();

var Node = /*#__PURE__*/function () {
  /**
   * Declare a Node class.
   */
  function Node(object3d, objectType) {
    this.name = object3d.name;
    this.object3d = object3d;
    this.objectType = objectType;
    this.enabled = true;
    this.selected = false;
    this.hovered = false;
    this.cameraState = null;
    this.linkedScene = null; // these might only apply or be assigned within some subclasses

    this.boundingBox = null;
    this.borderColor = null;
    this.fillColor = null;
  }

  var _proto = Node.prototype;

  _proto.applyDefaultOptions = function applyDefaultOptions(nodeTypes) {
    var options = nodeTypes[this.objectType];
    this.options = Object.assign({}, this.defaultOptions, options, this.individualOptions);
    this.updateMaterials();
  };

  _proto.isIsFrontOfPlane = function isIsFrontOfPlane(plane) {
    return false;
  };

  _proto.closeUpPoint = function closeUpPoint() {
    return new THREE.Vector3();
  };

  return Node;
}();

var MARKER_TYPE = 'Marker';

var Marker = /*#__PURE__*/function (_Node) {
  _inheritsLoose(Marker, _Node);

  /**
   * Creates a Marker.
   * @param sprite Sprite object, to be created beforehand with the SpriteCreateHelper.
   */
  function Marker(sprite) {
    var _this;

    _this = _Node.call(this, sprite, MARKER_TYPE) || this;
    _this.sprite = sprite;
    _this.options = _this.defaultOptions = Object.assign({
      disabledColor: 'rgba(255,255,255,1)',
      normalColor: null,
      hoveredColor: null,
      selectedColor: null,
      duration: 200,
      normalImagePath: '/images/Marker.png',
      hoveredImagePath: null,
      selectedImagePath: null,
      disabledImagePath: null
    }, sprite.options);
    _this.cameraState = null; // this.boundingBox = new Box3().setFromObject(this.sprite);

    _this.boundingBox = _this.sprite.boundingBox;
    _this.color = null;
    return _this;
  }

  var _proto = Marker.prototype;

  _proto.updateMaterials = function updateMaterials() {
    var imagePath = this.options.normalImagePath;
    var color = this.options.normalColor || 'rgba(255,255,255,1)';

    if (!this.enabled) {
      imagePath = this.options.disabledImagePath || imagePath;
      color = this.options.disabledColor || color;
    }

    if (this.hovered) {
      imagePath = this.options.hoveredImagePath || imagePath;
      color = this.options.hoveredColor || color;
    }

    if (this.selected) {
      imagePath = this.options.selectedImagePath || imagePath;
      color = this.options.selectedColor || color;
    }

    this.setMap(imagePath, color);
  }
  /**
   * Sets the image of the sprite and its ghost/transparent twin.
   * @param imagePath Image to be set.
   * @param color
   */
  ;

  _proto.setMap = function setMap(imagePath, color) {
    var _this2 = this;

    new TWEEN__default["default"].Tween({}).to({
      x: 10
    }, 50).onUpdate(function () {
      _this2.sprite.setMap(imagePath);
    }).start();
    var actualColor = new Color(color);
    new TWEEN__default["default"].Tween(this.sprite.color).to(new THREE.Color(actualColor.getRGB()), this.options.duration).start();
  };

  _proto.isIsFrontOfPlane = function isIsFrontOfPlane(plane) {
    return plane.distanceToPoint(this.sprite.position) >= 0;
  };

  _proto.closeUpPoint = function closeUpPoint() {
    // console.log(this.sprite);
    // return Vector3(this.sprite.scale.x, this.sprite.scale.y, 1);
    // return this.boundingBox.getCenter(new Vector3());
    return this.sprite.position;
  };

  _proto.onCameraChange = function onCameraChange(cameraPosition) {};

  return Marker;
}(Node);

function filterOfType(type, array) {
  if ('isObjectOfType' in type) {
    return array.filter(function (item) {
      return type.isObjectOfType(item);
    });
  }

  return array.filter(function (item) {
    return item instanceof type;
  });
}

var NodeContainer = /*#__PURE__*/function () {
  function NodeContainer() {}

  NodeContainer.isObjectOfType = function isObjectOfType(obj) {
    return !!obj.node && obj.node instanceof Node;
  };

  return NodeContainer;
}();

var MarkerManager = /*#__PURE__*/function () {
  function MarkerManager(dataSourceManager, cameraManager, nodeManager) {
    this.markerChanged = new SharpEvent();
    this.config = dataSourceManager.config;
    this.dataSourceManager = dataSourceManager;
    this.cameraManager = cameraManager;
    this.nodeManager = nodeManager;
    this.cameraManager.cameraChangeEvent.subscribe(this.onCameraChange, this);
    this.nodeManager.nodePreparationEvent.subscribe(this.onNodePreparation, this);
  }

  var _proto = MarkerManager.prototype;

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.MARKER, {
      addMarker: this.addMarker,
      removeMarker: this.removeMarker,
      listMarkers: this.listMarkers
    }, this);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.nodeManager.nodePreparationEvent.unsubscribeAll(this);
    this.cameraManager.cameraChangeEvent.unsubscribeAll(this);
  };

  _proto.onNodePreparation = function onNodePreparation() {
    this.updateSpriteScale();
    this.buildMarkersOnSprites();
  };

  _proto.onCameraChange = function onCameraChange() {
    this.updateSpriteScale();
  };

  _proto.updateSpriteScale = function updateSpriteScale() {
    var spritesScaled = false;

    for (var _iterator = _createForOfIteratorHelperLoose(filterOfType(SpecialSprite, this.dataSourceManager.getSceneObjects())), _step; !(_step = _iterator()).done;) {
      var sprite = _step.value;
      if (!sprite.originalScale || !sprite.relative) continue; // since the marker is always facing the camera, we take a sized vector in the camera up direction
      // (converted to world coordinates)
      // then we calculate the current screen size of the marker by getting the bottom and top coordinates
      // we then determine the screen size in order to determine how much the object has to be scaled in order
      // to maintain the desired size (which is the sprite's resolution * scale, as indicated in the originalScale)

      var upVector = this.cameraManager.getWorldDirection(new THREE.Vector3(0, sprite.originalScale.y, 0));
      var baseScreenSize = this.cameraManager.getScreenPosition(sprite.position);
      var topScreenSize = this.cameraManager.getScreenPosition(sprite.position.clone().add(upVector));
      var screenSizeY = Math.abs(baseScreenSize.y - topScreenSize.y);
      var newYScale = sprite.originalScale.y * sprite.originalScale.y / screenSizeY; // we can apply minimum limits to avoid having tiny sprites

      if (sprite.minSize) newYScale = Math.max(sprite.originalScale.y * sprite.minSize, newYScale); // or apply maximum limits to avoid having gigantic sprites

      if (sprite.maxSize) newYScale = Math.min(sprite.originalScale.y * sprite.maxSize, newYScale); // it's easier and less error-prone to simply extract the x scale from the original ratio

      var newXScale = newYScale * (sprite.originalScale.x / sprite.originalScale.y);
      sprite.scale.set(newXScale, newYScale, 1);
      spritesScaled = true;
    }

    if (spritesScaled) {
      this.markerChanged.invoke();
    }
  };

  _proto.buildMarkersOnSprites = function buildMarkersOnSprites() {
    for (var _iterator2 = _createForOfIteratorHelperLoose(filterOfType(SpecialSprite, this.dataSourceManager.getSceneObjects())), _step2; !(_step2 = _iterator2()).done;) {
      var sprite = _step2.value;
      this.nodeManager.buildNode(sprite, 'MARKER', MARKER_TYPE, Marker);
    }
  }
  /**
   * Adds a sprite marker to the scene.
   * @param imagePath Path string to the image
   * @param position Object with x, y, z fields indicating the position of the marker
   * @param scale Floating point number indicating the scale of the object
   * @param offset Object with x, y, z fields indicating the offset of the marker, from which to draw a line. If left null,
   * no line will be drawn.
   * @param cameraState Camera state to set. Can be null to avoid having the effect.
   * @param metadata Extra information to set on the marker object.
   * @param persistent Boolean indicating if the marker is persistent across different node loads. If not, the marker will
   * be automatically removed when a new node content is loaded.
   * @param line Line drawing options, to create a callout-like effect on the marker.
   * @param effects Image modification effects, such as text overlays.
   * @return Marker object.
   * @api viewer3d.marker
   */
  ;

  _proto.addMarker = function addMarker(imagePath, position, scale, offset, cameraState, metadata, persistent, line, effects) {
    var _this = this;

    var options = {
      position: position,
      scale: scale,
      center: {
        x: 0.5,
        y: 0
      },
      offset: offset,
      line: line,
      effects: effects
    };
    var sprite = new SpecialSprite(imagePath, options, function () {
      sprite.metadata = metadata;
      sprite.node = new Marker(sprite);
      sprite.node.persistent = persistent;
      sprite.node.cameraState = cameraState;
      sprite.node.applyDefaultOptions(_this.config.nodeTypes);
      sprite.persistent = persistent;
      sprite.isMarker = true;

      _this.markerChanged.invoke();

      _this.dataSourceManager.addSceneObject(sprite);
    });
    return sprite.node;
  }
  /**
   * Removes a marker (and its offset line) from the scene.
   * @param marker {Marker} Marker to remove.
   * @api viewer3d.marker
   */
  ;

  _proto.removeMarker = function removeMarker(marker) {
    this.dataSourceManager.removeSceneObject(marker.sprite);
    this.markerChanged.invoke();
  }
  /**
   * Gets a list of all markers currently present on the scene.
   * @return List of markers.
   * @api viewer3d.marker
   */
  ;

  _proto.listMarkers = function listMarkers() {
    return filterOfType(Marker, filterOfType(NodeContainer, this.dataSourceManager.getSceneObjects()).map(function (x) {
      return x.node;
    }));
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.markerChanged];
  };

  return MarkerManager;
}();

var WireframeManager = /*#__PURE__*/function () {
  function WireframeManager(dataSourceManager) {
    this.config = dataSourceManager.config;
    this.dataSourceManager = dataSourceManager;
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinished, this);
  }

  var _proto = WireframeManager.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    if (this.config.renderer.enableWireframe !== nextConfig.renderer.enableWireframe) {
      this.updateWireframe(nextConfig.renderer.enableWireframe, nextConfig.renderer.wireframeColor);
    }

    if (nextConfig.renderer.enableWireframe && this.config.renderer.wireframeColor !== nextConfig.renderer.wireframeColor) {
      for (var _iterator = _createForOfIteratorHelperLoose(this.dataSourceManager.getMeshChildren()), _step; !(_step = _iterator()).done;) {
        var mesh = _step.value;
        var wireframeMesh = mesh; //we can use the object id in a hashmap: https://threejs.org/docs/#api/en/core/Object3D

        wireframeMesh.wireframeChild.material.color = new THREE.Color(new Color(nextConfig.renderer.wireframeColor).getThreeColor());
      }
    }

    this.config = nextConfig;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.dataSourceManager.onLoadFinishEvent.unsubscribeAll(this);
  };

  _proto.onLoadFinished = function onLoadFinished() {
    this.updateWireframe(this.config.renderer.enableWireframe, this.config.renderer.wireframeColor);
  };

  _proto.updateWireframe = function updateWireframe(enableWireframe, color) {
    if (enableWireframe) {
      var mat = new THREE.LineBasicMaterial({
        color: new Color(color).getThreeColor()
      });

      for (var _iterator2 = _createForOfIteratorHelperLoose(this.dataSourceManager.getMeshChildren()), _step2; !(_step2 = _iterator2()).done;) {
        var mesh = _step2.value;
        // add the wireframe lines
        var geo = new THREE.EdgesGeometry(mesh.geometry); // or WireframeGeometry

        var wireframe = new THREE.LineSegments(geo, mat);
        mesh.add(wireframe);
        var wireframeMesh = mesh;
        wireframeMesh.wireframeChild = wireframe;
      }
    } else {
      for (var _iterator3 = _createForOfIteratorHelperLoose(this.dataSourceManager.getMeshChildren()), _step3; !(_step3 = _iterator3()).done;) {
        var _mesh = _step3.value;
        var _wireframeMesh = _mesh;

        if (_wireframeMesh.wireframeChild) {
          _wireframeMesh.remove(_wireframeMesh.wireframeChild);

          _wireframeMesh.wireframeChild = undefined;
        }
      }
    }
  };

  return WireframeManager;
}();

var MeshManager$1 = /*#__PURE__*/function () {
  function MeshManager(sceneManager) {
    this.config = sceneManager.config;
    this.dataSourceManager = sceneManager;
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinished, this);
  }

  var _proto = MeshManager.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    if (this.config.renderer.enableDoubleSide !== nextConfig.renderer.enableDoubleSide) {
      this.updateDoubleSide(nextConfig.renderer.enableDoubleSide);
    }

    this.config = nextConfig;
  };

  _proto.onLoadFinished = function onLoadFinished() {
    this.updateDoubleSide(this.config.renderer.enableDoubleSide);
  };

  _proto.updateDoubleSide = function updateDoubleSide(enableDoubleSide) {
    for (var _iterator = _createForOfIteratorHelperLoose(this.dataSourceManager.getMeshChildren()), _step; !(_step = _iterator()).done;) {
      var mesh = _step.value;
      mesh.material.side = enableDoubleSide ? THREE.DoubleSide : THREE.FrontSide;
    }
  };

  return MeshManager;
}();

var AnimationManager = /*#__PURE__*/function () {
  function AnimationManager(dataSourceManager, tweenManager) {
    this.config = dataSourceManager.config;
    this.dataSourceManager = dataSourceManager;
    this.clock = new THREE.Clock();
    this.tweenManager = tweenManager;
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinished, this);
  }

  var _proto = AnimationManager.prototype;

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.ANIMATION, {
      startAnimationsLooping: this.startAnimationsLooping,
      startAnimationsOnce: this.startAnimationsOnce,
      startAnimations: this.startAnimations,
      pauseAnimations: this.pauseAnimations,
      resumeAnimations: this.resumeAnimations,
      seekAnimations: this.seekAnimations,
      stopAnimations: this.stopAnimations,
      getAnimationNames: this.getAnimationNames,
      removeAnimations: this.removeAnimations
    }, this);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.update = function update() {
    var shouldRender = false;
    var delta = this.clock.getDelta();

    for (var _iterator = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects()), _step; !(_step = _iterator()).done;) {
      var sceneObject = _step.value;
      var mixerObject = sceneObject;

      if (mixerObject.mixer) {
        mixerObject.mixer.update(delta);
        shouldRender = true;
      }
    }

    return shouldRender;
  };

  _proto.onLoadFinished = function onLoadFinished(result) {
    this.animations = result.animations;
    var loadedAnimationNames = this.animations.map(function (x) {
      return x.name;
    });
    var initialAnimationState = this.config.animation.initialState;

    if (initialAnimationState !== 'paused') {
      switch (initialAnimationState) {
        case 'loopOnce':
          this.startAnimations({
            invert: false
          }, loadedAnimationNames);
          break;

        case 'loopOnceInverted':
          this.startAnimations({
            invert: false
          }, loadedAnimationNames);
          break;

        case 'loopPingPong':
          this.startAnimations({
            invert: false,
            repetitions: Infinity
          }, loadedAnimationNames);
          break;
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.dataSourceManager.onLoadFinishEvent.unsubscribeAll(this);
  };

  _proto.getAnimations = function getAnimations() {
    return this.animations.concat(this.tweenManager.getAnimations());
  }
  /**
   * Gets the names of all available animations from all objects.
   * @api viewer3d.animation
   */
  ;

  _proto.getAnimationNames = function getAnimationNames() {
    return this.getAnimations().map(function (x) {
      return x.name;
    });
  }
  /**
   * Starts all animations from all objects, keeping them forever looping in “ping-pong” mode
   * (from the start to end point, then back from end to start point, in a seamless effect).
   * @param nameFilter Name of the animation (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.animation
   * @deprecated
   */
  ;

  _proto.startAnimationsLooping = function startAnimationsLooping(nameFilter) {
    console.warn('This function has been deprecated. Please use startAnimations with {repetitions: Infinity}.');

    for (var _iterator2 = _createForOfIteratorHelperLoose(filterNamedObjects(this.getAnimations(), nameFilter)), _step2; !(_step2 = _iterator2()).done;) {
      var animation = _step2.value;
      animation.start({
        repetitions: Infinity
      });
    }
  }
  /**
   * Runs all animations from all objects, once, then stops.
   * @param invert (Optional) If true, the animations should be performed backwards (default is false), otherwise they will be played normally.
   * @param nameFilter Name of the animation (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @deprecated
   * @api viewer3d.animation
   */
  ;

  _proto.startAnimationsOnce = function startAnimationsOnce(invert, nameFilter) {
    console.warn('This function has been deprecated. Please use startAnimations with {invert: true}.');

    for (var _iterator3 = _createForOfIteratorHelperLoose(filterNamedObjects(this.getAnimations(), nameFilter)), _step3; !(_step3 = _iterator3()).done;) {
      var animation = _step3.value;
      animation.start({
        invert: true
      });
    }
  }
  /**
   * Runs all animations from all objects, according to the defined play options.
   * @param playOptions Optional play options, such as for looping or reversing the play order.
   * @param nameFilter Name of the animation (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.animation
   */
  ;

  _proto.startAnimations = function startAnimations(playOptions, nameFilter) {
    for (var _iterator4 = _createForOfIteratorHelperLoose(filterNamedObjects(this.getAnimations(), nameFilter)), _step4; !(_step4 = _iterator4()).done;) {
      var animation = _step4.value;
      animation.start(playOptions);
    }
  }
  /**
   * Resumes all animations from all objects at their current frame.
   * @param nameFilter Name of the animation (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.animation
   */
  ;

  _proto.resumeAnimations = function resumeAnimations(nameFilter) {
    for (var _iterator5 = _createForOfIteratorHelperLoose(filterNamedObjects(this.getAnimations(), nameFilter)), _step5; !(_step5 = _iterator5()).done;) {
      var animation = _step5.value;
      animation.resume();
    }
  }
  /**
   * Pauses all animations from all objects at their current frame.
   * @param nameFilter Name of the animation (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.animation
   */
  ;

  _proto.pauseAnimations = function pauseAnimations(nameFilter) {
    for (var _iterator6 = _createForOfIteratorHelperLoose(filterNamedObjects(this.getAnimations(), nameFilter)), _step6; !(_step6 = _iterator6()).done;) {
      var animation = _step6.value;
      animation.pause();
    }
  }
  /**
   * Stops all animations from all given objects, resetting their state back to the first frame.
   * @param nameFilter Name of the animation (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.animation
   */
  ;

  _proto.stopAnimations = function stopAnimations(nameFilter) {
    for (var _iterator7 = _createForOfIteratorHelperLoose(filterNamedObjects(this.getAnimations(), nameFilter)), _step7; !(_step7 = _iterator7()).done;) {
      var animation = _step7.value;
      animation.stop();
    }
  }
  /**
   * Moves the animations to a certain frame.
   * @param percentage Percentage/fraction (between 0 and 1) of the animation to move to.
   * @param nameFilter Name of the animation (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.animation
   */
  ;

  _proto.seekAnimations = function seekAnimations(percentage, nameFilter) {
    for (var _iterator8 = _createForOfIteratorHelperLoose(filterNamedObjects(this.getAnimations(), nameFilter)), _step8; !(_step8 = _iterator8()).done;) {
      var animation = _step8.value;
      animation.seek(percentage);
    }
  }
  /**
   * Stops and removes animations from the registry.
   * @param nameFilter Name of the animation (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.animation
   */
  ;

  _proto.removeAnimations = function removeAnimations(nameFilter) {
    for (var _iterator9 = _createForOfIteratorHelperLoose(filterNamedObjects(this.getAnimations(), nameFilter)), _step9; !(_step9 = _iterator9()).done;) {
      var animation = _step9.value;
      //mark for disposal?
      this.tweenManager.cancel(animation.name);
    }
  };

  return AnimationManager;
}();

var clipPlaneNormalsMap = {
  'X Up': {
    x: 1,
    y: 0,
    z: 0
  },
  'X Down': {
    x: -1,
    y: 0,
    z: 0
  },
  'Y Up': {
    x: 0,
    y: 1,
    z: 0
  },
  'Y Down': {
    x: 0,
    y: -1,
    z: 0
  },
  'Z Up': {
    x: 0,
    y: 0,
    z: 1
  },
  'Z Down': {
    x: 0,
    y: 0,
    z: -1
  }
};

var PlaneClippingManager = /*#__PURE__*/function () {
  function PlaneClippingManager(renderManager, dataSourceManager, nodeManager) {
    this.config = dataSourceManager.config;
    this.renderManager = renderManager;
    this.nodeManager = nodeManager;
    this.dataSourceManager = dataSourceManager;
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onNodesLoadFinished, this);
  }

  var _proto = PlaneClippingManager.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.renderManager.renderer.localClippingEnabled = this.config.renderer.clipPlaneEnabled;

    if (this.config.renderer.clipPlaneNormal && this.config.renderer.clipPlaneOffset !== null && this.config.renderer.clipPlaneOffset !== undefined) {
      // invert the normal, since it makes more sense to see the plane normal as the face we're looking at
      var normal = toVector3(this.getVectorValue(this.config.renderer.clipPlaneNormal)).multiplyScalar(-1);
      var constant = this.config.renderer.clipPlaneOffset;
      this.plane = new THREE.Plane(normal, constant);
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.renderManager.renderer.localClippingEnabled = nextConfig.renderer.clipPlaneEnabled;
    var planeChanged = false;

    if (!lodash.isEqual(this.config.renderer.clipPlaneNormal, nextConfig.renderer.clipPlaneNormal) || this.config.renderer.clipPlaneOffset !== nextConfig.renderer.clipPlaneOffset) {
      var constant = nextConfig.renderer.clipPlaneOffset;
      var normal = toVector3(this.getVectorValue(nextConfig.renderer.clipPlaneNormal)).multiplyScalar(-1);
      this.plane = new THREE.Plane(normal, constant);
      planeChanged = true;
    }

    if (nextConfig.renderer.clipPlaneEnabled
    /* && this.config.renderer.clipSectionColor !== nextConfig.renderer.clipSectionColor */
    ) {
      this.setupSceneObjects(nextConfig.renderer.clipSectionColor);
    }

    if (planeChanged || nextConfig.renderer.clipPlaneEnabled !== this.config.renderer.clipPlaneEnabled) {
      this.reevaluateObjectsBehindPlane(nextConfig.renderer.clipPlaneEnabled);
    }

    this.config = nextConfig;
  };

  _proto.reevaluateObjectsBehindPlane = function reevaluateObjectsBehindPlane(clipPlaneEnabled) {
    for (var _iterator = _createForOfIteratorHelperLoose(this.nodeManager.getNodes()), _step; !(_step = _iterator()).done;) {
      var node = _step.value;
      node.object3d.visible = node.isIsFrontOfPlane(this.plane) || !clipPlaneEnabled;
    }
  };

  _proto.onNodesLoadFinished = function onNodesLoadFinished() {
    if (this.config.renderer.clipPlaneEnabled) {
      this.setupSceneObjects(this.config.renderer.clipSectionColor);
      this.reevaluateObjectsBehindPlane(this.config.renderer.clipPlaneEnabled);
    }
  };

  _proto.setupSceneObjects = function setupSceneObjects(clipSectionColor) {
    clipSectionColor = clipSectionColor ? new Color(clipSectionColor).getThreeColor() : null;

    for (var _iterator2 = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects()), _step2; !(_step2 = _iterator2()).done;) {
      var sceneObject = _step2.value;
      var child = sceneObject; // affects meshes, but not pickingboxes and such

      if (sceneObject instanceof THREE.Mesh && !child.node) {
        // set up local clipping planes only
        child.material.side = THREE.FrontSide;
        child.material.clippingPlanes = [this.plane];
        child.material.clipIntersection = true; // create (or update) a copy of the mesh with inverted face rendering
        // just so as to give the effect of the cap

        if (child.clippingMesh) {
          if (clipSectionColor) child.clippingMesh.material.color = clipSectionColor;else {
            child.remove(child.clippingMesh);
            delete child.clippingMesh;
          }
        } else if (clipSectionColor) {
          var material = new THREE.MeshBasicMaterial({
            color: clipSectionColor,
            side: THREE.BackSide
          });
          material.clippingPlanes = [this.plane];
          material.clipIntersection = true;
          material.polygonOffset = true;
          material.polygonOffsetFactor = 1; // material.polygonOffsetUnits = -1;

          child.clippingMesh = new THREE.Mesh(child.geometry, material);
          child.add(child.clippingMesh);
        }
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.dataSourceManager.onLoadFinishEvent.unsubscribeAll(this);
  };

  _proto.getVectorValue = function getVectorValue(stringOrVector) {
    if (typeof stringOrVector === 'string') {
      return clipPlaneNormalsMap[stringOrVector];
    }

    return stringOrVector;
  };

  return PlaneClippingManager;
}();

var NodeFrameManager = /*#__PURE__*/function () {
  function NodeFrameManager(cameraManager, sceneManager, nodeManager) {
    this.config = cameraManager.config;
    this.cameraManager = cameraManager;
    this.dataSourceManager = sceneManager;
    this.nodeManager = nodeManager;
  }

  var _proto = NodeFrameManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDiv) {
    this.rendererDiv = rendererDiv;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.NODE, {
      frameNode: this.frameNode,
      frameNodes: this.frameNodes,
      closeUpNode: this.closeUpNode
    }, this);
  }
  /**
   * Moves the camera view position so that it frames the given node.
   * If the node has an assigned cameraState, the camera will be set to that location.
   * Otherwise, a normal framing will be performed based on its bounding box.
   * @param node Node object to frame.
   * @param animation If a value is set, the transition to the new location will be animated according to the defined options, otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.node
   */
  ;

  _proto.frameNode = function frameNode(node, animation) {
    if (node.cameraState) {
      return this.cameraManager.setCameraState(node.cameraState, {});
    } else {
      return this.cameraManager.frameBox(node.boundingBox, null, animation);
    }
  }
  /**
   * Moves the camera view position so that it frames all the given nodes.
   * @param nodes Nodes to frame.
   * @param animation If a value is set, the transition to the new location will be animated according to the defined options, otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.node
   */
  ;

  _proto.frameNodes = function frameNodes(nodes, animation) {
    var wholeBoundingBox = this.dataSourceManager.calculateBoundingBox(nodes.map(function (node) {
      return node.object3d;
    }));
    return this.cameraManager.frameBox(wholeBoundingBox, null, animation);
  }
  /**
   * Moves the camera view position to a certain distance of the center of the given node.
   * Can be used both to close in on the node and to withdraw from it.
   *
   * @param node Node on which the camera close up should be performed.
   * @param closeUpDistance Distance to be kept between the node center and the camera position.
   * @param animation If a value is set, the transition to the new location will be animated according to the defined options, otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.node
   */
  ;

  _proto.closeUpNode = function closeUpNode(node, closeUpDistance, animation) {
    var newTarget = node.closeUpPoint();
    return this.cameraManager.moveTo(newTarget, closeUpDistance, animation);
  };

  return NodeFrameManager;
}();

var NodeSelectionManager = /*#__PURE__*/function () {
  function NodeSelectionManager(cameraManager, dataSourceManager, nodeManager, nodeFrameManager) {
    this.selectedNodes = [];
    this.config = cameraManager.config;
    this.cameraManager = cameraManager;
    this.dataSourceManager = dataSourceManager;
    this.nodeManager = nodeManager;
    this.nodeFrameManager = nodeFrameManager;
    this.rayCaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();
    this.previousTouchTime = 0;
    this.longPressed = false;
    this.rayCaster.layers.enable(this.cameraManager.getCameraLayer());
    this.nodeSelectionChangedEvent = new SharpEvent();
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinished, this);
  }

  var _proto = NodeSelectionManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDiv) {
    this.rendererDiv = rendererDiv;
  };

  _proto.onLoadFinished = function onLoadFinished() {
    this.selectedNodes = [];
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry, api) {
    this.api = api;
    apiRegistry.register(Viewer3DApi.TYPES.NODE, {
      selectNode: this.selectNode,
      selectNodes: this.selectNodes,
      loadLinkedScene: this.loadLinkedScene,
      deselectAllNodes: this.deselectAllNodes,
      getSelectedNodes: this.getSelectedNodes
    }, this);
  }
  /**
   * the click doesn't make a distinction between a single click and a drag..release
   * so picking could occur after a camera drag, which is not intended. This has
   * required a logic using the this.mouseMoved flag and the mouseup and mousedown events.
   */
  ;

  _proto.onMouseDown = function onMouseDown() {
    this.mouseMoved = false;
    this.longPressed = false;
  };

  _proto.onTouchStart = function onTouchStart(e) {
    var _this = this;

    var interval = this.config.nodes.longPressInterval;
    var firstTouch = e.touches[0];
    this.pressTimer = window.setTimeout(function () {
      return _this.onLongTouch(firstTouch);
    }, interval);
  };

  _proto.onMouseMove = function onMouseMove(event) {
    clearTimeout(this.pressTimer);
    var previousCoords = {
      x: this.mouse.x,
      y: this.mouse.y
    };
    this.mouse = this.getMouseLocation(event); // if indeed there was a mouse movement

    if (Math.abs(this.mouse.x - previousCoords.x) > 0 || Math.abs(this.mouse.y - previousCoords.y) > 0) this.mouseMoved = true;
    if (!this.updateIntersectedObject()) return;
    this.updateHoveredEffects();
  };

  _proto.onMouseUp = function onMouseUp(e) {
    if (!this.mouseMoved && !this.longPressed) {
      this.mouse = this.getMouseLocation(e);
      this.updateIntersectedObject();

      if (this.intersectedObject && this.intersectedObject.node) {
        if (e.button === 2) {
          this.config.nodes.onNodeLongOrRightClick(this.api, this.intersectedObject.node);
        } else {
          var cumulative = e.shiftKey && this.config.nodes.allowMultiSelect;
          this.selectObject3d(this.intersectedObject, 'ui', cumulative);
        }
      } else if (!e.shiftKey && this.config.nodes.clickOnVoidToDeselect) {
        this.deselectAllNodes('ui');
        this.nodeSelectionChangedEvent.invoke([]);
      }
    }
  };

  _proto.onTouchEnd = function onTouchEnd() {
    clearTimeout(this.pressTimer);
    var touchTime = new Date().getTime();

    if (touchTime - this.previousTouchTime < this.config.nodes.doubleTapInterval) {
      this.onMouseDoubleClick();
    }

    this.previousTouchTime = touchTime; // this gets called on touchscreens only, after the onMouseUp
    // since touchscreens don't have mouse move, a hovered object would
    // remain in hovered state after a mouse Up, so we reset the intersected object
    // so that the hovered state does not stay on after a touch drag

    this.intersectedObject = null;
    this.updateHoveredEffects();
  };

  _proto.onMouseDoubleClick = function onMouseDoubleClick() {
    if (this.intersectedObject && this.intersectedObject.node) {
      this.config.nodes.onNodeDoubleClick(this.api, this.intersectedObject.node);
      var linkedScene = this.intersectedObject.node.linkedScene;
      if (linkedScene && this.config.nodes.doubleClickToLoad) this.dataSourceManager.loadScene(linkedScene);
    }
  };

  _proto.onLongTouch = function onLongTouch(event) {
    this.mouse = this.getMouseLocation(event);
    if (!this.updateIntersectedObject()) return;
    this.updateHoveredEffects();

    if (this.intersectedObject && this.intersectedObject.node) {
      this.config.nodes.onNodeLongOrRightClick(this.api, this.intersectedObject.node);
    }

    this.longPressed = true;
  };

  _proto.selectObject3d = function selectObject3d(object3d, origin, cumulative) {
    if (object3d) {
      var targetNode = object3d.node;

      if (cumulative) {
        if (this.selectedNodes.includes(targetNode)) {
          this.selectedNodes = this.selectedNodes.filter(function (x) {
            return x !== targetNode;
          });
          this.config.nodes.onNodeDeselect(this.api, targetNode, origin, this.selectedNodes);
        } else {
          this.selectedNodes.push(targetNode);
          this.config.nodes.onNodeSelect(this.api, targetNode, origin, this.selectedNodes);
        }
      } else {
        this.selectedNodes = [targetNode];
        this.config.nodes.onNodeSelect(this.api, targetNode, origin, this.selectedNodes);
      }

      this.nodeSelectionChangedEvent.invoke(this.selectedNodes);

      if (this.selectedNodes.length === 1) {
        if (this.config.camera.selectionFraming) this.nodeFrameManager.frameNode(object3d.node);
      } else if (this.selectedNodes.length > 1) {
        var objects3d = this.selectedNodes.map(function (node) {
          return node.object3d;
        }, this);
        var selectionBoundingBox = this.dataSourceManager.calculateBoundingBox(objects3d);
        if (this.config.camera.selectionFraming) this.cameraManager.frameBox(selectionBoundingBox);
      }
    }

    for (var _iterator = _createForOfIteratorHelperLoose(this.nodeManager.getNodes()), _step; !(_step = _iterator()).done;) {
      var node = _step.value;
      node.selected = this.selectedNodes.includes(node);
      if (node.selected) node.hovered = false;
      node.updateMaterials();
    }
  }
  /**
   * Selects a node.
   * Triggers onNodeSelect event of origin 'user'.
   * @param node Node to be selected.
   * @param cumulative Indicates if the selection is supposed to have a cumulative effect (the same addition/removal effect as if shift was pressed).
   * @api viewer3d.node
   */
  ;

  _proto.selectNode = function selectNode(node, cumulative) {
    this.selectObject3d(node.object3d, 'user', cumulative);
  }
  /**
   * Selects a list of nodes. Triggers onNodeSelect event of origin 'user', with the last node in the list and the nodeList filled.
   * @param nodes List of nodes to be selected. If empty, all nodes will be deselected.
   * @api viewer3d.node
   */
  ;

  _proto.selectNodes = function selectNodes(nodes) {
    if (nodes.length === 0) {
      this.deselectAllNodes();
      return;
    }

    var lastNode = nodes[nodes.length - 1]; // in order to avoid calling the event many times, we select all

    this.selectedNodes = nodes.slice(0, nodes.length - 1);
    this.selectObject3d(lastNode.object3d, 'user', true);
  }
  /**
   * Loads the scene linked to a node in the currently scene, i.e. loads a scene associated to the node, if defined.
   * @param node Node to be loaded.
   * @return True if the node has an associated scene, false otherwise .
   * @api viewer3d.node
   */
  ;

  _proto.loadLinkedScene = function loadLinkedScene(node) {
    if (node.linkedScene) {
      this.dataSourceManager.loadScene(node.linkedScene);
      return true;
    }

    return false;
  }
  /**
   * Deselects all nodes.
   * @api viewer3d.node
   */
  ;

  _proto.deselectAllNodes = function deselectAllNodes(origin) {
    if (!this.selectedNodes.length) return;
    var lastItem = this.selectedNodes[this.selectedNodes.length - 1];

    for (var _iterator2 = _createForOfIteratorHelperLoose(this.selectedNodes), _step2; !(_step2 = _iterator2()).done;) {
      var selectedNode = _step2.value;
      selectedNode.selected = false;
      selectedNode.updateMaterials();
    }

    this.selectedNodes = [];
    origin = origin || 'user';
    this.config.nodes.onNodeDeselect(this.api, lastItem, origin, []);
  }
  /**
   * Fetches all selected nodes.
   * @return A list with all the selected nodes.
   * @api viewer3d.node
   */
  ;

  _proto.getSelectedNodes = function getSelectedNodes() {
    return Array.from(this.selectedNodes);
  };

  _proto.getMouse3DCoordinates = function getMouse3DCoordinates() {
    this.rayCaster.setFromCamera(this.mouse, this.cameraManager.camera);
    var intersections = this.rayCaster.intersectObjects(this.dataSourceManager.group.children, true);
    return intersections.length > 0 ? intersections[0].point : null;
  };

  _proto.getMouseLocation = function getMouseLocation(event) {
    var clientRect = this.rendererDiv.getBoundingClientRect();
    var x = (event.clientX - clientRect.left) / clientRect.width * 2 - 1;
    var y = -((event.clientY - clientRect.top) / clientRect.height) * 2 + 1;
    return new THREE.Vector2(x, y);
  };

  _proto.updateIntersectedObject = function updateIntersectedObject() {
    // running this function before we are ready would cause bounding box calculation errors
    if (!this.dataSourceManager.sceneLoaded || !this.nodeManager.hasNodesInScene || this.cameraManager.animating) {
      return false;
    }

    this.rayCaster.setFromCamera(this.mouse, this.cameraManager.camera);
    var items = this.dataSourceManager.getSceneObjects().filter(function (x) {
      return x.node && x.node.enabled;
    });
    var intersections = this.rayCaster.intersectObjects(items);
    this.intersectedObject = intersections.length > 0 ? intersections[0].object : null;
    return true;
  };

  _proto.updateHoveredEffects = function updateHoveredEffects() {
    // the object that was hit will become hovered, the others will not
    for (var _iterator3 = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects()), _step3; !(_step3 = _iterator3()).done;) {
      var currentThreeObject = _step3.value;

      if (currentThreeObject.node) {
        var currentNode = currentThreeObject.node;
        var newState = currentThreeObject === this.intersectedObject;

        if (currentNode.hovered !== newState) {
          currentNode.hovered = newState;

          if (currentNode.hovered) {
            this.config.nodes.onNodeHover(this.api, currentNode);
          } else {
            this.config.nodes.onNodeUnhover(this.api, currentNode);
          }

          currentNode.updateMaterials();
        }
      }
    }
  };

  return NodeSelectionManager;
}();

var NodeStatusManager = /*#__PURE__*/function () {
  function NodeStatusManager(cameraManager, nodeManager) {
    this.config = cameraManager.config;
    this.cameraManager = cameraManager;
    this.nodeManager = nodeManager;
  }

  var _proto = NodeStatusManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDiv) {
    this.rendererDiv = rendererDiv;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.NODE, {
      getNodeCenter: this.getNodeCenter,
      setNodesFillColors: this.setNodesFillColors,
      setNodesBorderColors: this.setNodesBorderColors,
      setNodesEnabled: this.setNodesEnabled,
      isNodeEnabled: this.isNodeEnabled,
      hasLinkedScene: this.hasLinkedScene,
      getNodeFillColor: this.getNodeFillColor,
      getNodeBorderColor: this.getNodeBorderColor,
      getScreenPositionOfNode: this.getScreenPositionOfNode
    }, this);
  }
  /**
   * Sets the base fill color of the nodes.
   * @param color Fill color (css3-compatible format) to be set.
   * @param nodes List of nodes where to apply the color.
   * @api viewer3d.node
   */
  ;

  _proto.setNodesFillColors = function setNodesFillColors(color, nodes) {
    nodes.forEach(function (node) {
      node.fillColor = color;
      node.updateMaterials();
    }, this);
  }
  /**
   * Sets the base border color of the nodes.
   * @param color Border color (css3-compatible format) to be set.
   * @param nodes List of nodes where to apply the color.
   * @api viewer3d.node
   */
  ;

  _proto.setNodesBorderColors = function setNodesBorderColors(color, nodes) {
    nodes.forEach(function (node) {
      node.borderColor = color;
      node.updateMaterials();
    }, this);
  }
  /**
   * Enables or disables nodes.
   * @param state True or false to enable or disable the nodes.
   * @param nodes List of nodes where to apply the change.
   * @api viewer3d.node
   */
  ;

  _proto.setNodesEnabled = function setNodesEnabled(state, nodes) {
    nodes.forEach(function (node) {
      node.enabled = state;
      node.updateMaterials();
    }, this);
  }
  /**
   * Indicates if the given node has a scene that will be loaded when entered.
   * @param node The node to consult.
   * @return True if the node has such a scene link, false otherwise.
   * @api viewer3d.node
   */
  ;

  _proto.hasLinkedScene = function hasLinkedScene(node) {
    return Boolean(node.linkedScene);
  }
  /**
   * Indicates if the given node is enabled.
   * @param node The node to consult.
   * @return True if the node is enabled, false otherwise.
   * @api viewer3d.node
   */
  ;

  _proto.isNodeEnabled = function isNodeEnabled(node) {
    return node.enabled;
  }
  /**
   * Gets the fill color of a node.
   * @param node The node to consult.
   * @return String representing the css3 color, as defined in the setNodeFillColor
   * @api viewer3d.node
   */
  ;

  _proto.getNodeFillColor = function getNodeFillColor(node) {
    return node.fillColor;
  }
  /**
   * Gets the border color of a node.
   * @param node The node to consult.
   * @return String representing the css3 color, as defined in the setNodeBorderColor
   * @api viewer3d.node
   */
  ;

  _proto.getNodeBorderColor = function getNodeBorderColor(node) {
    return node.borderColor;
  }
  /**
   * Gets the 3D coordinates of the center of the node.
   * @param node The node to consult.
   * @return ThreeJs Vector3 indicating the 3D world coordinates of the node center.
   * @api viewer3d.node
   */
  ;

  _proto.getNodeCenter = function getNodeCenter(node) {
    return node.boundingBox.getCenter(new THREE.Vector3());
  }
  /**
   * Calculates the 2D screen position of the center of a given node.
   * @param node Node from which to calculate the center.
   * @return ThreeJs Vector2 indicating the 2D screen coordinates.
   * @api viewer3d.node
   */
  ;

  _proto.getScreenPositionOfNode = function getScreenPositionOfNode(node) {
    return this.cameraManager.getScreenPosition(node.object3d.position);
  };

  return NodeStatusManager;
}();

var IsolationManager = /*#__PURE__*/function () {
  function IsolationManager(dataSourceManager, nodeSelectionManager) {
    this.isolationChanged = new SharpEvent();
    this.config = dataSourceManager.config;
    this.dataSourceManager = dataSourceManager;
    this.nodeSelectionManager = nodeSelectionManager;
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinished, this);
    this.nodeSelectionManager.nodeSelectionChangedEvent.subscribe(this.onNodeSelectionChanged, this);
  }

  var _proto = IsolationManager.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.NODE, {
      isolateNodes: this.isolateNodes
    }, this);
  };

  _proto.onNodeSelectionChanged = function onNodeSelectionChanged(selectedNodes) {
    if (this.config.nodes.selectToIsolate) {
      this.isolateNodes(selectedNodes);
    }
  };

  _proto.onLoadFinished = function onLoadFinished() {
    // for use in isolation, copy the reference to the original material
    for (var _iterator = _createForOfIteratorHelperLoose(this.dataSourceManager.getMeshChildren()), _step; !(_step = _iterator()).done;) {
      var object = _step.value;
      object.originalMaterial = object.material;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.dataSourceManager.onLoadFinishEvent.unsubscribeAll(this);
    this.nodeSelectionManager.nodeSelectionChangedEvent.unsubscribe(this);
  }
  /**
   * Performs or resets isolation based on the definition in the data.json or default node association.
   * @param nodes {Node[]} the nodes to isolate. If empty, isolation will be reverted, so that no nodes will appear isolated.
   * @param [intensity] {number} Opacity to apply to the non-isolated meshes (0 being transparent, 1 fully opaque). Optional, if not defined, the value of the isolationAlpha is applied.
   * @api viewer3d.node
   */
  ;

  _proto.isolateNodes = function isolateNodes(nodes, intensity) {
    var _this = this;

    var allTargetModelFilters = []; // filter those nodes with the targetModels field and merge the contents of the arrays

    for (var _iterator2 = _createForOfIteratorHelperLoose(nodes), _step2; !(_step2 = _iterator2()).done;) {
      var node = _step2.value;

      if (node.targetModels !== null && node.targetModels !== undefined && node.targetModels.length > 0) {
        allTargetModelFilters = allTargetModelFilters.concat(node.targetModels);
      } else if (this.config.nodes.useDefaultIsolation) {
        (function () {
          // if useDefaultIsolation is enabled, we will check for default associations
          // according to the name. But it might happen that it won't match anything
          // (because it hasn't been configured yet). In that case, we won't apply isolation
          // but we could just apply the expression unconditionally if we don't want this behavior
          var expression = node.sid + '.*';
          var regEx = new RegExp('^' + expression + '$');

          if (_this.dataSourceManager.getMeshChildren().some(function (x) {
            return !x.node && regEx.test(x.name);
          })) {
            allTargetModelFilters.push(expression);
          }
        })();
      }
    }

    this.isolate(allTargetModelFilters, intensity);
  };

  _proto.isolate = function isolate(allTargetModelFilters, intensity) {
    var _this2 = this;

    var actualColor = new Color(this.config.nodes.isolationColor);
    var actualIntensity = ObjectHelper.coalesce(intensity, actualColor.getAlpha());
    var defaultIsolateMaterial = new THREE.MeshPhongMaterial();
    defaultIsolateMaterial.color = new THREE.Color(actualColor.getRGB());
    defaultIsolateMaterial.opacity = actualIntensity;
    defaultIsolateMaterial.transparent = defaultIsolateMaterial.opacity < 1;
    defaultIsolateMaterial.depthWrite = !defaultIsolateMaterial.transparent;
    var regExs = allTargetModelFilters.map(function (x) {
      return new RegExp('^' + x + '$');
    });

    var _loop = function _loop() {
      var currentThreeObject = _step3.value;
      // do not apply to nodes or objects without materials, just other models
      if (currentThreeObject.node || !currentThreeObject.material) return "continue"; // if there's a newAlpha, we set the new opacity level, otherwise use the baseAlpha
      // const material = currentThreeObject.material;

      var useIsolateMaterial = allTargetModelFilters.length > 0 && !regExs.some(function (x) {
        return x.test(currentThreeObject.name);
      }); // apply the alpha transparency to the mesh and all its children

      for (var _iterator4 = _createForOfIteratorHelperLoose([currentThreeObject].concat(_this2.dataSourceManager.getMeshChildren(currentThreeObject))), _step4; !(_step4 = _iterator4()).done;) {
        var obj = _step4.value;
        obj.material = useIsolateMaterial ? defaultIsolateMaterial : obj.originalMaterial;
      }
    };

    for (var _iterator3 = _createForOfIteratorHelperLoose(this.dataSourceManager.getMeshChildren()), _step3; !(_step3 = _iterator3()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }

    this.isolationChanged.invoke();
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.isolationChanged];
  };

  return IsolationManager;
}();

var PICKING_BOX_TYPE = 'PickingBox';

var PickingBox = /*#__PURE__*/function (_Node) {
  _inheritsLoose(PickingBox, _Node);

  function PickingBox(mesh) {
    var _this;

    _this = _Node.call(this, mesh, PICKING_BOX_TYPE) || this;
    _this.defaultOptions = {
      disabledFillColor: 'rgba(0,0,0,0.3)',
      normalFillColor: 'rgba(0,0,0,0)',
      hoveredFillColor: null,
      selectedFillColor: null,
      disabledBorderColor: null,
      normalBorderColor: null,
      hoveredBorderColor: 'rgba(0,0,255,0.5)',
      selectedBorderColor: 'rgba(0,255,0,0.3)',
      nearAlpha: 0.05,
      nearDistance: 1000,
      farDistance: 2000,
      duration: 200
    };
    _this.mesh = mesh;
    _this.originalMap = _this.mesh.material.map; // @ts-ignore

    mesh.material = mesh.material.clone();
    _this.baseColor = '#' + _this.mesh.material.color.getHexString();
    _this.fillColor = null;
    _this.borderColor = null;
    _this.boundingBox = new THREE.Box3().setFromObject(mesh);
    _this.boundingBoxVertices = PickingBox.getBoundBoxVertices(_this.boundingBox);
    _this.firstRun = true;
    return _this;
  }

  var _proto = PickingBox.prototype;

  _proto.updateMaterials = function updateMaterials() {
    this.updateBaseTexture();
    var color = this.fillColor || this.options.normalFillColor || this.baseColor || 'rgba(0,0,0,0)';
    var borderColor = this.borderColor || this.options.normalBorderColor || 'rgba(0,0,0,0)';

    if (!this.enabled) {
      color = this.options.disabledFillColor || color;
      borderColor = this.options.disabledBorderColor || borderColor;
    }

    if (this.hovered) {
      color = this.options.hoveredFillColor || color;
      borderColor = this.options.hoveredBorderColor || borderColor;
    }

    if (this.selected) {
      color = this.options.selectedFillColor || color;
      borderColor = this.options.selectedBorderColor || borderColor;
    }

    var duration = this.firstRun ? 0 : this.options.duration;
    if (!this.mesh.visible) return;
    this.setMaterial(color, duration); // this will be processed by the OutlineManager

    this.mesh.borderColor = borderColor;
    this.firstRun = false;
  };

  _proto.updateBaseTexture = function updateBaseTexture() {
    var map = this.options.disableTextures && (this.selected || this.hovered) ? null : this.originalMap;

    if (map !== this.mesh.material.map) {
      this.mesh.material.map = map;
      this.mesh.material.needsUpdate = true;
    }
  };

  _proto.setMaterial = function setMaterial(color, duration) {
    var material = this.mesh.material;
    var actualColor = new Color(color);
    this.baseAlpha = actualColor.getAlpha();
    this.updateAlpha();
    new TWEEN__default["default"].Tween(material.color).to(new THREE.Color(actualColor.getRGB()), duration).start();
  };

  _proto.onCameraChange = function onCameraChange(cameraPosition) {
    this.lastCameraPosition = cameraPosition;
    this.updateAlpha();
  };

  _proto.updateAlpha = function updateAlpha() {
    /* if (!this.lastCameraPosition)
      return; */
    var newAlpha = this.baseAlpha; // these can become viewer parameters

    var farAlpha = this.baseAlpha;
    var nearAlpha = this.options.nearAlpha;
    var nearDistance = this.options.nearDistance || 1000;
    var farDistance = this.options.farDistance || 2000; // experiment

    if (nearAlpha && this.lastCameraPosition) {
      nearAlpha = Math.min(this.baseAlpha, nearAlpha);
      var boundingCenter = this.boundingBox.getCenter(new THREE.Vector3());
      var distance = this.lastCameraPosition.clone().sub(boundingCenter).length();
      var constrainedDistance = Math.max(Math.min(distance, farDistance), nearDistance);
      var relativeDistance = (constrainedDistance - nearDistance) / (farDistance - nearDistance);
      newAlpha = nearAlpha + relativeDistance * (farAlpha - nearAlpha);
    } // if there's a newAlpha, we set the new opacity level, otherwise use the baseAlpha


    var material = this.mesh.material;
    material.opacity = newAlpha;
    material.transparent = material.opacity < 1;
    material.depthWrite = !material.transparent;
  };

  _proto.isIsFrontOfPlane = function isIsFrontOfPlane(plane) {
    return this.boundingBoxVertices.some(function (x) {
      return plane.distanceToPoint(x) >= 0;
    });
  };

  PickingBox.getBoundBoxVertices = function getBoundBoxVertices(boundingBox) {
    var min = boundingBox.min;
    var max = boundingBox.max;
    return [min, max, new THREE.Vector3(min.x, min.y, max.z), new THREE.Vector3(min.x, max.y, min.z), new THREE.Vector3(max.x, min.y, min.z), new THREE.Vector3(max.x, max.y, min.z), new THREE.Vector3(max.x, min.y, max.z), new THREE.Vector3(min.x, max.y, max.z)];
  };

  _proto.closeUpPoint = function closeUpPoint() {
    return this.boundingBox.getCenter(new THREE.Vector3());
  };

  return PickingBox;
}(Node);

var PickingBoxManager = /*#__PURE__*/function () {
  function PickingBoxManager(dataSourceManager, nodeManager) {
    this.config = dataSourceManager.config;
    this.dataSourceManager = dataSourceManager;
    this.nodeManager = nodeManager;
    this.nodeManager.nodePreparationEvent.subscribe(this.onNodePreparation, this);
  }

  var _proto = PickingBoxManager.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.nodeManager.nodePreparationEvent.unsubscribeAll(this);
  };

  _proto.onNodePreparation = function onNodePreparation() {
    this.buildPickingBoxesOnMeshes();
  };

  _proto.buildPickingBoxesOnMeshes = function buildPickingBoxesOnMeshes() {
    // for use in isolation, copy the reference to the original material
    for (var _iterator = _createForOfIteratorHelperLoose(this.dataSourceManager.getMeshChildren()), _step; !(_step = _iterator()).done;) {
      var mesh = _step.value;
      this.nodeManager.buildNode(mesh, 'PICK', PICKING_BOX_TYPE, PickingBox);
    }
  };

  _proto.decodeSid = function decodeSid(sid) {
    var strSplit = sid.split('__'); // TODO: check what cases fit this

    if (strSplit.length > 3) {
      return strSplit[2].concat('_-').concat(strSplit[3]);
    } else {
      return strSplit[2];
    }
  };

  return PickingBoxManager;
}();

var ReportInfo = function ReportInfo() {};

var ReportManager = /*#__PURE__*/function () {
  function ReportManager(dataSourceManager) {
    this.dataSourceManager = dataSourceManager;
  }

  var _proto = ReportManager.prototype;

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.SCENE, {
      getReport: this.getReport
    }, this);
  }
  /**
   * Produces a statistical report about the scene's loaded content, such as number of meshes, picking boxes and defined textures.
   * @api viewer3d.scene
   * @returns {ReportInfo} An object containing statistical information about the current scene.
   */
  ;

  _proto.getReport = function getReport() {
    var _this = this;

    var objects = this.dataSourceManager.getSceneObjects();

    if (objects) {
      var report = new ReportInfo();
      var meshes = objects.filter(function (x) {
        return x instanceof THREE.Mesh;
      });
      var pickingBoxes = meshes.filter(function (x) {
        return x.name.startsWith('PICK');
      });
      var nonPickingBoxes = meshes.filter(function (x) {
        return !x.name.startsWith('PICK');
      });
      report.numObjects = objects.length;
      report.objectNames = objects.map(function (x) {
        return x.name;
      });
      report.numMeshes = meshes.length;
      report.numPickingBoxes = pickingBoxes.length;
      report.pickingBoxNames = pickingBoxes.map(function (x) {
        return x.name;
      });
      report.meshNames = nonPickingBoxes.map(function (x) {
        return x.name;
      });
      report.meshSizes = nonPickingBoxes.map(function (x) {
        return {
          name: x.name,
          numVertices: _this.getNumVertices(x),
          numTriangles: _this.getNumTriangles(x)
        };
      });
      report.meshSizes.sort(function (a, b) {
        return b.numVertices - a.numVertices;
      }); // If the index attribute is not set, the renderer assumes that each three contiguous positions represent a single triangle.

      report.numVertices = meshes.map(function (y) {
        return _this.getNumVertices(y);
      }).reduce(function (total, num) {
        return total + num;
      }, 0);
      report.numTriangles = meshes.map(function (y) {
        return _this.getNumTriangles(y);
      }).reduce(function (total, num) {
        return total + num;
      }, 0);
      report.textureNames = meshes.filter(function (x) {
        return x.material.map;
      }).map(function (x) {
        return x.material.map;
      }).filter(function (x) {
        return x.image;
      }).map(function (x) {
        return x.image.src;
      }).filter(NodeHelper.onlyUnique);
      return report;
    }
  };

  _proto.getNumVertices = function getNumVertices(mesh) {
    return mesh.geometry.getAttribute('position').count;
  };

  _proto.getNumTriangles = function getNumTriangles(mesh) {
    return mesh.geometry.getAttribute('position').count / 3;
  };

  return ReportManager;
}();

var ExtendedCameraManager = /*#__PURE__*/function () {
  function ExtendedCameraManager(cameraManager, renderManager, dataSourceManager, nodeSelectionManager) {
    this.config = cameraManager.config;
    this.cameraManager = cameraManager;
    this.renderManager = renderManager;
    this.nodeSelectionManager = nodeSelectionManager;
    this.dataSourceManager = dataSourceManager;
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinishEvent, this);
  }

  var _proto = ExtendedCameraManager.prototype;

  _proto.onLoadFinishEvent = function onLoadFinishEvent() {
    this.enforceAutoFar(this.config.camera.far);
    this.enforceAutoMaxDistance(this.config.camera.maxDistance);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    if (this.config.camera.far !== nextConfig.camera.far) {
      this.enforceAutoFar(nextConfig.camera.far);
    }

    if (this.config.camera.maxDistance !== nextConfig.camera.maxDistance) {
      this.enforceAutoMaxDistance(this.config.camera.maxDistance);
    }
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.CAMERA, {
      takeScreenshot: this.takeScreenshot,
      getMouse3DCoordinates: this.getMouse3DCoordinates,
      reset: this.resetCamera,
      rerender: this.rerender
    }, this);
  }
  /**
   * Takes a screenshot of the Webgl canvas.
   * @returns {string}  The image data that was captured.
   * @api viewer3d.camera
   */
  ;

  _proto.takeScreenshot = function takeScreenshot() {
    return this.renderManager.getScreenshot();
  }
  /**
   * Resets the camera orientation to the initial direction and then frames the whole scene in the screen. Works only if a scene is loaded.
   * @param animation If a value is set, the transition to the new location will be animated according to the defined options, otherwise the change will be performed instantly.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.camera
   * @alias reset
   */
  ;

  _proto.resetCamera = function resetCamera(animation) {
    return this.dataSourceManager.frameScene(animation, this.cameraManager.getOriginalDirection());
  }
  /**
   * Gets the last 3D position resulting from an intersection between a ray cast starting from the mouse screen position.
   * @returns Vector3 object indicating the position, or null, if no 3D object was intersected.
   * @api viewer3d.camera
   */
  ;

  _proto.getMouse3DCoordinates = function getMouse3DCoordinates() {
    return this.nodeSelectionManager.getMouse3DCoordinates();
  }
  /**
   * Forces a rerender of the scene.
   * Should only be necessary to compensate for possible issues where the canvas content does not update.
   * @api viewer3d.camera
   */
  ;

  _proto.rerender = function rerender() {
    this.renderManager.updateShouldRenderer(true);
  };

  _proto.enforceAutoFar = function enforceAutoFar(definedFar) {
    if (definedFar === 'auto') {
      // adjust the camera far view limits so that it still encloses the content
      var sphere = this.dataSourceManager.allBoundingBox.getBoundingSphere(new THREE.Sphere()); // distance should be 10% larger than the distance calculated for the max distance
      // otherwise the objects could disappear before reaching the camera distance limit

      this.cameraManager.camera.far = sphere.radius * 1.1;
    }
  };

  _proto.enforceAutoMaxDistance = function enforceAutoMaxDistance(maxDistance) {
    if (maxDistance === 'auto') {
      // adjust the camera far view limits so that it still encloses the content
      var sphere = this.dataSourceManager.allBoundingBox.getBoundingSphere(new THREE.Sphere());
      this.cameraManager.controls.maxDistance = sphere.radius;
    }
  };

  return ExtendedCameraManager;
}();

var TemplateInfo = function TemplateInfo(templateMesh, instanceList) {
  this.templateMesh = templateMesh;
  this.instanceList = instanceList;
  this.originalInstanceList = [].concat(instanceList);
  this.needsUpdate = true;
  this.instanceSceneObject = null;
};

var InstancedMeshManager = /*#__PURE__*/function () {
  function InstancedMeshManager(dataSourceManager) {
    this.instanceChanged = new SharpEvent();
    this.config = dataSourceManager.config;
    this.dataSourceManager = dataSourceManager;
    this.dataSourceManager.onObjectsLoadedEvent.subscribe(this.onObjectsLoaded, this);
  }

  var _proto = InstancedMeshManager.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.INSTANCING, {
      getTemplatesAndInstances: this.getTemplatesAndInstances,
      changeInstances: this.changeInstances,
      resetInstances: this.resetInstances,
      updateInstances: this.updateInstances
    }, this);
  }
  /**
   * Gets the registered template names and their instances.
   * @return Map of template names, each entry containing the instances currently assigned this template.
   * @api viewer3d.instancing
   */
  ;

  _proto.getTemplatesAndInstances = function getTemplatesAndInstances() {
    return Object.entries(this.templateInfos).reduce(function (result, _ref) {
      var key = _ref[0],
          value = _ref[1];
      result[key] = value.instanceList.map(function (x) {
        return x.name;
      });
      return result;
    }, {});
  }
  /**
   * Resets the instances to their original template attributions.
   * @param skipUpdate If true, the instance meshes won't be immediately updated. This is useful if you wish to call several different instance changing functions at once. As the update process is an expensive operation, it should only be performed once.
   * @api viewer3d.instancing
   */
  ;

  _proto.resetInstances = function resetInstances(skipUpdate) {
    for (var _i = 0, _Object$values = Object.values(this.templateInfos); _i < _Object$values.length; _i++) {
      var templateInfo = _Object$values[_i];

      if (!lodash.isEqual(templateInfo.instanceList, templateInfo.originalInstanceList)) {
        templateInfo.instanceList = [].concat(templateInfo.originalInstanceList);
        templateInfo.needsUpdate = true;
      }
    }

    if (!skipUpdate) {
      this.updateInstances();
    }
  }
  /**
   * Changes the template assigned to instances.
   * @param [targetTemplateName] {string} Name of the template to change to. Leave undefined or null to select none (meaning the instances will just be removed).
   * @param [nameFilter] {string|string[]} Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @param [cumulative] {boolean} If true, the change will be applied additively, otherwise all instances will be reset before applying this change.
   * @param [skipUpdate] {boolean} If true, the instance meshes won't be immediately updated. This is useful if you wish to call several different instance changing functions at once. As the update process is an expensive operation, it should only be performed once.
   * @api viewer3d.instancing
   */
  ;

  _proto.changeInstances = function changeInstances(targetTemplateName, nameFilter, cumulative, skipUpdate) {
    if (!cumulative) {
      this.resetInstances(false);
    }

    var instancesToRelocate = [];
    var objectFilterSet = Array.isArray(nameFilter) ? new Set(nameFilter) : null;

    for (var _i2 = 0, _Object$entries = Object.entries(this.templateInfos); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _Object$entries[_i2],
          templateName = _Object$entries$_i[0],
          templateInfo = _Object$entries$_i[1];

      // if the target template is this one, we don't need to look into the instances
      // already inside this templateInfo
      if (targetTemplateName === templateName) {
        continue;
      }

      var newInstanceList = [];

      for (var _iterator = _createForOfIteratorHelperLoose(templateInfo.instanceList), _step; !(_step = _iterator()).done;) {
        var instance = _step.value;

        // if the item is included in the filter, it must go out
        if (appliesToObject(instance, objectFilterSet)) {
          instancesToRelocate.push(instance);
          templateInfo.needsUpdate = true;
        } else {
          newInstanceList.push(instance);
        }
      } // if we change the list, make


      templateInfo.instanceList = newInstanceList;
    } // if there is no target template, then the goal was just removal
    // and that has been done so far
    // but if not...


    if (targetTemplateName) {
      var targetTemplate = this.templateInfos[targetTemplateName];

      if (targetTemplate) {
        for (var _iterator2 = _createForOfIteratorHelperLoose(instancesToRelocate), _step2; !(_step2 = _iterator2()).done;) {
          var instanceToRelocate = _step2.value;
          targetTemplate.instanceList.push(instanceToRelocate);
        }

        targetTemplate.needsUpdate = true;
      } else {
        console.warn("The indicated template " + targetTemplate + " is not defined.");
      }
    }

    if (!skipUpdate) {
      // call the update function
      this.updateInstances();
    }
  };

  _proto.onObjectsLoaded = function onObjectsLoaded() {
    this.templateInfos = this.loadTemplateInfos();
    this.updateInstances();
  }
  /**
   * Updates the mesh instances on the screen, if there are pending changes. This is called by changeInstances, if skipUpdate = false.
   *
   * This can be a somewhat expensive operation if called after every small change. If many changes are to be chained, it is more efficient to call changeInstances(...) with skipUpdate = true and then call this function at the end (similar to a flush() operation).
   *
   * If there are no pending changes, then this function doesn't incur any overhead.
   * @api viewer3d.instancing
   */
  ;

  _proto.updateInstances = function updateInstances() {
    this.updateSceneInstanceObjects(this.templateInfos);
  };

  _proto.loadTemplateInfos = function loadTemplateInfos() {
    var templateMap = {};
    var instancesMap = {}; // iterate over objects and identify and separate the instances and samples

    for (var _iterator3 = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects()), _step3; !(_step3 = _iterator3()).done;) {
      var sceneObject = _step3.value;
      var splitName = sceneObject.name.split('_');

      if (sceneObject.name.startsWith('TEMPLATE_')) {
        var sampleName = splitName[1];
        templateMap[sampleName] = sceneObject;
        this.dataSourceManager.group.remove(sceneObject);
      } else if (sceneObject.name.startsWith('INSTANCE_')) {
        var instanceSampleName = splitName[1];

        if (!instancesMap[instanceSampleName]) {
          instancesMap[instanceSampleName] = [sceneObject];
        } else {
          instancesMap[instanceSampleName].push(sceneObject);
        }

        this.dataSourceManager.group.remove(sceneObject);
      }
    } // look at all the keys either defined in templates or instances


    var templateInfos = {};

    for (var _iterator4 = _createForOfIteratorHelperLoose(Object.keys(instancesMap).concat(Object.keys(templateMap))), _step4; !(_step4 = _iterator4()).done;) {
      var templateName = _step4.value;
      var templateMesh = templateMap[templateName];
      var instancesList = instancesMap[templateName];

      if (!templateMesh) {
        console.error("There are instances of sample " + templateName + ",\n          but there is no template object with that name.");
        continue;
      }

      if (!instancesList) {
        console.error("There are no instances of the sample " + templateName + ".");
        continue;
      }

      templateInfos[templateName] = new TemplateInfo(templateMesh, instancesList);
    }

    return templateInfos;
  };

  _proto.updateSceneInstanceObjects = function updateSceneInstanceObjects(templateInfos) {
    // now create one instanced mesh for each sample
    for (var _i3 = 0, _Object$entries2 = Object.entries(templateInfos); _i3 < _Object$entries2.length; _i3++) {
      var _Object$entries2$_i = _Object$entries2[_i3],
          templateName = _Object$entries2$_i[0],
          templateInfo = _Object$entries2$_i[1];
      var templateMesh = templateInfo.templateMesh;
      var instances = templateInfo.instanceList;
      var instancedMeshesObject = new THREE.InstancedMesh(templateMesh.geometry.clone(), Array.isArray(templateMesh.material) ? templateMesh.material.map(function (x) {
        return x.clone();
      }) : templateMesh.material.clone(), instances.length);
      instancedMeshesObject.name = 'INSTANCES_' + templateName;
      instancedMeshesObject.instanceMatrix.setUsage(THREE.DynamicDrawUsage);

      if (!templateInfo.needsUpdate) {
        continue;
      }

      for (var i = 0; i < instances.length; i++) {
        var dummy = new THREE.Object3D();
        var instanceMesh = instances[i];
        var positions = instanceMesh.geometry.attributes.position.array; // assumes triangle with counter-clockwise orientation

        var v0 = new THREE.Vector3(positions[0], positions[1], positions[2]);
        var v1 = new THREE.Vector3(positions[3], positions[4], positions[5]);
        var v2 = new THREE.Vector3(positions[6], positions[7], positions[8]);
        var vertices = [v0, v1, v2];
        var verticesExtra = [];

        for (var _i4 = 0; _i4 < 3; _i4++) {
          var currentVertex = vertices[_i4];
          var previousVertex = this.getCircular(vertices, _i4 - 1);
          var nextVertex = this.getCircular(vertices, _i4 + 1);
          var previousDirection = previousVertex.clone().sub(currentVertex);
          var nextDirection = nextVertex.clone().sub(currentVertex);
          var angle = MathHelper.toDegrees(previousDirection.angleTo(nextDirection));
          verticesExtra.push({
            vertex: vertices[_i4],
            angle: angle,
            lookTo: nextVertex,
            previousSize: previousDirection.length(),
            nextSize: nextDirection.length()
          });
        }

        var vertexAt90Degrees = lodash.minBy(verticesExtra, function (b) {
          return Math.abs(b.angle - 90);
        });
        var xScale = vertexAt90Degrees.previousSize;
        var zScale = vertexAt90Degrees.nextSize;
        var yScale = Math.min(xScale, zScale);
        dummy.position.copy(v2);
        dummy.lookAt(vertexAt90Degrees.lookTo);
        dummy.scale.copy(new THREE.Vector3(xScale, yScale, zScale));
        dummy.updateMatrix();
        instancedMeshesObject.setMatrixAt(i, dummy.matrix);
      } // if an object for this template already existed, remove it


      if (templateInfo.instanceSceneObject) {
        this.dataSourceManager.group.remove(templateInfo.instanceSceneObject);
      }

      templateInfo.needsUpdate = false;
      this.dataSourceManager.group.add(templateInfo.instanceSceneObject = instancedMeshesObject);
      this.instanceChanged.invoke();
    }
  };

  _proto.getCircular = function getCircular(vertices, index) {
    var len = vertices.length;
    return vertices[(index % len + len) % len];
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.instanceChanged];
  };

  return InstancedMeshManager;
}();

var MeshManager = /*#__PURE__*/function () {
  function MeshManager(dataSourceManager, renderManager) {
    this.config = dataSourceManager.config;
    this.dataSourceManager = dataSourceManager;
    this.renderManager = renderManager;
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinished, this);
  }

  var _proto = MeshManager.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    if (this.config.renderer.shadows.enabled !== nextConfig.renderer.shadows.enabled) {
      this.updateShadows(nextConfig.renderer.shadows.enabled);
    }

    this.config = nextConfig;
  };

  _proto.onLoadFinished = function onLoadFinished() {
    this.updateShadows(this.config.renderer.shadows.enabled);
  };

  _proto.updateShadows = function updateShadows(enabled) {
    for (var _iterator = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects().filter(function (x) {
      return x.type.endsWith('Light');
    }).map(function (x) {
      return x;
    })), _step; !(_step = _iterator()).done;) {
      var light = _step.value;

      if (light.type !== 'AmbientLight') {
        light.castShadow = enabled;
        light.shadow.bias = 0.0001;
      }

      if (light.type === 'DirectionalLight') {
        var orthoCamera = light.shadow.camera; //console.log('found', light, enabled)
        // light.shadowCameraVisible = true // only for debugging
        // light.shadow.camera.near = 0.01; // same as the camera

        orthoCamera.far = 1000; // same as the camera
        //orthoCamera.fov = 50; // same as the camera

        var distance = 500; // sceneObject.shadowMapWidth = 1024; // default is 512
        // sceneObject.shadowMapHeight = 1024; // default is 512

        orthoCamera.left = -distance;
        orthoCamera.right = distance;
        orthoCamera.top = distance;
        orthoCamera.bottom = -distance;
        light.shadow.mapSize.width = 2048;
        light.shadow.mapSize.height = 2048;
        /* if(!enabled && sceneObject.shadow.map){
          //this.renderManager.renderer.clear(sceneObject.shadow.map);
          sceneObject.shadow.map.dispose()
          sceneObject.shadow.map = null;
        } */
      } else if (light.type === 'SpotLight') {
        light.shadow.bias = 0;
        light.shadow.mapSize.width = 512;
        light.shadow.mapSize.height = 512;
        var perspCamera = light.shadow.camera;
        perspCamera.near = 0.5;
        perspCamera.far = 500; //light.shadow.focus = 1
      } else if (light.type === 'DirectionalLight') {
        light.shadow.bias = 0.00001;
        light.shadow.mapSize.width = 2048;
        light.shadow.mapSize.height = 2048;
      }
    }

    for (var _iterator2 = _createForOfIteratorHelperLoose(this.dataSourceManager.getMeshChildren()), _step2; !(_step2 = _iterator2()).done;) {
      var mesh = _step2.value;
      mesh.castShadow = enabled;
      mesh.receiveShadow = enabled;

      if (mesh.material && mesh.material instanceof THREE.Material) {
        mesh.material.needsUpdate = true;
      }
    }
  };

  return MeshManager;
}();

var MINIMAP_CAMERA_LAYER = 2;
var MINIMAP_CAMERA_NAME = 'minimap';
setLayerName(MINIMAP_CAMERA_NAME, MINIMAP_CAMERA_LAYER);

var MinimapManager = /*#__PURE__*/function () {
  function MinimapManager(renderManager, dataSourceManager, cameraManager, sceneManager) {
    this.config = dataSourceManager.config;
    this.renderManager = renderManager;
    this.dataSourceManager = dataSourceManager;
    this.cameraManager = cameraManager;
    this.sceneManager = sceneManager;
    this.eventPriority = 1;
    this.totalWidth = 1;
    this.totalHeight = 1;
  }

  var _proto = MinimapManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDiv) {
    var _this = this;

    this.rendererDiv = rendererDiv;
    this.canvas = document.createElement('canvas');
    this.canvas.addEventListener('click', function (e) {
      return _this.onCanvasClicked(e);
    }, false);
    this.setupAutoRatio(this.config);
    this.applyStyle(null, this.config);
    var parentElement = this.config.minimap.element ? document.getElementById(this.config.minimap.element) : rendererDiv;
    if (this.config.minimap.enabled) parentElement.appendChild(this.canvas);
    this.minimapCamera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    this.renderManager.renderEvent.subscribe(this.onRender, this);
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinishEvent, this);
    this.cameraManager.cameraChangeEvent.subscribe(this.onCameraChangeEvent, this);
    this.onCameraChangeEvent();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    if (nextConfig.minimap.element && !document.getElementById(nextConfig.minimap.element)) {
      console.warn("There is no DOM Element named: " + nextConfig.minimap.element + ", anchoring minimap to the current viewer REF. at MinimapManager");
    }

    var previousParent = this.config.minimap.element && document.getElementById(this.config.minimap.element) ? document.getElementById(this.config.minimap.element) : this.rendererDiv;
    var currentParent = nextConfig.minimap.element && document.getElementById(nextConfig.minimap.element) ? document.getElementById(nextConfig.minimap.element) : this.rendererDiv;

    if (!nextConfig.minimap.enabled && this.config.minimap.enabled) {
      previousParent.removeChild(this.canvas);
    } else if (nextConfig.minimap.enabled && !this.config.minimap.enabled) {
      currentParent.appendChild(this.canvas);
    } else if (nextConfig.minimap.element !== this.config.minimap.element) {
      previousParent.removeChild(this.canvas);
      currentParent.appendChild(this.canvas);
    }

    this.setupAutoRatio(nextConfig);
    this.applyStyle(this.config, nextConfig);
    this.config = nextConfig;
  };

  _proto.applyStyle = function applyStyle(previousConfig, config) {
    var newStyle = config.minimap.style;

    for (var key in newStyle) {
      if (Object.prototype.hasOwnProperty.call(newStyle, key)) {
        this.canvas.style[key] = newStyle[key];
      }
    } // if we make deep changes to the style, such as eliminating
    // a 'left' with a 'right' property, we need to delete the old properties


    if (previousConfig) {
      for (var _key in previousConfig.minimap.style) {
        if (!Object.prototype.hasOwnProperty.call(newStyle, _key)) {
          this.canvas.style[_key] = null;
        }
      }
    }
  };

  _proto.setupAutoRatio = function setupAutoRatio(config) {
    var ratio = 1; // if we already have the dimensions of the panel, use them for
    // the ratio calculation

    if (this.totalWidth && this.totalHeight) ratio = this.totalWidth / this.totalHeight;
    var configWidth = config.minimap.width;
    var configHeight = config.minimap.height; // if no dimension is indicated, we assume 200 for the width

    if (!configWidth && !configHeight) {
      configWidth = 200;
    } // if one of the dimensions is not indicated, we assume
    // the other is meant to be calculated from the surface ratio


    if (configWidth && !configHeight) {
      configHeight = configWidth / ratio;
    } else if (!configWidth && configHeight) {
      configWidth = configHeight * ratio;
    }

    this.canvas.width = configWidth;
    this.canvas.height = configHeight;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.renderManager.renderEvent.unsubscribeAll(this);
    this.dataSourceManager.onLoadFinishEvent.unsubscribeAll(this);
  };

  _proto.onCanvasClicked = function onCanvasClicked(e) {
    var canvasRect = this.canvas.getBoundingClientRect();
    var newX = this.minX + (1 - e.offsetY / canvasRect.height) * this.totalHeight;
    var newZ = this.minZ + e.offsetX / canvasRect.width * this.totalWidth;
    var sameY = this.cameraManager.getCameraPosition().y;
    var newPosition = new THREE.Vector3(newX, sameY, newZ);
    var direction = newPosition.clone().sub(this.cameraManager.getCameraPosition());
    var newTarget = this.cameraManager.getCameraTarget().clone().add(direction);
    this.cameraManager.setCameraPositionAndTarget(newPosition, newTarget, {});
  };

  _proto.onLoadFinishEvent = function onLoadFinishEvent() {
    var boundingBox = this.dataSourceManager.allBoundingBox;
    var minX = boundingBox.min.x;
    var minZ = boundingBox.min.z;
    var totalHeight = boundingBox.max.x - boundingBox.min.x;
    var totalWidth = boundingBox.max.z - boundingBox.min.z;
    var totalDepth = boundingBox.max.y - boundingBox.min.y; // for completely flat object, like surfaces, the totalDepth could be 0,
    // so make sure it is at least 1, otherwise the camera will lie on top of it and not render

    totalDepth = Math.max(totalDepth, 1);

    if (boundingBox.isEmpty()) {
      minX = minZ = 0;
      totalWidth = totalHeight = totalDepth = 1;
    }

    this.minimapCamera = new THREE.OrthographicCamera(0, totalWidth, totalHeight, 0, 0, totalDepth * 2);
    this.minimapCamera.layers.enable(MINIMAP_CAMERA_LAYER);
    this.minimapCamera.up.set(1, 0, 0);
    this.minimapCamera.lookAt(this.minimapCamera.position.clone().add(new THREE.Vector3(0, -1, 0)));
    this.minimapCamera.position.copy(new THREE.Vector3(minX, totalDepth, minZ)); // const helper = new THREE.CameraHelper( this.minimapCamera )
    // this.dataSourceManager.scene.add( helper )

    this.minX = minX;
    this.minZ = minZ;
    this.totalWidth = totalWidth;
    this.totalHeight = totalHeight;
    this.setupAutoRatio(this.config);
  };

  _proto.onCameraChangeEvent = function onCameraChangeEvent() {
    var cameraPosition = this.cameraManager.getCameraPosition();
    var distance = cameraPosition.y;
    var horizontalFov = this.cameraManager.getHorizontalFov();
    var verticalFov = this.cameraManager.getVerticalFov();
    this.cameraPosition = cameraPosition;
    this.cameraViewWidth = Math.tan(MathHelper.toRadians(horizontalFov / 2)) * distance * 2;
    this.cameraViewHeight = Math.tan(MathHelper.toRadians(verticalFov / 2)) * distance * 2;
  };

  _proto.onMouseDown = function onMouseDown(e) {
    // we need to make sure that if the minimap is on top of the viewer, a click
    // cannot affect the canvas. For instance, the light position should not be moved.
    // So we need to check if that is the case and return false to cancel other mouse handlers
    // that will be processed later. We ensure this manager is processed first through the mousePriority
    var canvasRect = this.canvas.getBoundingClientRect();

    if (e.clientX >= canvasRect.left && e.clientX <= canvasRect.right && e.clientY >= canvasRect.top && e.clientY <= canvasRect.bottom) {
      return false;
    }
  };

  _proto.onRender = function onRender(renderer) {
    if (!this.config.minimap.enabled) return;
    this.context = this.canvas.getContext('2d');
    renderer.clear();
    renderer.render(this.sceneManager.scene, this.minimapCamera);
    this.context.clearRect(0.0, 0, this.canvas.width, this.canvas.height);
    this.context.createImageData(this.canvas.width, this.canvas.height);
    this.context.drawImage(renderer.domElement, 0, 0, this.canvas.width, this.canvas.height);
    this.context.strokeStyle = this.config.minimap.strokeColor;
    this.context.lineWidth = this.config.minimap.strokeWidth;

    if (this.config.minimap.showCameraView) {
      var topCornerX = (this.cameraPosition.z - this.cameraViewWidth / 2 - this.minZ) / this.totalWidth * this.canvas.width;
      var topCornerY = (1 - (this.cameraPosition.x - this.cameraViewHeight / 2 - this.minX) / this.totalHeight) * this.canvas.height;
      var width = this.cameraViewWidth / this.totalWidth * this.canvas.width;
      var height = this.cameraViewHeight / this.totalHeight * this.canvas.height;
      this.context.strokeRect(topCornerX, topCornerY - height, width, height);
    }
  };

  return MinimapManager;
}();

var SurfaceManager = /*#__PURE__*/function () {
  function SurfaceManager(cameraManager, dataSourceManager) {
    this.api = {};
    this.surfaceChangeEvent = new SharpEvent();
    this.loadProgressEvent = new SharpEvent();
    this.loadFinishEvent = new SharpEvent();
    this.materialsLoading = 0;
    this.config = dataSourceManager.config;
    this.dataSourceManager = dataSourceManager;
    this.cameraManager = cameraManager;
    this.cameraManager.cameraChangeEvent.subscribe(this.onCameraChange, this);
    this.rayCaster = new THREE.Raycaster();
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onSceneLoadFinished, this);
  }

  var _proto = SurfaceManager.prototype;

  _proto.getSurfaceObjects = function getSurfaceObjects(nameFilter) {
    return this.dataSourceManager.getSceneObjects(nameFilter).filter(function (x) {
      return x instanceof SurfaceObject;
    }).map(function (x) {
      return x;
    });
  };

  _proto.onSceneLoadFinished = function onSceneLoadFinished() {
    var _this = this;

    var _loop = function _loop() {
      var surfaceObject = _step.value;

      if (Object.keys(surfaceObject.materialHandlers).length === 0) {
        console.error('No materials have been defined.');
      } else {
        for (var _i = 0, _Object$values = Object.values(surfaceObject.materialHandlers); _i < _Object$values.length; _i++) {
          var materialHandler = _Object$values[_i];
          materialHandler.textureLoadedEvent.subscribe(_this.onTextureLoaded, _this);
          materialHandler.loadStartEvent.subscribe(function () {
            return _this.onMaterialLoadStart(surfaceObject);
          }, _this);
          materialHandler.loadFinishEvent.subscribe(function () {
            return _this.onMaterialLoadFinish(surfaceObject);
          }, _this);
        }

        var firstKey = Object.keys(surfaceObject.materialHandlers)[0];

        _this.loadMaterial(firstKey, surfaceObject.name);
      }
    };

    for (var _iterator = _createForOfIteratorHelperLoose(this.getSurfaceObjects()), _step; !(_step = _iterator()).done;) {
      _loop();
    }
  };

  _proto.componentDidMount = function componentDidMount(rendererDiv) {
    this.rendererDiv = rendererDiv;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cameraManager.cameraChangeEvent.unsubscribeAll(this);
    this.dataSourceManager.onLoadFinishEvent.unsubscribeAll(this);
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.SURFACE, {
      getSurfaceNames: this.getSurfaceNames,
      getSurfaceMaterials: this.getSurfaceMaterials,
      loadMaterial: this.loadMaterial,
      getMaterialProperties: this.getMaterialProperties,
      getMaterialUIDetails: this.getMaterialUIDetails,
      getMaterialPropertyValues: this.getMaterialPropertyValues,
      setMaterialPropertyValues: this.setMaterialPropertyValues
    }, this);
  }
  /**
   * Loads a material of a surface, by its surface and material names, as defined in the surface definition.
   * @param materialName Name of the material to load.
   * @param nameFilter Name, or list of names, of the surface(s) that the operation should be applied to. Leave null/undefined to apply to all.
   *
   * @api viewer3d.surface
   */
  ;

  _proto.loadMaterial = function loadMaterial(materialName, nameFilter) {
    var sceneObjects = this.getSurfaceObjects(nameFilter);

    for (var _iterator2 = _createForOfIteratorHelperLoose(sceneObjects), _step2; !(_step2 = _iterator2()).done;) {
      var sceneObject = _step2.value;
      var materialHandler = sceneObject.materialHandlers[materialName];

      if (sceneObject.isMultiResolution) {
        sceneObject.baseQuad.setMaterialHandler(materialHandler);
      } else {
        sceneObject.plane.material = sceneObject.plane.originalMaterial = materialHandler.getSingleLevelMaterial();
      }
    }

    this.surfaceChangeEvent.invoke();
  }
  /**
   * Gets the names of available surfaces.
   * @return A list of strings containing the names of available surfaces.
   * @api viewer3d.surface
   */
  ;

  _proto.getSurfaceNames = function getSurfaceNames() {
    return this.getSurfaceObjects().map(function (x) {
      return x.name;
    });
  }
  /**
   * Gets the names of the materials of a given surface, or common materials of several surfaces.
   * @param nameFilter Name, or list of names, of the surface(s) that the operation should be applied to. Leave null/undefined to apply to all.
   * @return A list of strings containing the names of available materials.
   * @api viewer3d.surface
   */
  ;

  _proto.getSurfaceMaterials = function getSurfaceMaterials(nameFilter) {
    var sceneObjects = this.getSurfaceObjects(nameFilter);
    var materialNameLists = sceneObjects.map(function (sceneObject) {
      return Object.keys(sceneObject.materialHandlers);
    });
    return lodash.intersection.apply(void 0, materialNameLists);
  }
  /**
   * Gets the configurable properties of the material with the given name.
   * @param name The name of the material whose properties are to be returned.
   * @param nameFilter Name, or list of names, of the surface(s) that the operation should be applied to. Leave null/undefined to apply to all.
   * @return A hashmap/object containing the configurable properties, such as name, type, title, minimum, maximum, etc., which are useful for creating a UI dynamically.
   * @api viewer3d.surface
   */
  ;

  _proto.getMaterialProperties = function getMaterialProperties(name, nameFilter) {
    var sceneObjects = this.getSurfaceObjects(nameFilter);
    return sceneObjects.map(function (sceneObject) {
      return sceneObject.materialHandlers[name];
    }).filter(function (x) {
      return !!x;
    }).map(function (x) {
      return x.getProperties();
    })[0];
  }
  /**
   * Gets UI-specific properties of the material with the given name. A subset of those returned by the getMaterialProperties
   * @param name The name of the material whose properties are to be returned.
   * @param nameFilter Name, or list of names, of the surface(s) that the operation should be applied to. Leave null/undefined to apply to all.
   * @return A hashmap/object containing the ui-specific properties (basically those with 'ui:' prefix). See the 'react-jsonschema-form' library for format examples.
   * @api viewer3d.surface
   */
  ;

  _proto.getMaterialUIDetails = function getMaterialUIDetails(name, nameFilter) {
    var sceneObjects = this.getSurfaceObjects(nameFilter);
    return sceneObjects.map(function (sceneObject) {
      return sceneObject.materialHandlers[name];
    }).filter(function (x) {
      return !!x;
    }).map(function (x) {
      return x.getUIDetails();
    })[0];
  }
  /**
   * Gets the currently set values of the properties of the material with the given name.
   * @param name The name of the material whose property values are to be returned.
   * @param nameFilter Name, or list of names, of the surface(s) that the operation should be applied to. Leave null/undefined to apply to all.
   * @return A hashmap/object matching the property names to their currently set values.
   * @api viewer3d.surface
   */
  ;

  _proto.getMaterialPropertyValues = function getMaterialPropertyValues(name, nameFilter) {
    var sceneObjects = this.getSurfaceObjects(nameFilter);
    return sceneObjects.map(function (sceneObject) {
      return sceneObject.materialHandlers[name];
    }).filter(function (x) {
      return !!x;
    }).map(function (x) {
      return x.getPropertyValues();
    })[0];
  }
  /**
   * Sets the values of the properties of the material with the given name.
   * @param name The name of the material whose property values are to be set.
   * @param nameFilter Name, or list of names, of the surface(s) that the operation should be applied to. Leave null/undefined to apply to all.
   * @param properties A hashmap/object matching the property names to values to be set.
   * @api viewer3d.surface
   */
  ;

  _proto.setMaterialPropertyValues = function setMaterialPropertyValues(name, properties, nameFilter) {
    var surfaceObjects = this.getSurfaceObjects(nameFilter);

    for (var _iterator3 = _createForOfIteratorHelperLoose(surfaceObjects), _step3; !(_step3 = _iterator3()).done;) {
      var surfaceObject = _step3.value;
      var materialHandler = surfaceObject.materialHandlers[name];

      if (materialHandler) {
        materialHandler.setPropertyValues(properties);
      }
    }

    this.surfaceChangeEvent.invoke();
  };

  _proto.onCanvasSizeUpdate = function onCanvasSizeUpdate(width, height) {
    this.horizontalResolution = width;
    this.verticalResolution = height;
  };

  _proto.setCameraLimits = function setCameraLimits() {
    /*const minDist = this.getDistance(this.tileWidth, this.tileHeight)
    const maxDist = this.getDistance(this.totalWidth, this.totalHeight)*/
    //TODO: Review how to set this
    //this.cameraManager.setObjectMinMaxDistance(minDist, maxDist)
  };

  _proto.getDistance = function getDistance(targetWidth, targetHeight) {
    var halfWidth = targetWidth / 2;
    var halfHeight = targetHeight / 2;
    var distanceX = halfWidth / Math.tan(MathHelper.toRadians(this.cameraManager.getHorizontalFov() / 2));
    var distanceY = halfHeight / Math.tan(MathHelper.toRadians(this.cameraManager.getVerticalFov() / 2));
    return Math.max(distanceX, distanceY);
  };

  _proto.onMaterialLoadStart = function onMaterialLoadStart(surfaceObject) {
    surfaceObject.toggleBackPlane(true);
    this.materialsLoading++;
    this.updateProgress();
  };

  _proto.onMaterialLoadFinish = function onMaterialLoadFinish(surfaceObject) {
    surfaceObject.toggleBackPlane(false);
    this.materialsLoading--;
    this.updateProgress();
  };

  _proto.updateProgress = function updateProgress() {
    if (this.materialsLoading > 0) {
      this.loadProgressEvent.invoke();
    } else {
      this.loadFinishEvent.invoke();
    }
  };

  _proto.onTextureLoaded = function onTextureLoaded() {
    this.surfaceChangeEvent.invoke();
  };

  _proto.processCameraView = function processCameraView(multiResolutionSurfaces) {
    var position = this.cameraManager.getCameraPosition();
    var distance = position.y; // this.setMinDistance();

    var halfWidth = Math.tan(MathHelper.toRadians(this.cameraManager.getHorizontalFov() / 2)) * distance;
    var halfHeight = Math.tan(MathHelper.toRadians(this.cameraManager.getVerticalFov() / 2)) * distance;
    var topX = position.z - halfWidth;
    var topY = position.x + halfHeight;
    var width = halfWidth * 2;
    var height = halfHeight * 2;
    var camDotsPerX = this.horizontalResolution / width;
    var camDotsPerY = this.verticalResolution / height; //this.addDebugRect(topX, topY, width, height);

    for (var _iterator4 = _createForOfIteratorHelperLoose(multiResolutionSurfaces), _step4; !(_step4 = _iterator4()).done;) {
      var multiResolutionSurface = _step4.value;
      multiResolutionSurface.baseQuad.process(topX, topY - multiResolutionSurface.totalHeight, width, height, camDotsPerX, camDotsPerY);
    }
  }
  /**
   * Draws a rectangle gizmo that indicates the current view. Used for debugging. To be removed.
   * @param x
   * @param y
   * @param width
   * @param height
   */
  ;

  _proto.addDebugRect = function addDebugRect(x, y, width, height) {
    var geometry = new THREE.PlaneGeometry(width, height);
    var edgesGeometry = new THREE.EdgesGeometry(geometry); // or WireframeGeometry

    var edgesMaterial = new THREE.LineBasicMaterial({
      color: 0x00ff00,
      linewidth: 2
    });
    var wireframe = new THREE.LineSegments(edgesGeometry, edgesMaterial);
    wireframe.position.set(x + width / 2, y - height / 2, 10);
    if (this.currentTestRect) this.group.remove(this.currentTestRect);
    this.currentTestRect = wireframe;
    this.group.add(this.currentTestRect);
  };

  _proto.calculateFrameDistance = function calculateFrameDistance(boundingBox) {
    var distanceX = (boundingBox.max.x - boundingBox.min.x) / 2 / Math.tan(MathHelper.toRadians(this.cameraManager.getHorizontalFov() / 2));
    var distanceY = (boundingBox.max.y - boundingBox.min.y) / 2 / Math.tan(MathHelper.toRadians(this.cameraManager.getVerticalFov() / 2)); // const size = Math.max(boundingBox.max.x - boundingBox.min.x, boundingBox.max.y - boundingBox.min.y) / 2;//(boundingBox.getCenter().sub(boundingBox.min)).length();
    // const distance = size / (Math.tan(MathHelper.toRadians((camera.fov) / 2)) * camera.aspect);

    return Math.max(distanceX, distanceY);
  }
  /**
   * Updates the tile composition for multiresolution images when the camera is moved.
   */
  ;

  _proto.onCameraChange = function onCameraChange() {
    var _this2 = this;

    var delayedTimeOutDuration = this.config.surface.loadingDelay;
    var multiResolutionSurfaces = this.getSurfaceObjects().filter(function (x) {
      return x.isMultiResolution;
    });

    if (multiResolutionSurfaces.length > 0) {
      // if a delay in execution has been requested
      if (delayedTimeOutDuration > 0) {
        // if there was already a planned execution of the processCameraView, reset it
        if (this.delayedQuadProcessTimeoutHandle) clearTimeout(this.delayedQuadProcessTimeoutHandle); // and create a new one planned execution

        this.delayedQuadProcessTimeoutHandle = setTimeout(function () {
          _this2.delayedQuadProcessTimeoutHandle = null;

          _this2.processCameraView(multiResolutionSurfaces);
        }, delayedTimeOutDuration);
      } else {
        this.processCameraView(multiResolutionSurfaces);
      }
    }
  };

  _proto.getProgressEvent = function getProgressEvent() {
    return this.loadProgressEvent;
  };

  _proto.getProgressFinishEvent = function getProgressFinishEvent() {
    return this.loadFinishEvent;
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.surfaceChangeEvent, this.loadProgressEvent, this.loadFinishEvent];
  };

  return SurfaceManager;
}();

var FlashlightManager = /*#__PURE__*/function () {
  function FlashlightManager(dataSourceManager, cameraManager, surfaceManager, extendedCameraManager) {
    this.lightChanged = new SharpEvent();
    this.config = dataSourceManager.config;
    this.sceneManager = dataSourceManager.sceneManager;
    this.dataSourceManager = dataSourceManager;
    this.surfaceManager = surfaceManager;
    this.cameraManager = cameraManager;
    this.extendedCameraManager = extendedCameraManager;
    this.dataSourceManager.onLoadFinishEvent.subscribe(this.onLoadFinished, this);
    this.cameraManager.cameraChangeEvent.subscribe(this.onCameraChange, this);
    this.mouse = new THREE.Vector2();
    this.distance = 100;
    this.propsUpdateEvent = new SharpEvent();
  }

  var _proto = FlashlightManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDiv) {
    this.rendererDiv = rendererDiv;
    this.setupInitialTargetAndPosition(this.config);
    this.directionalLight = new THREE.DirectionalLight(this.config.flashlight.color, this.config.flashlight.intensity);
    this.directionalLight.target = new THREE.Object3D();
    this.directionalLight.target.position.copy(this.currentTarget);
    this.directionalLight.position.copy(this.currentPosition);
    this.directionalLight.visible = this.config.flashlight.lightType === 'Directional' && this.config.flashlight.enabled;
    this.sceneManager.scene.add(this.directionalLight.target);
    this.sceneManager.scene.add(this.directionalLight);
    this.spotLight = new THREE.SpotLight(this.config.flashlight.color, this.config.flashlight.intensity);
    this.spotLight.penumbra = 0.1;
    this.spotLight.decay = 2;
    this.spotLight.target = new THREE.Object3D();
    this.spotLight.target.position.copy(this.currentTarget);
    this.spotLight.position.copy(this.currentPosition);
    this.spotLight.visible = this.config.flashlight.lightType === 'Spot' && this.config.flashlight.enabled;
    this.sceneManager.scene.add(this.spotLight.target);
    this.sceneManager.scene.add(this.spotLight);
    this.arrowHelper = new THREE.ArrowHelper(new THREE.Vector3(), new THREE.Vector3(-100, -100, 100), 1000, 0xff0000);
    this.arrowHelper.visible = this.config.flashlight.arrowHelper;
    this.sceneManager.scene.add(this.arrowHelper);
    this.updateLightDistance(this.config.flashlight.distance);
    this.applyLightTarget();
    this.applyLightPosition();
  };

  _proto.setupInitialTargetAndPosition = function setupInitialTargetAndPosition(config) {
    this.currentTarget = toVector3(config.flashlight.initialTarget);
    this.currentPosition = this.calculatePositionFromOrientation(this.currentTarget, this.config.flashlight.initialAngle, this.config.flashlight.initialRelativeDistance);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.spotLight.visible = nextConfig.flashlight.lightType === 'Spot' && nextConfig.flashlight.enabled;
    this.directionalLight.visible = nextConfig.flashlight.lightType === 'Directional' && nextConfig.flashlight.enabled;
    this.spotLight.color = new THREE.Color(nextConfig.flashlight.color);
    this.spotLight.intensity = nextConfig.flashlight.intensity;
    this.directionalLight.color = new THREE.Color(nextConfig.flashlight.color);
    this.directionalLight.intensity = nextConfig.flashlight.intensity;
    this.arrowHelper.visible = nextConfig.flashlight.arrowHelper;

    if (this.config.flashlight.distance !== nextConfig.flashlight.distance) {
      this.updateLightDistance(nextConfig.flashlight.distance);
    }

    if (!lodash.isEqual(this.config.flashlight.initialTarget, nextConfig.flashlight.initialTarget)) {
      this.setupInitialTargetAndPosition(this.config);
      this.applyLightTarget();
      this.applyLightPosition();
    }

    if (this.config.flashlight.initialAngle !== nextConfig.flashlight.initialAngle || this.config.flashlight.initialRelativeDistance !== nextConfig.flashlight.initialRelativeDistance) {
      this.setOrientation(nextConfig.flashlight.initialAngle, nextConfig.flashlight.initialRelativeDistance);
    }

    this.config = nextConfig;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.dataSourceManager.onLoadFinishEvent.unsubscribeAll(this);
    this.cameraManager.cameraChangeEvent.unsubscribeAll(this);
  };

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.FLASHLIGHT, {
      getPosition: this.getLightPosition,
      setPosition: this.setLightPosition,
      getTarget: this.getLightTarget,
      setTarget: this.setLightTarget,
      getState: this.getLightState,
      setState: this.setLightState,
      setOrientation: this.setOrientation,
      getOrientation: this.getOrientation
    }, this);
  }
  /**
   * Gets the light source position.
   * @alias getPosition
   * @returns {Vector3} The 3D coordinates of the camera position.
   * @api viewer3d.flashlight
   */
  ;

  _proto.getLightPosition = function getLightPosition() {
    return this.currentPosition;
  }
  /**
   * Gets the light target position.
   * @alias getTarget
   * @returns {Vector3} The 3D coordinates of the camera position.
   * @api viewer3d.flashlight
   */
  ;

  _proto.getLightTarget = function getLightTarget() {
    return this.currentTarget;
  }
  /**
   * Gets a hash that represents the current light position and orientation/target.
   * @returns {string} Base64 string (url-friendly) with the hash.
   * @api viewer3d.flashlight
   * @alias getState
   */
  ;

  _proto.getLightState = function getLightState() {
    var position = this.getLightPosition();
    var target = this.getLightTarget();
    var buf = Buffer.alloc(6 * 4); // 4 bytes for each value

    var valueList = [position.x, position.y, position.z, target.x, target.y, target.z];

    for (var i = 0; i < valueList.length; i++) {
      buf.writeFloatBE(valueList[i], i * 4);
    }

    var base64String = buf.toString('base64');
    return base64EncodeUrl(base64String);
  }
  /**
   * Sets the current light position and orientation/target from a hash.
   * @param state {string} Base64 string (url-friendly) with the hash.
   * @alias setState
   * @api viewer3d.flashlight
   */
  ;

  _proto.setLightState = function setLightState(state) {
    var base64State = base64DecodeUrl(state);
    var buf = Buffer.from(base64State, 'base64');
    var valueList = [];

    for (var i = 0; i < 6; i++) {
      valueList.push(buf.readFloatBE(i * 4));
    }

    this.setLightTarget(new THREE.Vector3(valueList[3], valueList[4], valueList[5]));
    this.setLightPosition(new THREE.Vector3(valueList[0], valueList[1], valueList[2]));
  }
  /**
   * Sets the light orientation, rotated around the set light target. Works according to the sin-cos unit circle.
   * @param angleDegrees Angle in degrees (0-360).
   * @param relativeDistance Relative distance (value between 0 and 1). The max distance is defined via props.
   * @api viewer3d.flashlight
   */
  ;

  _proto.setOrientation = function setOrientation(angleDegrees, relativeDistance) {
    var newPosition = this.calculatePositionFromOrientation(this.currentTarget, angleDegrees, relativeDistance);
    this.setLightPosition(newPosition);
  }
  /**
   * Gets the light orientation.
   * @returns {LightOrientation} The light orientation, rotated around the set light target. Works according to the sin-cos unit circle.
   * @api viewer3d.flashlight
   */
  ;

  _proto.getOrientation = function getOrientation() {
    var direction = this.currentPosition.clone().sub(this.currentTarget);
    var vectorSize = direction.length();
    var flatDirection = direction.setZ(0);
    var angleRadians = flatDirection.clone().angleTo(new THREE.Vector3(1, 0, 0));
    var xDirection = new THREE.Vector3(1, 0, 0);
    var zDirection = new THREE.Vector3(0, 0, 1);

    if (xDirection.cross(flatDirection).dot(zDirection) < 0) {
      angleRadians = 2 * Math.PI - angleRadians;
    }

    return {
      angleDegrees: MathHelper.toDegrees(angleRadians),
      relativeDistance: vectorSize / this.distance
    };
  };

  _proto.calculatePositionFromOrientation = function calculatePositionFromOrientation(target, angleDegrees, relativeDistance) {
    var angleRadians = MathHelper.toRadians(angleDegrees);
    var distance = this.distance * relativeDistance;
    var offsetX = Math.cos(angleRadians) * distance;
    var offsetY = Math.sin(angleRadians) * distance;
    return target.clone().add(new THREE.Vector3(offsetX, 0, offsetY));
  };

  _proto.onMouseMove = function onMouseMove(event) {
    if (this.config.flashlight.enabled && this.mouseDown) {
      this.performLightOrientationChange(event);
    }
  };

  _proto.onTouchMove = function onTouchMove(e) {
    if (this.config.flashlight.enabled && e.touches.length === 1) {
      this.performLightOrientationChange(e.touches[0]);
    }
  };

  _proto.onMouseDown = function onMouseDown(e) {
    this.mouseMoved = false;
    this.mouseDown = true;

    if (e.button === 0) {
      this.firstDragPosition = this.extendedCameraManager.getMouse3DCoordinates();
    }
  };

  _proto.onTouchStart = function onTouchStart(e) {
    this.mouseMoved = false;

    if (e.touches.length === 1) {
      this.firstDragPosition = this.extendedCameraManager.getMouse3DCoordinates();
    }
  };

  _proto.onMouseUp = function onMouseUp(e) {
    this.mouseDown = false;

    if (e.button === 0) {
      if (this.config.flashlight.enabled) {
        if (!this.mouseMoved) {
          this.changeLightPosition();
        } else {
          this.changeLightOrientation();
        }
      }

      this.firstDragPosition = null;
    }
  };

  _proto.onTouchEnd = function onTouchEnd() {
    if (!this.mouseMoved) {
      this.changeLightPosition();
    } else {
      this.changeLightOrientation();
    }

    this.firstDragPosition = null;
  };

  _proto.performLightOrientationChange = function performLightOrientationChange(event) {
    var clientRect = this.rendererDiv.getBoundingClientRect();
    var previousCoords = {
      x: this.mouse.x,
      y: this.mouse.y
    };
    this.mouse.x = (event.clientX - clientRect.left) / clientRect.width * 2 - 1;
    this.mouse.y = -((event.clientY - clientRect.top) / clientRect.height) * 2 + 1; // if indeed there was a mouse movement inside the canvas

    if (Math.abs(this.mouse.x - previousCoords.x) > 0 || Math.abs(this.mouse.y - previousCoords.y) > 0) {
      this.mouseMoved = true;
      var coordinates = this.extendedCameraManager.getMouse3DCoordinates();

      if (coordinates) {
        this.changeLightOrientation();
      }
    }
  };

  _proto.changeLightPosition = function changeLightPosition() {
    if (!this.config.flashlight.enableInteractivePosition) {
      return;
    }

    var newTarget = this.extendedCameraManager.getMouse3DCoordinates();

    if (newTarget) {
      var offsetX = newTarget.x - this.currentTarget.x;
      var offsetZ = newTarget.z - this.currentTarget.z;
      var newX = this.currentPosition.x + offsetX;
      var newZ = this.currentPosition.z + offsetZ;
      this.setLightTarget(new THREE.Vector3(newTarget.x, this.currentTarget.y, newTarget.z));
      this.setLightPosition(new THREE.Vector3(newX, this.currentPosition.y, newZ));
    }
  };

  _proto.changeLightOrientation = function changeLightOrientation() {
    if (!this.config.flashlight.enableInteractiveDirection) {
      return;
    }

    var dragStartPosition = this.firstDragPosition;
    var dragFinishPosition = this.extendedCameraManager.getMouse3DCoordinates();

    if (dragStartPosition && dragFinishPosition) {
      this.setLightTarget(new THREE.Vector3(dragStartPosition.x, this.currentTarget.y, dragStartPosition.z));
      this.setLightPosition(new THREE.Vector3(dragFinishPosition.x, this.currentPosition.y, dragFinishPosition.z));
    }
  }
  /**
   * Sets the light source position.
   * @param position The 3D coordinates of the light position.
   * @alias setPosition
   * @api viewer35d.flashlight
   */
  ;

  _proto.setLightPosition = function setLightPosition(position) {
    // allow simple x,y,z objects, too
    position = toVector3(position);
    this.currentPosition = position;
    this.applyLightPosition();
  };

  _proto.applyLightPosition = function applyLightPosition() {
    // in order to perform a light orientation change based on distance
    // we use the distance configuration
    var vectorSize = this.currentPosition.clone().sub(this.currentTarget).length();
    var minSize = Math.min(this.distance, vectorSize);
    var newY = Math.sqrt(this.distance * this.distance - minSize * minSize);
    newY = Math.max(newY, 5);
    var newPosition = new THREE.Vector3(this.currentPosition.x, newY, this.currentPosition.z);
    this.directionalLight.position.copy(newPosition);
    this.spotLight.position.copy(newPosition);
    this.updateArrowHelper();
    this.config.flashlight.onLightChange();
    this.lightChanged.invoke();
  }
  /**
   * Sets the light target location.
   * @param target The 3D coordinates of the new target.
   * @api viewer3d.flashlight
   * @alias setTarget
   */
  ;

  _proto.setLightTarget = function setLightTarget(target) {
    // allow simple x,y,z objects, too
    target = toVector3(target);
    this.currentTarget = target;
    this.applyLightTarget();
  };

  _proto.applyLightTarget = function applyLightTarget() {
    this.directionalLight.target.position.copy(this.currentTarget);
    this.spotLight.target.position.copy(this.currentTarget);
    this.updateArrowHelper();
    this.config.flashlight.onLightChange();
    this.lightChanged.invoke();
  };

  _proto.updateArrowHelper = function updateArrowHelper() {
    var lightPosition = this.currentPosition.clone();
    lightPosition.y = 10;
    var lightTarget = this.currentTarget.clone();
    lightTarget.y = 10;
    var lightDirection = lightTarget.clone().sub(lightPosition);
    var lightDirectionSize = 1;

    if (lightDirection.lengthSq() > 0) {
      lightDirectionSize = lightDirection.length();
      lightDirection.normalize();
    }

    this.arrowHelper.position.copy(lightPosition);
    this.arrowHelper.setDirection(lightDirection);
    this.arrowHelper.setLength(lightDirectionSize);
  };

  _proto.onLoadFinished = function onLoadFinished() {
    this.updateLightDistance(this.config.flashlight.distance);
  };

  _proto.updateLightDistance = function updateLightDistance(newDistance) {
    var previousDistance = this.distance;

    switch (newDistance) {
      case 'auto':
        {
          var _this$dataSourceManag, _this$dataSourceManag2;

          var defaultSize = new THREE.Vector3(10, 0, 10);
          var boundingBox = (_this$dataSourceManag = (_this$dataSourceManag2 = this.dataSourceManager.allBoundingBox) == null ? void 0 : _this$dataSourceManag2.getSize(defaultSize)) != null ? _this$dataSourceManag : defaultSize;
          this.distance = Math.min(boundingBox.z, boundingBox.x) / 2;
          break;
        }

      case 'dynamic':
        this.distance = this.calculateDynamicDistance();
        break;

      default:
        this.distance = newDistance;
        break;
    }

    this.scalePositionFromTarget(this.distance / previousDistance);
    this.setupInitialTargetAndPosition(this.config);
    this.applyLightTarget();
    this.applyLightPosition();
  };

  _proto.scalePositionFromTarget = function scalePositionFromTarget(amount) {
    var direction = this.currentPosition.clone().sub(this.currentTarget).multiplyScalar(amount);
    this.currentPosition = this.currentTarget.clone().add(direction);
    this.setLightPosition(this.currentPosition);
  };

  _proto.onCameraChange = function onCameraChange() {
    if (this.config.flashlight.distance !== 'dynamic') {
      return;
    }

    this.distance = this.calculateDynamicDistance();
  };

  _proto.calculateDynamicDistance = function calculateDynamicDistance() {
    var position = this.cameraManager.getCameraPosition();
    var distance = position.y;
    var halfWidth = Math.tan(MathHelper.toRadians(this.cameraManager.getHorizontalFov() / 2)) * distance;
    var halfHeight = Math.tan(MathHelper.toRadians(this.cameraManager.getVerticalFov() / 2)) * distance;
    return Math.min(halfWidth, halfHeight);
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.lightChanged];
  };

  return FlashlightManager;
}();

var SceneOptionsManager = /*#__PURE__*/function () {
  function SceneOptionsManager(dataSourceManager, managers) {
    this.config = dataSourceManager.config;
    this.previousConfig = this.config;
    this.currentSceneConfig = {};
    this.dataSourceManager = dataSourceManager;
    this.managers = managers;
    this.dataSourceManager.onSceneChanged.subscribe(this.onSceneChanged, this);
  }

  var _proto = SceneOptionsManager.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
    this.refreshComponentOptions();
  };

  _proto.onSceneChanged = function onSceneChanged(scene) {
    this.currentSceneConfig = scene.options || {};
    this.refreshComponentOptions();
  };

  _proto.refreshComponentOptions = function refreshComponentOptions() {
    var nextConfig = lodash.merge({}, this.config, this.currentSceneConfig); // skip the rest of the verifications if nothing changed

    if (lodash.isEqual(this.previousConfig, nextConfig)) return;

    for (var _iterator = _createForOfIteratorHelperLoose(this.managers.filter(function (x) {
      return x.componentWillReceiveProps;
    })), _step; !(_step = _iterator()).done;) {
      var manager = _step.value;
      manager.componentWillReceiveProps(nextConfig);
    }

    this.previousConfig = nextConfig;
  };

  return SceneOptionsManager;
}();

var ProgressManager = /*#__PURE__*/function () {
  function ProgressManager(config, viewerManagers) {
    var _this = this;

    this.onProgressEvent = new SharpEvent();
    this.onProgressFinishEvent = new SharpEvent();
    this.progressEvents = viewerManagers.filter(function (x) {
      return x.getProgressEvent;
    }).map(function (x) {
      return x.getProgressEvent();
    });

    for (var _iterator = _createForOfIteratorHelperLoose(this.progressEvents), _step; !(_step = _iterator()).done;) {
      var progressEvent = _step.value;
      progressEvent.subscribe(function () {
        var _this$onProgressEvent, _config$renderer;

        var args = [].slice.call(arguments);

        (_this$onProgressEvent = _this.onProgressEvent).invoke.apply(_this$onProgressEvent, args);

        (_config$renderer = config.renderer).onProgress.apply(_config$renderer, args);
      }, this);
    }

    this.progressFinishEvents = viewerManagers.filter(function (x) {
      return x.getProgressFinishEvent;
    }).map(function (x) {
      return x.getProgressFinishEvent();
    });

    for (var _iterator2 = _createForOfIteratorHelperLoose(this.progressFinishEvents), _step2; !(_step2 = _iterator2()).done;) {
      var progressFinishEvent = _step2.value;
      progressFinishEvent.subscribe(function () {
        var _this$onProgressFinis;

        (_this$onProgressFinis = _this.onProgressFinishEvent).invoke.apply(_this$onProgressFinis, [].slice.call(arguments));

        config.renderer.onProgressFinished();
      }, this);
    }
  }

  var _proto = ProgressManager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    for (var _iterator3 = _createForOfIteratorHelperLoose(this.progressEvents), _step3; !(_step3 = _iterator3()).done;) {
      var progressEvent = _step3.value;
      progressEvent.unsubscribeAll(this);
    }

    for (var _iterator4 = _createForOfIteratorHelperLoose(this.progressFinishEvents), _step4; !(_step4 = _iterator4()).done;) {
      var progressFinishEvent = _step4.value;
      progressFinishEvent.unsubscribeAll(this);
    }
  };

  return ProgressManager;
}();

var RenderTriggerManager = /*#__PURE__*/function () {
  function RenderTriggerManager(renderManager, viewerManagers) {
    var _this = this;

    this.renderManager = renderManager;
    this.renderTriggerEvents = viewerManagers.filter(function (x) {
      return x.getRenderEvents;
    }).flatMap(function (x) {
      return x.getRenderEvents();
    });

    for (var _iterator = _createForOfIteratorHelperLoose(this.renderTriggerEvents), _step; !(_step = _iterator()).done;) {
      var renderTriggerEvent = _step.value;
      renderTriggerEvent.subscribe(function () {
        return _this.renderManager.updateShouldRenderer(true);
      }, this);
    }
  }

  var _proto = RenderTriggerManager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    for (var _iterator2 = _createForOfIteratorHelperLoose(this.renderTriggerEvents), _step2; !(_step2 = _iterator2()).done;) {
      var renderTriggerEvent = _step2.value;
      renderTriggerEvent.unsubscribeAll(this);
    }
  };

  return RenderTriggerManager;
}();

var InternalStateManager = /*#__PURE__*/function () {
  function InternalStateManager(config) {
    this.onLoadConfigs = new SharpEvent();
    this.config = config;
  }

  var _proto = InternalStateManager.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.config = nextConfig;
  };

  _proto.loadConfiguration = function loadConfiguration(name, options) {
    var newConfig = lodash.cloneDeep(this.config);

    if (!!name && !lodash.has(newConfig, name)) {
      console.error('There is no configuration field called "' + name + '".');
      return;
    }

    this.recursiveSetObjectField(newConfig, name, options);
    this.onLoadConfigs.invoke(newConfig);
  };

  _proto.recursiveSetObjectField = function recursiveSetObjectField(newConfig, name, options) {
    if (options instanceof Object) {
      for (var _i = 0, _Object$keys = Object.keys(options); _i < _Object$keys.length; _i++) {
        var propertyKey = _Object$keys[_i];
        this.recursiveSetObjectField(newConfig, name ? name + "." + propertyKey : propertyKey, options[propertyKey]);
      }
    } else if (!lodash.has(newConfig, name)) {
      console.error('There is no matching configuration field called "' + name + '".');
      return;
    } else {
      lodash.set(newConfig, name, options);
    }
  };

  _proto.getConfiguration = function getConfiguration(path) {
    return path ? lodash.get(this.config, path) : lodash.cloneDeep(this.config);
  };

  return InternalStateManager;
}();

var NavigationManager = /*#__PURE__*/function () {
  function NavigationManager(cameraManager, tweenManager, internalStateManager) {
    this.cameraManager = cameraManager;
    this.tweenManager = tweenManager;
    this.internalStateManager = internalStateManager;
  }

  var _proto = NavigationManager.prototype;

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.CAMERA, {
      animatePath: this.animatePath,
      animateStatePath: this.animateStatePath
    }, this);
  }
  /**
   * Animates the camera along a given set of position/target points.
   * @param pathKeys A list of objects containing information about the source, target and, optionally, duration and effect types.
   * @param jumpToStart If true, the camera will jump immediately to the first path key, otherwise it will animate from the current position.
   * @param animationOptions The animation options to control duration, effect style, and callbacks.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.camera
   */
  ;

  _proto.animatePath = function animatePath(pathKeys, jumpToStart, animationOptions) {
    var _this = this;

    if (this.previousAnimation) this.tweenManager.cancel(this.previousAnimation);

    if (jumpToStart) {
      pathKeys = [].concat(pathKeys);
      pathKeys[0].duration = 0;
    }

    var animationSetup = this.createAnimationWithoutLimits(animationOptions);
    var animationCallbacks = pathKeys.map(function (x, index) {
      return function (opts) {
        var _pathKeys$index$durat, _pathKeys$index$type;

        return _this.cameraManager.setCameraPositionAndTarget(x.position, x.target, Object.assign({}, opts, {
          duration: (_pathKeys$index$durat = pathKeys[index].duration) != null ? _pathKeys$index$durat : animationOptions.duration,
          type: (_pathKeys$index$type = pathKeys[index].type) != null ? _pathKeys$index$type : animationOptions.type
        }));
      };
    });
    return this.previousAnimation = this.tweenManager.registerAnimationsAsSequence(animationCallbacks, animationSetup);
  }
  /**
   * Animates the camera along a given set of camera states.
   * @param states A list of camera states.
   * @param jumpToStart If true, the camera will jump immediately to the first state, otherwise it will animate from the current position.
   * @param animation The animation options to control duration, effect style, and callbacks.
   * @api viewer3d.camera
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   */
  ;

  _proto.animateStatePath = function animateStatePath(states, jumpToStart, animation) {
    var _this2 = this;

    if (this.previousAnimation) this.tweenManager.cancel(this.previousAnimation);
    var animationSetup = this.createAnimationWithoutLimits(animation);
    var animationCallbacks = states.map(function (x, index) {
      return function (opts) {
        return _this2.cameraManager.setCameraState(x, Object.assign({}, opts, {
          duration: jumpToStart && index == 0 ? 0 : animation.duration
        }));
      };
    });
    return this.previousAnimation = this.tweenManager.registerAnimationsAsSequence(animationCallbacks, animationSetup);
  };

  _proto.createAnimationWithoutLimits = function createAnimationWithoutLimits(animationOptions) {
    var _this3 = this;

    var originalValues = this.disableCameraLimits();
    return Object.assign({}, animationOptions, {
      onStop: function onStop() {
        _this3.restoreCameraLimits(originalValues);

        if (animationOptions.onStop) animationOptions.onStop();
      },
      onFinish: function onFinish() {
        _this3.restoreCameraLimits(originalValues);

        if (animationOptions.onFinish) animationOptions.onFinish();
      }
    });
  };

  _proto.disableCameraLimits = function disableCameraLimits() {
    var propsToChangeTo = {
      'camera.enableRotate': false,
      'camera.enableZoom': false,
      'camera.enablePan': false,
      'camera.minDistance': 0,
      'camera.maxDistance': Infinity,
      'camera.selectionFraming': false,
      'camera.minPolarAngle': -180,
      'camera.maxPolarAngle': 180
    };
    var originalValues = {};

    for (var _i = 0, _Object$entries = Object.entries(propsToChangeTo); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
      originalValues[key] = this.internalStateManager.getConfiguration(key);
      this.internalStateManager.loadConfiguration(key, value);
    }

    return originalValues;
  };

  _proto.restoreCameraLimits = function restoreCameraLimits(originalValues) {
    for (var _i2 = 0, _Object$entries2 = Object.entries(originalValues); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _Object$entries2[_i2],
          key = _Object$entries2$_i[0],
          value = _Object$entries2$_i[1];
      this.internalStateManager.loadConfiguration(key, value);
    }
  };

  return NavigationManager;
}();

var RenderEffectsManager = /*#__PURE__*/function () {
  function RenderEffectsManager(renderManager, tweenManager, internalStateManager) {
    this.renderManager = renderManager;
    this.tweenManager = tweenManager;
    this.internalStateManager = internalStateManager;
  }

  var _proto = RenderEffectsManager.prototype;

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.CAMERA, {
      flashScreen: this.flashScreen
    }, this);
  }
  /**
   * Performs a screen effect animation, showing a white screen instantly and fading out from there.
   * @param animationOptions The animation options to control duration, effect style, and callbacks.
   * @returns The animation id, which can be used for pausing, resuming and stopping the animation.
   * @api viewer3d.camera
   */
  ;

  _proto.flashScreen = function flashScreen(animationOptions) {
    var _this = this;

    this.internalStateManager.loadConfiguration('renderer.brightness', 1);
    return this.tweenManager.register(animate1to0(function (val) {
      return _this.internalStateManager.loadConfiguration('renderer.brightness', val);
    }, animationOptions));
  };

  return RenderEffectsManager;
}();

var _default = /*#__PURE__*/function () {
  function _default(config, cameraManager) {
    this.config = config;
    this.cameraManager = cameraManager;
  }

  var _proto = _default.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDivRef) {
    this.rendererDivRef = rendererDivRef;
    this.updateMouseWheelEvent(false, this.config.camera.scrollZoomToCursor && this.config.camera.enableZoom && this.config.renderer.enabled);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextConfig) {
    this.updateMouseWheelEvent(this.config.camera.scrollZoomToCursor && this.config.camera.enableZoom && this.config.renderer.enabled, nextConfig.camera.scrollZoomToCursor && nextConfig.camera.enableZoom && nextConfig.renderer.enabled);
    this.config = nextConfig;
  };

  _proto.updateMouseWheelEvent = function updateMouseWheelEvent(previousState, currentState) {
    if (previousState === currentState) return;

    if (previousState && !currentState) {
      this.rendererDivRef.removeEventListener('wheel', this.onMouseWheelFunction, false);
      this.rendererDivRef.removeEventListener('touchmove', this.onTouchMove.bind(this), false);
    } else {
      this.onMouseWheelFunction = this.onMouseWheel.bind(this);
      this.rendererDivRef.addEventListener('wheel', this.onMouseWheelFunction, false);
      this.rendererDivRef.addEventListener('touchmove', this.onTouchMove.bind(this), false);
    }
  };

  _proto.onMouseWheel = function onMouseWheel(e) {
    var baseWheelZoomSpeed = 0.5;
    var multiplier = e.wheelDelta * baseWheelZoomSpeed * this.config.camera.zoomSpeed;
    this.targetedZoom(e.offsetX, e.offsetY, multiplier);
  };

  _proto.targetedZoom = function targetedZoom(offsetX, offsetY, multiplier) {
    //console.log('multiplier is',multiplier)
    var rendererDivRect = this.rendererDivRef.getBoundingClientRect(); // we have to convert the coordinates in canvas space [0,1] to screen space [-1,1], hence the calculation

    var screenX = (offsetX / rendererDivRect.width - 0.5) * 2;
    var screenY = (1 - offsetY / rendererDivRect.height - 0.5) * 2;
    var farClipPosition = new THREE.Vector3(screenX, screenY, 1).unproject(this.cameraManager.camera);
    var zoomDirection = farClipPosition.clone().sub(this.cameraManager.camera.position).normalize();
    var newPosition = this.cameraManager.camera.position.clone().add(zoomDirection.clone().multiplyScalar(multiplier));
    var newTarget = this.cameraManager.controls.target.clone().add(zoomDirection.clone().multiplyScalar(multiplier));
    this.cameraManager.setCameraPosition(newPosition);
    this.cameraManager.setCameraTarget(newTarget);
    this.config.camera.onCameraZoom(this.cameraManager.api);
    this.config.camera.onCameraChange(this.cameraManager.api);
    this.cameraManager.cameraChangeEvent.invoke();
  } //invoked through explicit addEventListener call, not through the viewer events, since
  ;

  _proto.getFingerDistance = function getFingerDistance(e) {
    return Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
  };

  _proto.onTouchStart = function onTouchStart(e) {
    if (e.touches.length === 2) {
      this.pinching = true;
      this.previousDistance = this.getFingerDistance(e);
    }
  } //onTouchMove does not seem to work for those
  ;

  _proto.onTouchMove = function onTouchMove(e) {
    //console.log('Pinch moving for sure.', this.pinching)
    if (this.pinching) {
      var midPointX = e.touches[0].clientX + (e.touches[1].clientX - e.touches[0].clientX) / 2;
      var midPointY = e.touches[0].clientY + (e.touches[1].clientY - e.touches[0].clientY) / 2;
      var distance = this.getFingerDistance(e); //console.log('Pinch distance for zoom is: ', distance, e.touches)

      this.targetedZoom(midPointX, midPointY, distance - this.previousDistance);
    }
  };

  _proto.onTouchEnd = function onTouchEnd() {
    if (this.pinching) {
      this.pinching = false;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.updateMouseWheelEvent(this.config.camera.scrollZoomToCursor, false);
  };

  return _default;
}();

var SceneManager = function SceneManager() {
  this.scene = new THREE.Scene();
};

var TransformMode;

(function (TransformMode) {
  TransformMode["Absolute"] = "absolute";
  TransformMode["Relative"] = "relative";
})(TransformMode || (TransformMode = {})); // #endregion TransformMode


var ObjectTransformManager = /*#__PURE__*/function () {
  function ObjectTransformManager(dataSourceManager, tweenManager) {
    this.sceneObjectsChangedEvent = new SharpEvent();
    this.dataSourceManager = dataSourceManager;
    this.tweenManager = tweenManager;
  }

  var _proto = ObjectTransformManager.prototype;

  _proto.exposeAPI = function exposeAPI(apiRegistry) {
    apiRegistry.register(Viewer3DApi.TYPES.SCENE, {
      setObjectPosition: this.setObjectPosition,
      setObjectRotation: this.setObjectRotation,
      setObjectScale: this.setObjectScale,
      setObjectVisibility: this.setObjectVisibility
    }, this);
  }
  /**
   * Changes the position of objects that match the passed filter by an a certain amount or to a particular location.
   * @param vector Vector3 representing a target position or an offset, depending on the 'mode' parameter.
   * @param mode Controls if the the indicated vector indicates an absolute position to translate to, or a relative offset. Default is 'absolute'.
   * @param nameFilter Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @param [animation] If a value is set, the translation will be animated, otherwise the change will be performed instantly.
   * @returns The or list of animation ids, which can be used for pausing, resuming and stopping the animation(s).
   * @api viewer3d.scene
   */
  ;

  _proto.setObjectPosition = function setObjectPosition(vector, mode, nameFilter, animation) {
    var _this = this;

    return this.dataSourceManager.getSceneObjects(nameFilter).map(function (sceneObject) {
      var targetPosition = sceneObject.position.clone();
      if (mode === TransformMode.Relative) targetPosition.add(new THREE.Vector3(vector.x, vector.y, vector.z));else targetPosition.set(vector.x, vector.y, vector.z);
      return _this.tweenManager.register(animateVector(sceneObject.position, targetPosition, animation, function () {
        return _this.sceneObjectsChangedEvent.invoke();
      }));
    });
  }
  /**
   * Changes the rotation of objects that match the passed filter by an a certain amount or to a particular amount.
   * Rotation is performed around the centroid of the object, which is a standard for three.js objects.
   *
   * @param angles Euler angles (in degrees) representing a target rotation or an offset, depending on the 'mode' parameter.
   * @param mode Controls if the the indicated angles indicates an absolute orientation to rotate to, or a relative offset. Default is 'absolute'.
   * @param nameFilter Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @param [animation] If a value is set, the rotation will be animated, otherwise the change will be performed instantly.
   * @returns The or list of animation ids, which can be used for pausing, resuming and stopping the animation(s).
   * @api viewer3d.scene
   */
  ;

  _proto.setObjectRotation = function setObjectRotation(angles, mode, nameFilter, animation) {
    var _this2 = this;

    return this.dataSourceManager.getSceneObjects(nameFilter).map(function (sceneObject) {
      var xRadians = MathHelper.toRadians(angles.x);
      var yRadians = MathHelper.toRadians(angles.y);
      var zRadians = MathHelper.toRadians(angles.z);
      var targetRotation = sceneObject.rotation.clone();
      if (mode === TransformMode.Relative) targetRotation.set(sceneObject.rotation.x + xRadians, sceneObject.rotation.y + yRadians, sceneObject.rotation.z + zRadians);else targetRotation.set(xRadians, yRadians, zRadians);
      return _this2.tweenManager.register(animateEuler(sceneObject.rotation, targetRotation, animation, function () {
        return _this2.sceneObjectsChangedEvent.invoke();
      }));
    });
  }
  /**
   * Changes the scale of objects that match the passed filter by an a certain amount or to a particular location.
   * Scaling is performed around the centroid of the object, which is a standard for three.js objects.
   *
   * @param sizes Vector3 representing a target scale or an offset, depending on the 'mode' parameter.
   * @param mode Controls if the the indicated vector indicates an absolute size to scale to, or a relative offset. Default is 'absolute'.
   * @param nameFilter Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @param [animation] If a value is set, the scale will be animated, otherwise the change will be performed instantly.
   * @returns The or list of animation ids, which can be used for pausing, resuming and stopping the animation(s).
   * @api viewer3d.scene
   */
  ;

  _proto.setObjectScale = function setObjectScale(sizes, mode, nameFilter, animation) {
    var _this3 = this;

    return this.dataSourceManager.getSceneObjects(nameFilter).map(function (sceneObject) {
      var targetScale = sceneObject.scale.clone();
      if (mode === TransformMode.Relative) targetScale.multiply(new THREE.Vector3(sizes.x, sizes.y, sizes.z));else targetScale.set(sizes.x, sizes.y, sizes.z);
      return _this3.tweenManager.register(animateVector(sceneObject.scale, targetScale, animation, function () {
        return _this3.sceneObjectsChangedEvent.invoke();
      }));
    });
  }
  /**
   * Sets the visibility of the objects that match the passed filter.
   * @param visibility New visibility status that is to be assigned to the objects.
   * @param nameFilter  Name of the object (or list of names) that the operation should be applied to. Leave null/undefined to apply to all.
   * @api viewer3d.scene
   */
  ;

  _proto.setObjectVisibility = function setObjectVisibility(visibility, nameFilter) {
    var contentChanged = false;

    for (var _iterator = _createForOfIteratorHelperLoose(this.dataSourceManager.getSceneObjects(nameFilter)), _step; !(_step = _iterator()).done;) {
      var sceneObject = _step.value;
      contentChanged = contentChanged || sceneObject.visible !== visibility;
      sceneObject.visible = visibility;
    }

    if (contentChanged) this.sceneObjectsChangedEvent.invoke();
  };

  _proto.getRenderEvents = function getRenderEvents() {
    return [this.sceneObjectsChangedEvent];
  };

  return ObjectTransformManager;
}();

/**
 * Currently a test class to test drawing of 2D text renderers and lines with widths greater than 1.
 */

var TextLineManager = /*#__PURE__*/function () {
  function TextLineManager(sceneManager) {
    this.sceneManager = sceneManager; // For now this isn't doing anything, but can be turned into api functions.
    //this.createText("Hello World!")
    //this.createLine()
  }

  var _proto = TextLineManager.prototype;

  _proto.createText = function createText(text) {
    var canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 256;
    var context = canvas.getContext('2d');
    context.fillStyle = '#ffffff';
    context.font = 'Bold 20px Arial';
    context.fillText(text, 10, 50);
    var texture = new THREE.CanvasTexture(canvas);
    var material = new THREE.SpriteMaterial({
      map: texture
    });
    var sprite = new THREE.Sprite(material);
    sprite.name = "'" + text + "' Text";
    sprite.scale.set(100, 100, 1);
    this.sceneManager.scene.add(sprite);
  };

  _proto.createLine = function createLine() {
    var size = 200;
    var lineWidth = 0.5;
    var positions = [0, 0, 0, 0, size, 0, size, size * 2, 0];
    var material = new LineMaterial_js.LineMaterial({
      color: 0xff00,
      linewidth: 0.01 * lineWidth,
      depthTest: true
    });
    var geometry = new LineGeometry_js.LineGeometry();
    geometry.setPositions(positions);
    var outline = new Line2_js.Line2(geometry, material);
    outline.computeLineDistances();
    this.sceneManager.scene.add(outline);
  };

  return TextLineManager;
}();

var ServiceManager = /*#__PURE__*/function () {
  function ServiceManager(initialConfig) {
    this.config = initialConfig;
    var managers = {};
    managers.tween = new TweenManager();
    managers.scene = new SceneManager();
    managers.camera = new CameraManager(initialConfig, managers.tween);
    managers.cameraZoom = new _default(initialConfig, managers.camera);
    managers.render = new RenderManager(managers.scene, managers.camera);
    managers.dataSource = new DataSourceManager(managers.scene, managers.camera, managers.render);
    managers.fixedObjects = new _default$1(managers.scene, managers.camera);
    managers.node = new NodeManager(managers.camera, managers.dataSource);
    managers.skin = new SkinManager(managers.dataSource, managers.tween);
    managers.textLine = new TextLineManager(managers.scene);
    managers.markerManager = new MarkerManager(managers.dataSource, managers.camera, managers.node);
    managers.wireframeManager = new WireframeManager(managers.dataSource);
    managers.meshManager = new MeshManager$1(managers.dataSource);
    managers.animationManager = new AnimationManager(managers.dataSource, managers.tween);
    managers.planeClippingManager = new PlaneClippingManager(managers.render, managers.dataSource, managers.node);
    managers.nodeFrame = new NodeFrameManager(managers.camera, managers.dataSource, managers.node);
    managers.nodeSelection = new NodeSelectionManager(managers.camera, managers.dataSource, managers.node, managers.nodeFrame);
    managers.nodeStatusManager = new NodeStatusManager(managers.camera, managers.node);
    managers.isolation = new IsolationManager(managers.dataSource, managers.nodeSelection);
    managers.pickingBox = new PickingBoxManager(managers.dataSource, managers.node);
    managers.report = new ReportManager(managers.dataSource);
    managers.extendedCamera = new ExtendedCameraManager(managers.camera, managers.render, managers.dataSource, managers.nodeSelection);
    managers.instanced = new InstancedMeshManager(managers.dataSource);
    managers.shadow = new MeshManager(managers.dataSource, managers.render);
    managers.minimap = new MinimapManager(managers.render, managers.dataSource, managers.camera, managers.scene);
    managers.surface = new SurfaceManager(managers.camera, managers.dataSource);
    managers.flashlight = new FlashlightManager(managers.dataSource, managers.camera, managers.surface, managers.extendedCamera);
    managers.internalState = new InternalStateManager(initialConfig);
    managers.progress = new ProgressManager(initialConfig, Object.values(managers));
    managers.objectManipulation = new ObjectTransformManager(managers.dataSource, managers.tween);
    managers.renderTrigger = new RenderTriggerManager(managers.render, Object.values(managers));
    managers.sceneOptions = new SceneOptionsManager(managers.dataSource, Object.values(managers));
    managers.navigation = new NavigationManager(managers.camera, managers.tween, managers.internalState);
    managers.renderEffects = new RenderEffectsManager(managers.render, managers.tween, managers.internalState);
    this.dataSourceManager = managers.dataSource;
    this.renderManager = managers.render;
    this.progressManager = managers.progress;
    this.renderTriggerManager = managers.renderTrigger;
    this.internalStateManager = managers.internalState;
    this.api = new Viewer3DApi(Object.values(managers), managers.internalState);
    this.viewerManagers = Object.values(managers);
  }

  var _proto = ServiceManager.prototype;

  _proto.componentDidMount = function componentDidMount(rendererDivRef) {
    // relay to all managers
    for (var _iterator = _createForOfIteratorHelperLoose(this.viewerManagers), _step; !(_step = _iterator()).done;) {
      var viewerManager = _step.value;

      if (viewerManager.componentDidMount) {
        viewerManager.componentDidMount(rendererDivRef);
      }
    }
  };

  _proto.updateConfigs = function updateConfigs(nextConfig) {
    // relay to all managers
    for (var _iterator2 = _createForOfIteratorHelperLoose(this.viewerManagers.filter(function (x) {
      return x.componentWillReceiveProps;
    })), _step2; !(_step2 = _iterator2()).done;) {
      var viewerManager = _step2.value;
      viewerManager.componentWillReceiveProps(nextConfig);
    }

    this.config = nextConfig;
  };

  _proto.update = function update() {
    for (var _iterator3 = _createForOfIteratorHelperLoose(this.viewerManagers.filter(function (x) {
      return x.update;
    })), _step3; !(_step3 = _iterator3()).done;) {
      var viewerManager = _step3.value;
      this.renderManager.updateShouldRenderer(viewerManager.update());
    }

    this.renderManager.render();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // relay to all managers
    for (var _iterator4 = _createForOfIteratorHelperLoose(this.viewerManagers.filter(function (x) {
      return x.componentWillUnmount;
    })), _step4; !(_step4 = _iterator4()).done;) {
      var viewerManager = _step4.value;
      viewerManager.componentWillUnmount();
    }

    this.viewerManagers = [];
  };

  _proto.onMouseEvent = function onMouseEvent(e, mouseEventName) {
    // relay to all managers. eventName can be onMouseMove, onMouseDown, onMouseDoubleClick, onMouseUp
    for (var _iterator5 = _createForOfIteratorHelperLoose(this.viewerManagers.filter(function (x) {
      return x[mouseEventName];
    })), _step5; !(_step5 = _iterator5()).done;) {
      var viewerManager = _step5.value;
      viewerManager[mouseEventName](e);
    }
  };

  return ServiceManager;
}();

/**
 * The Viewer3D Component is a react-based UI control for viewing, navigating and interacting with hierarchical
 * 3D models on the Web. These models can be located on a local or remote server, organized into a tree of nodes,
 * whereas each can contain several meshes.
 */

var Viewer3D = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Viewer3D, _React$Component);

  function Viewer3D(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // eslint-disable-next-line no-undef

    _this.rendererDivRef = /*#__PURE__*/react.createRef();
    _this.mounted = true;
    var config = lodash.merge({}, Viewer3DDefaults, _this.props);
    _this.serviceManager = new ServiceManager(config);

    _this.serviceManager.internalStateManager.onLoadConfigs.subscribe(_this.updateConfigs, _assertThisInitialized(_this));

    _this.config = config;
    return _this;
  }

  var _proto = Viewer3D.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.serviceManager.componentDidMount(this.rendererDivRef.current);
    this.requestedAnimationFrame = window.requestAnimationFrame(function () {
      return _this2.animate();
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextConfig = lodash.merge({}, Viewer3DDefaults, this.props);

    if (lodash.isEqual(this.props, prevProps)) {
      return;
    }

    this.updateConfigs(nextConfig);
  };

  _proto.updateConfigs = function updateConfigs(nextConfig) {
    var _this3 = this;

    if (lodash.isEqual(this.config, nextConfig)) {
      return;
    }

    this.serviceManager.updateConfigs(nextConfig);

    if (nextConfig.renderer.enabled && !this.config.renderer.enabled) {
      this.requestedAnimationFrame = window.requestAnimationFrame(function () {
        return _this3.animate();
      });
    }

    this.config = nextConfig; //update the render function

    this.setState({});
  };

  _proto.animate = function animate() {
    var _this4 = this;

    if (this.config.renderer.enabled && this.mounted) {
      this.serviceManager.update();
      this.requestedAnimationFrame = window.requestAnimationFrame(function () {
        return _this4.animate();
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
    window.cancelAnimationFrame(this.requestedAnimationFrame);
    this.serviceManager.internalStateManager.onLoadConfigs.unsubscribeAll(this);
    this.serviceManager.componentWillUnmount();
    this.serviceManager = null;
    this.config.renderer.onUnload();
  };

  _proto.onMouseEvent = function onMouseEvent(e, mouseEventName) {
    if (!this.config.renderer.enabled) {
      return;
    }

    this.serviceManager.onMouseEvent(e, mouseEventName);
  };

  _proto.render = function render() {
    var _this5 = this;

    var secondStyle = {
      position: 'relative',
      height: 'auto',
      outline: 0,
      width: undefined
    };
    if (this.config.renderer.width) secondStyle.width = this.config.renderer.width;
    return /*#__PURE__*/react.createElement("div", {
      className: 'viewer3d',
      ref: this.rendererDivRef,
      style: Object.assign({}, this.config.style, secondStyle),
      onPointerMove: function onPointerMove(e) {
        return _this5.onMouseEvent(e, 'onMouseMove');
      },
      onPointerDown: function onPointerDown(e) {
        return _this5.onMouseEvent(e, 'onMouseDown');
      },
      onDoubleClick: function onDoubleClick(e) {
        return _this5.onMouseEvent(e, 'onMouseDoubleClick');
      },
      onPointerUp: function onPointerUp(e) {
        return _this5.onMouseEvent(e, 'onMouseUp');
      },
      onTouchStart: function onTouchStart(e) {
        return _this5.onMouseEvent(e, 'onTouchStart');
      },
      onTouchEnd: function onTouchEnd(e) {
        return _this5.onMouseEvent(e, 'onTouchEnd');
      }
    }, /*#__PURE__*/react.createElement(CanvasResizeWatcher, {
      viewerManagers: this.serviceManager.viewerManagers,
      renderManager: this.serviceManager.renderManager,
      config: this.config
    }), /*#__PURE__*/react.createElement(ProgressCircle, {
      showProgress: this.config.renderer.showProgress,
      progressColor: this.config.renderer.progressColor,
      progressManager: this.serviceManager.progressManager
    }));
  };

  _proto.getAPI = function getAPI() {
    return this.serviceManager.api;
  };

  return Viewer3D;
}(react.Component);

var Viewer25DDefaults = lodash.merge({}, Viewer3DDefaults, // #region Defaults
{
  camera: {
    initialPosition: {
      x: -0.1,
      y: 100,
      z: 0
    },
    initialTarget: {
      x: 0,
      y: 0,
      z: 0
    },
    far: 'auto',
    enableRotate: false,
    minDistance: 0,
    maxDistance: 'auto',
    scrollZoomToCursor: false,
    loadFramingDuration: 0
  },
  light: {
    intensity: 1
  },
  minimap: {
    enabled: true,
    showCameraView: true
  },
  flashlight: {
    enabled: true,
    arrowHelper: true
  }
} // #endregion Defaults
);
function Viewer25D(props) {
  return /*#__PURE__*/react.createElement(Viewer3D, Object.assign({}, lodash.merge({}, Viewer25DDefaults, props)));
}

exports.Viewer25D = Viewer25D;
exports.Viewer25DDefaults = Viewer25DDefaults;
exports.Viewer3D = Viewer3D;
exports.Viewer3DApi = Viewer3DApi;
exports.Viewer3DDefaults = Viewer3DDefaults;
//# sourceMappingURL=index.js.map
